import React from 'react';

const Decor1: React.FC = () => {
  return (
    <g
      className="prefix__map-decor-1 prefix__map-decor"
      transform="translate(40 120)"
    >
      <g transform="translate(0 -15)">
        <ellipse cx="365.17" cy="308.85" rx="48" ry="12.5" fill="#54ba02" />
        <path
          d="M365.17,296.35c-23.14,0-42.46,4.27-47,9.95,8.19-3.84,23.92-6.45,42-6.45,26.51,0,48,5.6,48,12.5a4.14,4.14,0,0,1-1,2.56c3.82-1.8,6-3.86,6-6.06C413.17,302,391.68,296.35,365.17,296.35Z"
          fill="#4fb002"
        />
      </g>
      <g>
        <ellipse
          cx="869.53"
          cy="196.49"
          rx="12.5"
          ry="48"
          transform="translate(470.22 993.5) rotate(-76.12)"
          fill="#54ba02"
        />
        <path
          d="M872.53,184.35c-22.48-5.55-42.25-6-48-1.62,8.87-1.76,24.77-.51,42.31,3.82,25.74,6.36,45.26,16.95,43.6,23.65a4.1,4.1,0,0,1-1.59,2.24c4.14-.83,6.76-2.31,7.29-4.44C917.78,201.3,898.26,190.71,872.53,184.35Z"
          fill="#4fb002"
        />
      </g>
      <g>
        <ellipse cx="1271.25" cy="416.15" rx="48" ry="12.5" fill="#54ba02" />
        <path
          d="M1271.25,403.65c-23.15,0-42.46,4.27-47,10,8.19-3.85,23.92-6.45,42-6.45,26.51,0,48,5.6,48,12.5a4.1,4.1,0,0,1-1,2.56c3.83-1.8,6-3.86,6-6.06C1319.25,409.25,1297.76,403.65,1271.25,403.65Z"
          fill="#4fb002"
        />
      </g>
      <g>
        <ellipse cx="92.97" cy="294.21" rx="12.52" ry="5.48" fill="#72a139" />
        <path
          d="M84.29,241.8c-.2,3.66.38,12.16-2.13,17.38s-6.37,7.72-3.67,14.67,2.51,16.42,1.93,18.54-.77,2.9-.77,2.9a2.59,2.59,0,0,0,2.7,1.06c1.94-.29,3-2.9,3.09-4.34s1.07-8.4-.29-15.26a60.13,60.13,0,0,1-1.54-13c-.1-4.24,1.83-6.75,2.41-9.94S87.09,242,87.09,242s6.47.77,7.24-.1c.77-1.93.48-8.5-7.73-8.11s-9.94,6-9.56,7.53S84.29,241.8,84.29,241.8Z"
          fill="#c53964"
        />
        <path
          d="M87.09,242s6.47.77,7.24-.1c.77-1.93.48-8.5-7.73-8.11s-9.94,6-9.56,7.53,7.25.49,7.25.49a1.09,1.09,0,0,0,0,.18,12.08,12.08,0,0,1,1.36.1c.42.07.9.14,1.43.2C87.08,242.1,87.09,242,87.09,242Z"
          fill="#c53964"
        />
        <path
          d="M84.29,241.8c.48-.29,2.8.19,2.8.19s-.58,10.72-1.16,12.45C85.06,243.34,84.29,241.8,84.29,241.8Z"
          fill="#a03964"
        />
        <path
          d="M83.13,299.54c0,1.93,1.93,2.8,4.15,3.09s6-.29,6.18-1.74,0-26.55-.58-27.81c1.74-.39,6.08-1.83,5.79-4.83s-2.12-7.14-8.2-7.72S80,262.94,80.62,266.9s6.18,6.28,6.18,6.28a59.46,59.46,0,0,1,.87,9.94C87.76,289.3,83.13,299.54,83.13,299.54Z"
          fill="#9a7ce3"
        />
        <path
          d="M85.15,233.78c-1.81.3-4.82,1.35-5.69,2.8s3.18,2.7,6.27,2.42,7.25.67,7.54-1.16-.39-2.9-2.42-3.58A11.85,11.85,0,0,0,85.15,233.78Z"
          fill="#c9679b"
        />
        <ellipse cx="81.97" cy="238.64" rx="1.93" ry="0.97" fill="#dfd5b0" />
        <ellipse cx="84.09" cy="237.06" rx="0.92" ry="0.46" fill="#dfd5b0" />
        <ellipse cx="81" cy="236.77" rx="1.25" ry="0.63" fill="#dfd5b0" />
        <ellipse cx="89.82" cy="239.32" rx="1.77" ry="0.88" fill="#dfd5b0" />
        <ellipse cx="92.02" cy="237.76" rx="0.77" ry="0.38" fill="#dfd5b0" />
        <ellipse cx="86.92" cy="235.38" rx="1.64" ry="0.82" fill="#dfd5b0" />
        <path
          d="M87.28,302.63c2.22.29,6-.29,6.18-1.74s0-24.87-.52-27.6c-2.28,0-5.25-.28-6.87-.46.44.23.73.35.73.35a59.46,59.46,0,0,1,.87,9.94c.09,6.18-4.54,16.42-4.54,16.42C83.13,301.47,85.06,302.34,87.28,302.63Z"
          fill="#806ce3"
        />
        <path
          d="M92.92,273.22a.84.84,0,0,0,0-.14c1.74-.39,6.08-1.83,5.79-4.83A8.82,8.82,0,0,0,97.1,264c-.16,5.65-7.41,8.16-15,5.88a13.73,13.73,0,0,0,4,3l.77.36S89.87,273.36,92.92,273.22Z"
          fill="#735dc9"
        />
        <path
          d="M86.8,273.18s3.18,3,4.87,2.51,1.21-2.61,1.21-2.61S87.52,273.27,86.8,273.18Z"
          fill="#5243c8"
        />
        <ellipse cx="85.7" cy="266.64" rx="3.28" ry="1.42" fill="#d199e4" />
        <ellipse cx="87.96" cy="263.36" rx="1.46" ry="0.63" fill="#d199e4" />
        <ellipse cx="91.5" cy="266.64" rx="1.46" ry="0.63" fill="#d199e4" />
        <path
          d="M102.23,321.81H81.36q-.77-1-1.56-2l.76-1c0-.47-.09-.63-.13-.33,0-.37-.09-3.11-.05-4.91s.09-3,.07-3.52a11.1,11.1,0,0,1,.1,1.8c0-1.3,0-2.34.1-3s.11-2.09.06-3.06a69.67,69.67,0,0,1,.16,7.83A12.4,12.4,0,0,1,81,312.1v.17c.11-2.87.19-4.83.16-5.87a37.28,37.28,0,0,1,.2,4.92c.06-3.07.17-5.34.3-6.57a60.37,60.37,0,0,0,.23-7,112.41,112.41,0,0,1,.3,11.37,6.14,6.14,0,0,1,.13-.87,18.51,18.51,0,0,0,.25-3.79c.06.35.11,2.84.08,6.11.08-.75.16-1.3.24-2.14.3-3.42.31-4.7.34-8.22,0-.84.08-1.06.11-.51.05.84.08,1.75.1,2.71a21.44,21.44,0,0,1,.19,3.65c0-2.66.11-4.76.21-6s.23-4.27.13-6.24c.14-.32.45,6.34.32,15.95a25.07,25.07,0,0,1,.23-3.09V307c.21-5.85.39-9.84.33-11.95a79.56,79.56,0,0,1,.39,10c.13-6.25.36-10.88.62-13.38a124.92,124.92,0,0,0,.47-14.25c.24,0,.62,9.43.61,23.16a12.27,12.27,0,0,1,.27-1.76,37.81,37.81,0,0,0,.5-7.73c.13.71.23,5.78.17,12.44.16-1.52.33-2.64.48-4.35A164.85,164.85,0,0,0,89,282.47c0-1.71.17-2.16.24-1,.3,5.61.36,12.6.14,20.64-.1,3.82-.24,7-.38,9.68l.18-.05a.19.19,0,0,0,0-.08c.11-1.09.23-1.81.33-3A101.18,101.18,0,0,0,90,298.12c0-1.08.11-1.36.15-.66.19,3.53.23,7.92.09,13,0,.37,0,.72,0,1.07l.64-.08c0-.31,0-.61,0-.88,0-2.38.12-4,.09-4.65a15.69,15.69,0,0,1,.13,2.38c0-1.72.07-3.08.13-3.9s.15-2.76.09-4a97.55,97.55,0,0,1,.2,10.31,15,15,0,0,1,.15-2v.22c.14-3.78.25-6.36.21-7.73a49.49,49.49,0,0,1,.25,6.49c.09-4.05.24-7,.41-8.66a81.92,81.92,0,0,0,.3-9.21c.16,0,.4,6.09.39,15a7.73,7.73,0,0,1,.18-1.14,24.64,24.64,0,0,0,.32-5c.09.46.15,3.74.11,8,.11-1,.22-1.7.32-2.81A107.24,107.24,0,0,0,94.56,293c0-1.11.11-1.4.15-.67.2,3.62.24,8.14.1,13.35q-.11,3.57-.24,6.07l.12,0c.07-.66.14-1.13.21-1.86a66.07,66.07,0,0,0,.27-6.8c0-.7.08-.88.1-.42.13,2.27.15,5.11.06,8.38,0,.32,0,.61,0,.91,3.28,1.21,5.8,4.12,8.48,7.77C103.26,320.48,102.74,321.16,102.23,321.81Zm-19-7c0-.44,0-.88,0-1.34,0,.83-.08,1.55-.12,2.19l.08-.09C83.24,315.31,83.25,315.06,83.27,314.82Z"
          fill="#68c902"
        />
      </g>
      <g>
        <ellipse cx="442.81" cy="457.52" rx="21.57" ry="5.62" fill="#54ba02" />
        <path
          d="M442.81,451.9c-10.4,0-19.08,1.92-21.11,4.47,3.68-1.72,10.75-2.89,18.87-2.89,11.91,0,21.57,2.51,21.57,5.61a1.86,1.86,0,0,1-.45,1.15c1.71-.8,2.7-1.73,2.7-2.72C464.39,454.42,454.73,451.9,442.81,451.9Z"
          fill="#4fb002"
        />
      </g>
      <g>
        <ellipse cx="1281.47" cy="60.55" rx="34" ry="8.85" fill="#54ba02" />
        <path
          d="M1281.47,51.69c-16.39,0-30.07,3-33.28,7.05,5.8-2.72,16.94-4.57,29.74-4.57,18.78,0,34,4,34,8.86a2.89,2.89,0,0,1-.71,1.81c2.71-1.27,4.25-2.74,4.25-4.29C1315.47,55.66,1300.25,51.69,1281.47,51.69Z"
          fill="#4fb002"
        />
      </g>
      <g>
        <ellipse
          cx="1418.54"
          cy="399.33"
          rx="51.48"
          ry="13.41"
          fill="#54ba02"
        />
        <path
          d="M1418.54,385.92c-24.83,0-45.54,4.58-50.4,10.67,8.78-4.12,25.65-6.92,45-6.92,28.43,0,51.48,6,51.48,13.41a4.41,4.41,0,0,1-1.08,2.74c4.1-1.92,6.44-4.14,6.44-6.49C1470,391.92,1447,385.92,1418.54,385.92Z"
          fill="#4fb002"
        />
      </g>
      <g>
        <ellipse cx="332.04" cy="192.79" rx="31" ry="8.07" fill="#54ba02" />
        <path
          d="M332,184.72c-15,0-27.42,2.76-30.35,6.42,5.29-2.48,15.45-4.16,27.12-4.16,17.12,0,31,3.62,31,8.07a2.6,2.6,0,0,1-.65,1.65c2.47-1.15,3.88-2.49,3.88-3.91C363,188.34,349.16,184.72,332,184.72Z"
          fill="#4fb002"
        />
      </g>
      <g>
        <ellipse cx="992.43" cy="476.78" rx="34" ry="8.85" fill="#54ba02" />
        <path
          d="M992.43,467.93c-16.39,0-30.07,3-33.28,7,5.8-2.72,16.94-4.56,29.74-4.56,18.78,0,34,4,34,8.85a2.92,2.92,0,0,1-.71,1.81c2.71-1.27,4.25-2.73,4.25-4.29C1026.43,471.89,1011.21,467.93,992.43,467.93Z"
          fill="#4fb002"
        />
      </g>
      <g>
        <ellipse cx="208.17" cy="195.23" rx="34" ry="8.85" fill="#54ba02" />
        <path
          d="M208.17,186.38c-16.39,0-30.07,3-33.28,7,5.8-2.72,16.94-4.56,29.74-4.56,18.78,0,34,4,34,8.85a2.86,2.86,0,0,1-.71,1.81c2.71-1.27,4.25-2.73,4.25-4.29C242.17,190.34,227,186.38,208.17,186.38Z"
          fill="#4fb002"
        />
      </g>
      <g>
        <ellipse cx="501.08" cy="132.13" rx="27.84" ry="7.25" fill="#54ba02" />
        <path
          d="M501.08,124.88c-13.43,0-24.63,2.48-27.26,5.77,4.75-2.23,13.88-3.74,24.36-3.74,15.37,0,27.84,3.25,27.84,7.25a2.31,2.31,0,0,1-.59,1.48c2.22-1,3.49-2.23,3.49-3.51C528.92,128.13,516.45,124.88,501.08,124.88Z"
          fill="#4fb002"
        />
      </g>
      <path
        d="M850.69,198.25a16.91,16.91,0,0,0-8.47,1.09l.45-3.38-3.81,3.21a80.43,80.43,0,0,0-.86-14.63,46.12,46.12,0,0,0-.8,13.52q-2.69-2.61-5.46-5.13a4.62,4.62,0,0,0,1,4.56,10.49,10.49,0,0,0-9.29,2.45,19.25,19.25,0,0,0,6.62,2,77.86,77.86,0,0,0,13.81,1c1.92,0,2.33-.06,3.65-1.27C848.28,200.93,849.29,198.07,850.69,198.25Z"
        fill="#8ac72f"
      />
      <path
        d="M361.12,92.43a8,8,0,0,1-.1-2.88l1.06,1.54a3.07,3.07,0,0,1,1.21-1.31,7.23,7.23,0,0,0,1.8,2l1.48-1.19a1.4,1.4,0,0,0,1.79,1,4,4,0,0,0,1.84-1.39l.7,1.52a4.86,4.86,0,0,0,1.72-1.06,1.53,1.53,0,0,0,.52,1.3,28,28,0,0,1,9-13.54,39.72,39.72,0,0,0-8.71,18.15A17.62,17.62,0,0,1,378.81,91a1.06,1.06,0,0,0,.05,1.57,77.89,77.89,0,0,1-5.44,9.3,26.5,26.5,0,0,0-2.74-7.76L369.43,96A3,3,0,0,1,368,94.72a2.65,2.65,0,0,0-1.45-1.2c-.63-.14-1.4.45-1.17,1.06-1.05-.94-2.07-2-3.19-2.79-.15,1.66.33,3.69-.24,5.23-2.55-2.1-3-7.65-4.52-10.52C358.68,88.46,359.89,90.45,361.12,92.43Z"
        fill="#72a139"
      />
      <path
        d="M388.1,608a7.75,7.75,0,0,1-.1-2.88l1.06,1.54a3.18,3.18,0,0,1,1.21-1.31,7,7,0,0,0,1.8,2l1.48-1.19a1.4,1.4,0,0,0,1.79,1,4,4,0,0,0,1.84-1.4l.7,1.53a4.89,4.89,0,0,0,1.72-1.07,1.54,1.54,0,0,0,.52,1.31A28,28,0,0,1,409.07,594a39.8,39.8,0,0,0-8.7,18.15,17.62,17.62,0,0,1,5.42-5.55,1.06,1.06,0,0,0,0,1.57,79.13,79.13,0,0,1-5.44,9.29,26.44,26.44,0,0,0-2.74-7.75l-1.25,1.84a2.91,2.91,0,0,1-1.42-1.25,2.65,2.65,0,0,0-1.45-1.2c-.63-.13-1.4.46-1.17,1.06-1.05-.94-2.07-2-3.19-2.78-.15,1.65.33,3.69-.25,5.23-2.54-2.11-3-7.65-4.51-10.53C385.66,604.08,386.87,606.07,388.1,608Z"
        fill="#72a139"
      />
      <path
        d="M541.45,581.2a8,8,0,0,1-.1-2.88l1.07,1.54a3.1,3.1,0,0,1,1.2-1.31,7,7,0,0,0,1.81,2l1.48-1.19c.05.78,1,1.22,1.78,1a4,4,0,0,0,1.84-1.4l.7,1.53a5,5,0,0,0,1.73-1.07,1.51,1.51,0,0,0,.51,1.31,28.1,28.1,0,0,1,9-13.54,39.72,39.72,0,0,0-8.71,18.15,17.72,17.72,0,0,1,5.42-5.55,1.07,1.07,0,0,0,.05,1.57,78.49,78.49,0,0,1-5.43,9.29A27,27,0,0,0,551,582.9l-1.26,1.84a2.89,2.89,0,0,1-1.41-1.25,2.67,2.67,0,0,0-1.46-1.2c-.62-.13-1.39.46-1.17,1.06a41.75,41.75,0,0,0-3.19-2.78c-.15,1.65.33,3.69-.24,5.23-2.55-2.11-3-7.65-4.52-10.53C539,577.24,540.23,579.23,541.45,581.2Z"
        fill="#72a139"
      />
      <path
        d="M848.42,120.28a8,8,0,0,1-.1-2.88l1.06,1.54a3.18,3.18,0,0,1,1.21-1.31,6.85,6.85,0,0,0,1.81,2l1.48-1.19c0,.78,1,1.22,1.78,1a4.06,4.06,0,0,0,1.84-1.4l.7,1.53a5,5,0,0,0,1.73-1.07,1.51,1.51,0,0,0,.51,1.31,28.1,28.1,0,0,1,9-13.54,39.67,39.67,0,0,0-8.71,18.15,17.62,17.62,0,0,1,5.42-5.55,1.07,1.07,0,0,0,0,1.57,78.49,78.49,0,0,1-5.43,9.29A27,27,0,0,0,858,122l-1.26,1.84a2.85,2.85,0,0,1-1.41-1.25,2.67,2.67,0,0,0-1.46-1.2c-.62-.13-1.39.46-1.17,1.06-1.05-.94-2.07-2-3.19-2.79-.15,1.66.33,3.7-.24,5.23-2.55-2.1-3-7.65-4.52-10.52C846,116.32,847.19,118.3,848.42,120.28Z"
        fill="#72a139"
      />
      <path
        d="M950.77,184.34a8.22,8.22,0,0,1,.59-2.82l.67,1.75a3,3,0,0,1,1.49-1,6.88,6.88,0,0,0,1.27,2.35l1.72-.8c-.13.77.71,1.43,1.49,1.42a4.15,4.15,0,0,0,2.13-.92l.31,1.65a4.92,4.92,0,0,0,1.93-.62,1.5,1.5,0,0,0,.19,1.39,28,28,0,0,1,11.94-11,39.63,39.63,0,0,0-12.81,15.53,17.67,17.67,0,0,1,6.59-4.09,1.05,1.05,0,0,0-.32,1.53,77.1,77.1,0,0,1-7.51,7.72,26.56,26.56,0,0,0-.8-8.18L958,189.77a2.9,2.9,0,0,1-1.07-1.56,2.75,2.75,0,0,0-1.12-1.51c-.58-.28-1.47.11-1.4.75-.79-1.16-1.54-2.4-2.42-3.47-.55,1.57-.57,3.66-1.5,5-2-2.66-1.09-8.15-1.86-11.3C949.35,179.91,950.06,182.13,950.77,184.34Z"
        fill="#72a139"
      />
      <path
        d="M1252.43,347.65a8,8,0,0,1-.1-2.88l1.07,1.54a3.12,3.12,0,0,1,1.21-1.31,6.81,6.81,0,0,0,1.8,2l1.48-1.19c0,.78,1,1.22,1.78,1a4,4,0,0,0,1.85-1.4l.69,1.53a4.93,4.93,0,0,0,1.73-1.07,1.48,1.48,0,0,0,.52,1.31,28,28,0,0,1,9-13.54,39.72,39.72,0,0,0-8.71,18.15,17.72,17.72,0,0,1,5.42-5.55,1.06,1.06,0,0,0,.06,1.57,79.13,79.13,0,0,1-5.44,9.29,27,27,0,0,0-2.74-7.75l-1.26,1.84a2.93,2.93,0,0,1-1.41-1.25,2.65,2.65,0,0,0-1.45-1.2c-.63-.13-1.4.46-1.18,1.06-1-.94-2.07-1.95-3.18-2.78-.15,1.65.32,3.69-.25,5.23-2.54-2.11-3-7.65-4.52-10.53C1250,343.69,1251.21,345.68,1252.43,347.65Z"
        fill="#72a139"
      />
      <path
        d="M1125.37,376.79a8,8,0,0,1-.1-2.88l1.06,1.54a3.07,3.07,0,0,1,1.21-1.31,7.09,7.09,0,0,0,1.8,2l1.48-1.19a1.4,1.4,0,0,0,1.79,1,4,4,0,0,0,1.84-1.39l.7,1.52a4.86,4.86,0,0,0,1.72-1.06,1.53,1.53,0,0,0,.52,1.3,27.93,27.93,0,0,1,9-13.53,39.64,39.64,0,0,0-8.71,18.14,17.62,17.62,0,0,1,5.42-5.55,1.06,1.06,0,0,0,0,1.57,77.89,77.89,0,0,1-5.44,9.3,26.34,26.34,0,0,0-2.74-7.75l-1.25,1.84a3,3,0,0,1-1.42-1.25,2.65,2.65,0,0,0-1.45-1.2c-.63-.13-1.4.45-1.17,1.06-1.05-.94-2.07-2-3.19-2.79-.15,1.66.33,3.69-.24,5.23-2.55-2.1-3-7.65-4.52-10.52C1122.93,372.82,1124.14,374.81,1125.37,376.79Z"
        fill="#72a139"
      />
      <path
        d="M1327.15,295.13a8,8,0,0,1-.11-2.88l1.07,1.54a3.06,3.06,0,0,1,1.21-1.31,6.94,6.94,0,0,0,1.8,2l1.48-1.19a1.4,1.4,0,0,0,1.79,1,4.12,4.12,0,0,0,1.84-1.4l.69,1.52a4.9,4.9,0,0,0,1.73-1.06,1.47,1.47,0,0,0,.52,1.3,28,28,0,0,1,8.95-13.53,39.89,39.89,0,0,0-8.71,18.14,17.7,17.7,0,0,1,5.42-5.54,1,1,0,0,0,.06,1.56,79.26,79.26,0,0,1-5.44,9.3,27,27,0,0,0-2.74-7.75l-1.25,1.84a2.91,2.91,0,0,1-1.42-1.25,2.65,2.65,0,0,0-1.45-1.2c-.63-.13-1.4.46-1.18,1.06-1-.94-2.06-2-3.18-2.79-.15,1.66.32,3.69-.25,5.23-2.54-2.1-3-7.65-4.52-10.52C1324.7,291.17,1325.92,293.15,1327.15,295.13Z"
        fill="#72a139"
      />
      <path
        d="M1379.09,224.93a8,8,0,0,1-.11-2.88l1.07,1.53a3.12,3.12,0,0,1,1.21-1.31,6.81,6.81,0,0,0,1.8,2l1.48-1.19c0,.78,1,1.22,1.79,1a4,4,0,0,0,1.84-1.4l.69,1.53a5.05,5.05,0,0,0,1.73-1.06,1.47,1.47,0,0,0,.52,1.3,28.06,28.06,0,0,1,9-13.54,39.82,39.82,0,0,0-8.71,18.15,17.83,17.83,0,0,1,5.42-5.55,1.06,1.06,0,0,0,.06,1.57,78.33,78.33,0,0,1-5.44,9.29,27,27,0,0,0-2.74-7.75l-1.25,1.84a2.91,2.91,0,0,1-1.42-1.25,2.7,2.7,0,0,0-1.45-1.2c-.63-.13-1.4.46-1.18,1.06-1-.94-2.07-1.95-3.18-2.78-.15,1.66.32,3.69-.25,5.23-2.54-2.11-3-7.65-4.52-10.53C1376.64,221,1377.86,223,1379.09,224.93Z"
        fill="#72a139"
      />
      <path
        d="M1445.24,134.41a8,8,0,0,1-.11-2.88l1.07,1.54a3.12,3.12,0,0,1,1.21-1.31,6.81,6.81,0,0,0,1.8,2l1.48-1.19a1.4,1.4,0,0,0,1.79,1,4,4,0,0,0,1.84-1.4l.69,1.53a4.84,4.84,0,0,0,1.73-1.07,1.48,1.48,0,0,0,.52,1.31,28,28,0,0,1,9-13.54,39.8,39.8,0,0,0-8.7,18.15,17.69,17.69,0,0,1,5.41-5.55,1.06,1.06,0,0,0,.06,1.57,79.13,79.13,0,0,1-5.44,9.29,27,27,0,0,0-2.74-7.75l-1.25,1.84a2.91,2.91,0,0,1-1.42-1.25,2.65,2.65,0,0,0-1.45-1.2c-.63-.13-1.4.46-1.18,1.06-1-.94-2.06-1.95-3.18-2.78-.15,1.65.32,3.69-.25,5.23-2.54-2.11-3-7.65-4.52-10.53C1442.79,130.45,1444,132.44,1445.24,134.41Z"
        fill="#72a139"
      />
      <path
        d="M1411.61,291.6a7.76,7.76,0,0,1-.1-2.88l1.06,1.54a3,3,0,0,1,1.21-1.31,7.23,7.23,0,0,0,1.8,2l1.48-1.19a1.4,1.4,0,0,0,1.79,1,4,4,0,0,0,1.84-1.39l.7,1.52a4.86,4.86,0,0,0,1.72-1.06,1.53,1.53,0,0,0,.52,1.3,28.06,28.06,0,0,1,8.95-13.54,39.8,39.8,0,0,0-8.7,18.15,17.62,17.62,0,0,1,5.42-5.55,1.05,1.05,0,0,0,0,1.57,79.26,79.26,0,0,1-5.44,9.3,26.5,26.5,0,0,0-2.74-7.76l-1.25,1.85a3,3,0,0,1-1.42-1.25,2.65,2.65,0,0,0-1.45-1.2c-.63-.14-1.4.45-1.17,1.05-1.05-.93-2.07-1.95-3.19-2.78-.15,1.66.33,3.69-.25,5.23-2.54-2.11-3-7.65-4.52-10.52C1409.17,287.63,1410.38,289.62,1411.61,291.6Z"
        fill="#72a139"
      />
      <path
        d="M1329.74,14a8,8,0,0,1-.1-2.88l1.06,1.54a3.18,3.18,0,0,1,1.21-1.31,7,7,0,0,0,1.8,2l1.48-1.19a1.4,1.4,0,0,0,1.79,1,4,4,0,0,0,1.84-1.4l.7,1.53a4.89,4.89,0,0,0,1.72-1.07,1.55,1.55,0,0,0,.52,1.31,28,28,0,0,1,9-13.54A39.72,39.72,0,0,0,1342,18.15a17.62,17.62,0,0,1,5.42-5.55,1.06,1.06,0,0,0,0,1.57,78.56,78.56,0,0,1-5.44,9.29,26.44,26.44,0,0,0-2.74-7.75l-1.25,1.84a2.91,2.91,0,0,1-1.42-1.25,2.65,2.65,0,0,0-1.45-1.2c-.63-.13-1.4.46-1.17,1.06-1-.94-2.07-2-3.19-2.78-.15,1.65.33,3.69-.24,5.22-2.55-2.1-3-7.65-4.52-10.52C1327.3,10.05,1328.51,12,1329.74,14Z"
        fill="#72a139"
      />
      <path
        d="M1356.29,117.91a8,8,0,0,1-.1-2.88l1.07,1.54a3.12,3.12,0,0,1,1.21-1.31,6.81,6.81,0,0,0,1.8,2l1.48-1.19c0,.78,1,1.22,1.78,1a4,4,0,0,0,1.85-1.4l.69,1.53a5,5,0,0,0,1.73-1.07,1.48,1.48,0,0,0,.52,1.31,28,28,0,0,1,9-13.54,39.72,39.72,0,0,0-8.71,18.15,17.72,17.72,0,0,1,5.42-5.55,1.07,1.07,0,0,0,0,1.57,77.69,77.69,0,0,1-5.43,9.29,27,27,0,0,0-2.74-7.75l-1.26,1.84a2.89,2.89,0,0,1-1.41-1.25,2.69,2.69,0,0,0-1.45-1.2c-.63-.13-1.4.46-1.18,1.06-1-.94-2.07-2-3.19-2.78-.14,1.65.33,3.69-.24,5.23-2.54-2.11-3-7.65-4.52-10.53C1353.85,114,1355.07,115.94,1356.29,117.91Z"
        fill="#72a139"
      />
      <path
        d="M1227.86,529.86a8,8,0,0,1-.1-2.88l1.07,1.54a3,3,0,0,1,1.21-1.31,6.94,6.94,0,0,0,1.8,2l1.48-1.19c0,.78,1,1.21,1.78,1a4.07,4.07,0,0,0,1.85-1.39l.69,1.52a5,5,0,0,0,1.73-1.06,1.47,1.47,0,0,0,.52,1.3,28,28,0,0,1,8.95-13.53,39.64,39.64,0,0,0-8.71,18.14,17.72,17.72,0,0,1,5.42-5.55,1.07,1.07,0,0,0,0,1.57,77.82,77.82,0,0,1-5.43,9.3,26.92,26.92,0,0,0-2.74-7.75l-1.26,1.84a3,3,0,0,1-1.41-1.25,2.69,2.69,0,0,0-1.45-1.2c-.63-.13-1.4.45-1.18,1.06-1-.94-2.07-2-3.19-2.79-.14,1.66.33,3.69-.24,5.23-2.54-2.1-3-7.65-4.52-10.52C1225.42,525.9,1226.64,527.88,1227.86,529.86Z"
        fill="#72a139"
      />
      <path
        d="M458.91,185.47a8,8,0,0,1-.1-2.88l1.07,1.54a3.12,3.12,0,0,1,1.21-1.31,6.81,6.81,0,0,0,1.8,2l1.48-1.19c.05.78,1,1.22,1.78,1a4,4,0,0,0,1.85-1.4l.69,1.53a5,5,0,0,0,1.73-1.07,1.49,1.49,0,0,0,.52,1.31,28,28,0,0,1,8.95-13.54,39.67,39.67,0,0,0-8.71,18.15,17.72,17.72,0,0,1,5.42-5.55,1.07,1.07,0,0,0,0,1.57,78.49,78.49,0,0,1-5.43,9.29,27,27,0,0,0-2.74-7.75L467.22,189a2.89,2.89,0,0,1-1.41-1.25,2.69,2.69,0,0,0-1.45-1.2c-.63-.13-1.4.46-1.18,1.06a41.75,41.75,0,0,0-3.19-2.78c-.14,1.65.33,3.69-.24,5.22-2.54-2.1-3-7.65-4.52-10.52C456.47,181.51,457.69,183.5,458.91,185.47Z"
        fill="#72a139"
      />
      <path
        d="M676.78,145.62a8,8,0,0,1-.1-2.88l1.07,1.54A3.06,3.06,0,0,1,679,143a6.94,6.94,0,0,0,1.8,2l1.48-1.19c0,.78,1,1.22,1.78,1a4.09,4.09,0,0,0,1.85-1.4l.69,1.52a5,5,0,0,0,1.73-1.06,1.47,1.47,0,0,0,.52,1.3,28,28,0,0,1,9-13.53,39.64,39.64,0,0,0-8.71,18.14,17.59,17.59,0,0,1,5.42-5.54,1.05,1.05,0,0,0,0,1.56,77.82,77.82,0,0,1-5.43,9.3,27,27,0,0,0-2.74-7.75l-1.26,1.84a2.89,2.89,0,0,1-1.41-1.25,2.69,2.69,0,0,0-1.45-1.2c-.63-.13-1.4.46-1.18,1.06-1-.94-2.07-2-3.19-2.79-.14,1.66.33,3.69-.24,5.23-2.54-2.1-3-7.65-4.52-10.52C674.34,141.66,675.56,143.64,676.78,145.62Z"
        fill="#72a139"
      />
      <path
        d="M155.36,279.15a8,8,0,0,1-.1-2.88l1.06,1.54a3.18,3.18,0,0,1,1.21-1.31,7,7,0,0,0,1.8,2l1.48-1.19a1.4,1.4,0,0,0,1.79,1,4,4,0,0,0,1.84-1.4l.7,1.53a4.89,4.89,0,0,0,1.72-1.07,1.55,1.55,0,0,0,.52,1.31,28,28,0,0,1,9-13.54,39.72,39.72,0,0,0-8.71,18.15,17.62,17.62,0,0,1,5.42-5.55,1.06,1.06,0,0,0,0,1.57,78.56,78.56,0,0,1-5.44,9.29,26.44,26.44,0,0,0-2.74-7.75l-1.25,1.84a2.91,2.91,0,0,1-1.42-1.25,2.65,2.65,0,0,0-1.45-1.2c-.63-.13-1.4.46-1.17,1.06-1-.94-2.07-2-3.19-2.78-.15,1.65.33,3.69-.24,5.23-2.55-2.11-3-7.65-4.52-10.53C152.92,275.19,154.13,277.18,155.36,279.15Z"
        fill="#72a139"
      />
      <path
        d="M333.19,236.15a8,8,0,0,1-.1-2.88l1.06,1.54a3.18,3.18,0,0,1,1.21-1.31,6.85,6.85,0,0,0,1.81,2l1.47-1.19a1.41,1.41,0,0,0,1.79,1,4.06,4.06,0,0,0,1.84-1.4l.7,1.53a5,5,0,0,0,1.73-1.07,1.48,1.48,0,0,0,.51,1.3,28.07,28.07,0,0,1,9-13.53,39.67,39.67,0,0,0-8.71,18.15,17.52,17.52,0,0,1,5.42-5.55,1.07,1.07,0,0,0,.05,1.57,78.49,78.49,0,0,1-5.43,9.29,27,27,0,0,0-2.74-7.75l-1.26,1.84a2.85,2.85,0,0,1-1.41-1.25,2.67,2.67,0,0,0-1.46-1.2c-.62-.13-1.39.46-1.17,1.06-1-.94-2.07-2-3.19-2.79-.15,1.66.33,3.69-.24,5.23-2.55-2.1-3-7.65-4.52-10.52C330.75,232.19,332,234.17,333.19,236.15Z"
        fill="#72a139"
      />
      <path
        d="M273.9,279.22a8,8,0,0,1-.1-2.89l1.06,1.54a3.18,3.18,0,0,1,1.21-1.31,7,7,0,0,0,1.8,2l1.48-1.19a1.4,1.4,0,0,0,1.79,1A4,4,0,0,0,283,277l.7,1.53a4.89,4.89,0,0,0,1.72-1.07,1.54,1.54,0,0,0,.52,1.31,28,28,0,0,1,9-13.54,39.72,39.72,0,0,0-8.71,18.15,17.62,17.62,0,0,1,5.42-5.55,1.06,1.06,0,0,0,.05,1.57,77.76,77.76,0,0,1-5.44,9.29,26.44,26.44,0,0,0-2.74-7.75l-1.25,1.84a2.91,2.91,0,0,1-1.42-1.25,2.65,2.65,0,0,0-1.45-1.2c-.63-.13-1.4.46-1.17,1.06-1.05-.94-2.07-1.95-3.19-2.78-.15,1.65.33,3.69-.24,5.23-2.55-2.11-3-7.65-4.52-10.53C271.46,275.25,272.67,277.24,273.9,279.22Z"
        fill="#72a139"
      />
      <path
        d="M994.59,478.34a6.65,6.65,0,0,0-4.08,4.06,21.07,21.07,0,0,0-.2-5.72l-2.14,3.45-.62-2.05a18.58,18.58,0,0,0-3.14,3.37,23.23,23.23,0,0,0-5.92-10c-1.79,2.38-.51,5.77-1,8.71a1.4,1.4,0,0,1-.46,1,1.42,1.42,0,0,1-1,.12,12,12,0,0,1-6.45-3.09l-.8,3a1.81,1.81,0,0,0-.78-1.25l-.54,2a6,6,0,0,0-8.1-.72c2.62,2.32,6.09,3.37,9.49,4.19a92.83,92.83,0,0,0,24.26,2.87c7-.24,6.3-5,7.16-10.83A14.69,14.69,0,0,0,994.59,478.34Z"
        fill="#8ac72f"
      />
      {/* <g>
        <ellipse cx="363.56" cy="301.58" rx="19.19" ry="8.4" fill="#72a139" />
        <path
          d="M350.25,221.25c-.29,5.62.59,18.64-3.25,26.63s-9.77,11.84-5.63,22.5,3.85,25.15,3,28.41-1.18,4.44-1.18,4.44a4,4,0,0,0,4.14,1.62c3-.44,4.59-4.44,4.74-6.66s1.62-12.87-.45-23.37-2.22-13.47-2.36-20,2.81-10.36,3.69-15.24,1.63-18,1.63-18,9.92,1.18,11.1-.15c1.18-3,.74-13-11.84-12.43s-15.24,9.17-14.65,11.54S350.25,221.25,350.25,221.25Z"
          fill="#c53964"
        />
        <path
          d="M354.54,221.55s9.92,1.18,11.1-.15c1.18-3,.74-13-11.84-12.43s-15.24,9.17-14.65,11.54,11.1.74,11.1.74,0,.19,0,.29a14.14,14.14,0,0,1,2.08.15l2.2.31C354.53,221.71,354.54,221.55,354.54,221.55Z"
          fill="#c53964"
        />
        <path
          d="M350.25,221.25c.74-.44,4.29.3,4.29.3s-.89,16.42-1.77,19.08C351.44,223.62,350.25,221.25,350.25,221.25Z"
          fill="#a03964"
        />
        <path
          d="M348.48,309.74c0,3,3,4.29,6.36,4.73s9.17-.44,9.47-2.66,0-40.69-.89-42.62c2.66-.59,9.32-2.81,8.88-7.4s-3.26-11-12.58-11.83-16,3.7-15.09,9.76,9.47,9.62,9.47,9.62a91.12,91.12,0,0,1,1.33,15.24C355.58,294.05,348.48,309.74,348.48,309.74Z"
          fill="#9a7ce3"
        />
        <path
          d="M351.58,209c-2.77.46-7.4,2.07-8.73,4.29s4.89,4.14,9.62,3.7,11.1,1,11.54-1.78-.59-4.44-3.7-5.47A18,18,0,0,0,351.58,209Z"
          fill="#c9679b"
        />
        <ellipse cx="346.7" cy="216.42" rx="2.96" ry="1.48" fill="#dfd5b0" />
        <ellipse cx="349.96" cy="214" rx="1.42" ry="0.71" fill="#dfd5b0" />
        <ellipse cx="345.22" cy="213.56" rx="1.92" ry="0.96" fill="#dfd5b0" />
        <ellipse cx="358.73" cy="217.45" rx="2.71" ry="1.35" fill="#dfd5b0" />
        <ellipse cx="362.1" cy="215.06" rx="1.18" ry="0.59" fill="#dfd5b0" />
        <ellipse cx="354.29" cy="211.41" rx="2.51" ry="1.26" fill="#dfd5b0" />
        <path
          d="M354.84,314.47c3.4.45,9.17-.44,9.47-2.66s0-38.12-.8-42.29c-3.49,0-8-.44-10.53-.71.68.35,1.12.53,1.12.53a91.12,91.12,0,0,1,1.33,15.24c.15,9.47-6.95,25.16-6.95,25.16C348.48,312.7,351.44,314,354.84,314.47Z"
          fill="#806ce3"
        />
        <path
          d="M363.49,269.41a1.44,1.44,0,0,0-.07-.22c2.66-.59,9.32-2.81,8.88-7.4a13.55,13.55,0,0,0-2.41-6.59c-.25,8.67-11.35,12.51-23.05,9a21,21,0,0,0,6.09,4.57l1.17.55S358.81,269.62,363.49,269.41Z"
          fill="#735dc9"
        />
        <path
          d="M354.1,269.34s4.88,4.66,7.47,3.85,1.85-4,1.85-4S355.21,269.49,354.1,269.34Z"
          fill="#5243c8"
        />
        <ellipse cx="352.42" cy="259.33" rx="5.03" ry="2.17" fill="#d199e4" />
        <ellipse cx="355.87" cy="254.3" rx="2.24" ry="0.97" fill="#d199e4" />
        <ellipse cx="361.3" cy="259.33" rx="2.24" ry="0.97" fill="#d199e4" />
        <path
          d="M377.74,332.05h-32c-.79-.64-1.58-1.32-2.39-2l1.16-1c-.06-.47-.14-.64-.21-.33,0-.37-.12-3.12-.06-4.91s.14-3,.11-3.52a7.4,7.4,0,0,1,.14,1.8c0-1.31.08-2.34.16-3a20.58,20.58,0,0,0,.1-3.06,46.73,46.73,0,0,1,.23,7.83,8.42,8.42,0,0,1,.18-1.52v.18c.16-2.87.29-4.83.25-5.87a25.62,25.62,0,0,1,.29,4.92,59.93,59.93,0,0,1,.47-6.57,40.29,40.29,0,0,0,.35-7c.18,0,.47,4.62.46,11.37a4.19,4.19,0,0,1,.2-.87,12.11,12.11,0,0,0,.38-3.79,51,51,0,0,1,.13,6.1c.12-.74.25-1.29.36-2.13a52,52,0,0,0,.52-8.22c0-.84.13-1.07.17-.51.08.84.13,1.75.16,2.71a14.78,14.78,0,0,1,.29,3.65c0-2.66.17-4.76.31-6a40,40,0,0,0,.21-6.24c.21-.32.68,6.34.48,15.95a16,16,0,0,1,.36-3.09v.36c.33-5.85.6-9.84.5-11.95a51.67,51.67,0,0,1,.6,10,126.15,126.15,0,0,1,.95-13.38,81.32,81.32,0,0,0,.72-14.25c.37,0,.95,9.43.94,23.16a8.66,8.66,0,0,1,.4-1.76,24.63,24.63,0,0,0,.78-7.73,106.14,106.14,0,0,1,.26,12.44c.25-1.52.51-2.64.74-4.36a106.4,106.4,0,0,0,1-16.74c0-1.71.27-2.16.36-1a168.52,168.52,0,0,1,.23,20.64c-.16,3.82-.37,7-.6,9.68l.29-.05a.22.22,0,0,0,0-.08c.17-1.09.35-1.81.51-3a67.8,67.8,0,0,0,.66-10.52c0-1.08.17-1.36.23-.66a107.84,107.84,0,0,1,.14,13c0,.37,0,.72-.05,1.07l1-.08c0-.31,0-.61,0-.89.08-2.37.17-4,.13-4.64a9.34,9.34,0,0,1,.2,2.38c0-1.72.1-3.08.2-3.9a26.37,26.37,0,0,0,.13-4c.14-.21.44,4.1.31,10.31a10.67,10.67,0,0,1,.23-2v.23c.22-3.78.39-6.36.33-7.73a33.64,33.64,0,0,1,.39,6.49,82.79,82.79,0,0,1,.61-8.66,52.42,52.42,0,0,0,.47-9.22c.24,0,.61,6.1.6,15a5.25,5.25,0,0,1,.27-1.14,16.07,16.07,0,0,0,.5-5,69.4,69.4,0,0,1,.17,8c.16-1,.32-1.7.47-2.81a68.05,68.05,0,0,0,.68-10.83c0-1.11.18-1.4.24-.67a111.64,111.64,0,0,1,.15,13.34c-.1,2.38-.23,4.4-.37,6.07l.19,0c.1-.66.21-1.13.31-1.86a43.74,43.74,0,0,0,.43-6.8c0-.7.11-.88.15-.43a70.49,70.49,0,0,1,.09,8.39c0,.32,0,.61-.05.9,5,1.22,8.89,4.13,13,7.78C379.33,330.73,378.53,331.41,377.74,332.05Zm-29-7c0-.44,0-.88,0-1.34-.06.83-.12,1.55-.19,2.19l.13-.09C348.64,325.56,348.67,325.31,348.7,325.07Z"
          fill="#8ac72f"
        />
      </g> */}
      <g transform="translate(10 -10)">
        <ellipse cx="932.83" cy="508.07" rx="24.24" ry="10.61" fill="#72a139" />
        <path
          d="M916,406.59c-.37,7.11.75,23.56-4.11,33.65s-12.34,15-7.11,28.41,4.86,31.78,3.74,35.9-1.49,5.6-1.49,5.6a5,5,0,0,0,5.23,2.06c3.74-.56,5.8-5.61,6-8.41s2.06-16.27-.56-29.54-2.8-17-3-25.23,3.55-13.09,4.67-19.26,2.06-22.8,2.06-22.8,12.53,1.49,14-.19c1.5-3.74.94-16.45-15-15.7S901.25,402.67,902,405.66,916,406.59,916,406.59Z"
          fill="#c53964"
        />
        <path
          d="M921.44,407s12.53,1.49,14-.19c1.5-3.74.94-16.45-15-15.7S901.25,402.67,902,405.66s14,.93,14,.93,0,.25,0,.37a17.55,17.55,0,0,1,2.64.19c.81.13,1.75.26,2.77.38C921.43,407.17,921.44,407,921.44,407Z"
          fill="#c53964"
        />
        <path
          d="M916,406.59c.93-.56,5.42.38,5.42.38s-1.12,20.75-2.24,24.11C917.52,409.58,916,406.59,916,406.59Z"
          fill="#a03964"
        />
        <path
          d="M913.78,518.38c0,3.74,3.74,5.42,8,6s11.59-.56,12-3.36,0-51.41-1.12-53.84c3.36-.75,11.77-3.55,11.21-9.35S939.76,444,928,442.86s-20.19,4.67-19.06,12.34,12,12.15,12,12.15a113.87,113.87,0,0,1,1.68,19.25C922.75,498.56,913.78,518.38,913.78,518.38Z"
          fill="#9a7ce3"
        />
        <path
          d="M917.7,391.08c-3.51.58-9.34,2.61-11,5.42s6.17,5.23,12.15,4.67,14,1.31,14.58-2.24-.74-5.61-4.67-6.92A22.77,22.77,0,0,0,917.7,391.08Z"
          fill="#c9679b"
        />
        <ellipse cx="911.53" cy="400.49" rx="3.74" ry="1.87" fill="#dfd5b0" />
        <ellipse cx="915.65" cy="397.43" rx="1.79" ry="0.89" fill="#dfd5b0" />
        <ellipse cx="909.66" cy="396.87" rx="2.42" ry="1.21" fill="#dfd5b0" />
        <ellipse cx="926.74" cy="401.79" rx="3.42" ry="1.71" fill="#dfd5b0" />
        <ellipse cx="930.99" cy="398.77" rx="1.48" ry="0.74" fill="#dfd5b0" />
        <ellipse cx="921.12" cy="394.16" rx="3.18" ry="1.59" fill="#dfd5b0" />
        <path
          d="M921.81,524.36c4.3.56,11.59-.56,12-3.36s0-48.16-1-53.43c-4.41,0-10.15-.55-13.31-.89.87.44,1.42.67,1.42.67a113.87,113.87,0,0,1,1.68,19.25c.19,12-8.78,31.78-8.78,31.78C913.78,522.12,917.52,523.8,921.81,524.36Z"
          fill="#806ce3"
        />
        <path
          d="M932.74,467.44a1.68,1.68,0,0,0-.08-.28c3.36-.75,11.77-3.55,11.21-9.35a17.14,17.14,0,0,0-3-8.33c-.32,10.95-14.34,15.81-29.12,11.39a26.3,26.3,0,0,0,7.69,5.78l1.48.7S926.83,467.7,932.74,467.44Z"
          fill="#735dc9"
        />
        <path
          d="M920.88,467.35s6.17,5.88,9.44,4.86,2.34-5,2.34-5S922.28,467.53,920.88,467.35Z"
          fill="#5243c8"
        />
        <ellipse cx="918.76" cy="454.7" rx="6.36" ry="2.74" fill="#d199e4" />
        <ellipse cx="923.12" cy="448.34" rx="2.83" ry="1.22" fill="#d199e4" />
        <ellipse cx="929.98" cy="454.7" rx="2.83" ry="1.22" fill="#d199e4" />
        <path
          d="M950.75,540.74H910.36c-1-.65-2-1.33-3-2l1.47-1c-.09-.47-.19-.63-.26-.33,0-.37-.16-3.11-.08-4.91s.17-3,.13-3.52a5.91,5.91,0,0,1,.18,1.8,24.65,24.65,0,0,1,.2-3,16.85,16.85,0,0,0,.13-3.06c.12-.16.42,3.11.29,7.83a7.08,7.08,0,0,1,.22-1.51v.17c.21-2.87.38-4.83.32-5.87a20.76,20.76,0,0,1,.37,4.92,47.27,47.27,0,0,1,.59-6.57,31.84,31.84,0,0,0,.44-7c.23,0,.59,4.62.58,11.37a3.41,3.41,0,0,1,.26-.87,10,10,0,0,0,.48-3.79,42.42,42.42,0,0,1,.16,6.11c.15-.75.31-1.3.46-2.14a42.36,42.36,0,0,0,.65-8.22c0-.84.17-1.06.22-.51.09.84.16,1.75.2,2.71a12,12,0,0,1,.37,3.65,56.44,56.44,0,0,1,.39-6,32.41,32.41,0,0,0,.27-6.24c.26-.32.85,6.34.6,15.95a13.28,13.28,0,0,1,.45-3.09V526c.42-5.85.76-9.84.64-12a41.54,41.54,0,0,1,.76,10,98.7,98.7,0,0,1,1.2-13.38,65.76,65.76,0,0,0,.91-14.25c.46,0,1.2,9.43,1.18,23.16a7.14,7.14,0,0,1,.51-1.76c.4-.72,1.08-3.56,1-7.73.25.71.45,5.78.33,12.44.31-1.52.64-2.64.93-4.35,1.2-7,1.23-9.57,1.33-16.75,0-1.71.34-2.16.46-1A135.19,135.19,0,0,1,926,521c-.21,3.82-.47,7-.75,9.68l.36,0s0,0,0-.08c.22-1.09.44-1.81.64-3a53.24,53.24,0,0,0,.83-10.52c0-1.08.22-1.36.29-.66a83.07,83.07,0,0,1,.18,13c0,.37,0,.72-.06,1.07l1.24-.08c0-.31,0-.61,0-.88.1-2.38.22-4,.17-4.65a7.47,7.47,0,0,1,.25,2.38,36,36,0,0,1,.25-3.9,20.87,20.87,0,0,0,.17-4c.17-.21.56,4.1.39,10.32a8.65,8.65,0,0,1,.29-2c0,.06,0,.14,0,.23.27-3.79.49-6.37.41-7.73a27,27,0,0,1,.49,6.48,64.44,64.44,0,0,1,.77-8.66,41.4,41.4,0,0,0,.59-9.21c.3,0,.78,6.09.77,15a4.63,4.63,0,0,1,.33-1.14,12.81,12.81,0,0,0,.63-5,53.08,53.08,0,0,1,.22,8c.2-1,.41-1.7.6-2.81a55.63,55.63,0,0,0,.86-10.83c0-1.11.22-1.4.29-.67a85.25,85.25,0,0,1,.19,13.35c-.13,2.38-.29,4.4-.46,6.07l.23,0c.14-.66.27-1.13.4-1.86a34.06,34.06,0,0,0,.54-6.8c0-.7.14-.88.19-.42a53.71,53.71,0,0,1,.11,8.38c0,.32,0,.61,0,.91,6.34,1.21,11.22,4.12,16.41,7.77C952.75,539.41,951.75,540.09,950.75,540.74Zm-36.69-7c0-.44,0-.88,0-1.34-.08.83-.16,1.55-.24,2.19l.16-.09C914,534.24,914,534,914.06,533.75Z"
          fill="#68c902"
        />
      </g>
      <g transform="translate(10, -175)">
        <ellipse cx="1374.08" cy="176.51" rx="17.19" ry="7.53" fill="#72a139" />
        <path
          d="M1362.16,104.54c-.26,5,.53,16.71-2.91,23.87s-8.75,10.6-5,20.15,3.44,22.54,2.65,25.45-1.06,4-1.06,4a3.55,3.55,0,0,0,3.71,1.46c2.65-.4,4.11-4,4.24-6s1.46-11.53-.39-20.94-2-12.07-2.13-17.9,2.52-9.28,3.32-13.66,1.46-16.17,1.46-16.17,8.88,1.06,9.94-.13c1.06-2.66.66-11.67-10.61-11.14s-13.65,8.22-13.12,10.34S1362.16,104.54,1362.16,104.54Z"
          fill="#c53964"
        />
        <path
          d="M1366,104.81s8.88,1.06,9.94-.13c1.06-2.66.66-11.67-10.61-11.14s-13.65,8.22-13.12,10.34,9.94.66,9.94.66,0,.18,0,.26a14.18,14.18,0,0,1,1.87.14c.58.09,1.24.18,2,.27C1366,105,1366,104.81,1366,104.81Z"
          fill="#c53964"
        />
        <path
          d="M1362.16,104.54c.67-.39,3.85.27,3.85.27s-.8,14.71-1.59,17.1C1363.22,106.66,1362.16,104.54,1362.16,104.54Z"
          fill="#a03964"
        />
        <path
          d="M1360.57,183.82c0,2.65,2.65,3.85,5.7,4.25s8.22-.4,8.49-2.39,0-36.46-.8-38.18c2.39-.53,8.35-2.52,8-6.63s-2.92-9.81-11.27-10.61-14.32,3.32-13.53,8.75,8.49,8.62,8.49,8.62a81.22,81.22,0,0,1,1.19,13.66C1366.94,169.77,1360.57,183.82,1360.57,183.82Z"
          fill="#9a7ce3"
        />
        <path
          d="M1363.36,93.54c-2.49.41-6.63,1.86-7.83,3.84s4.38,3.72,8.62,3.32,9.94.93,10.34-1.59-.53-4-3.31-4.91A16.11,16.11,0,0,0,1363.36,93.54Z"
          fill="#c9679b"
        />
        <ellipse cx="1358.98" cy="100.21" rx="2.65" ry="1.33" fill="#dfd5b0" />
        <ellipse cx="1361.9" cy="98.05" rx="1.27" ry="0.63" fill="#dfd5b0" />
        <ellipse cx="1357.65" cy="97.65" rx="1.72" ry="0.86" fill="#dfd5b0" />
        <ellipse cx="1369.76" cy="101.14" rx="2.43" ry="1.21" fill="#dfd5b0" />
        <ellipse cx="1372.78" cy="99" rx="1.05" ry="0.53" fill="#dfd5b0" />
        <ellipse cx="1365.78" cy="95.73" rx="2.25" ry="1.13" fill="#dfd5b0" />
        <path
          d="M1366.27,188.07c3,.39,8.22-.4,8.49-2.39s0-34.15-.72-37.89c-3.12,0-7.2-.39-9.43-.63.61.31,1,.47,1,.47a81.22,81.22,0,0,1,1.19,13.66c.14,8.48-6.23,22.53-6.23,22.53C1360.57,186.47,1363.22,187.67,1366.27,188.07Z"
          fill="#806ce3"
        />
        <path
          d="M1374,147.7a1,1,0,0,0-.06-.2c2.39-.53,8.35-2.52,8-6.63a12.16,12.16,0,0,0-2.16-5.91c-.23,7.77-10.17,11.21-20.66,8.08a18.66,18.66,0,0,0,5.46,4.09l1,.5S1369.83,147.88,1374,147.7Z"
          fill="#735dc9"
        />
        <path
          d="M1365.61,147.63s4.37,4.18,6.69,3.45,1.66-3.58,1.66-3.58S1366.6,147.76,1365.61,147.63Z"
          fill="#5243c8"
        />
        <ellipse cx="1364.11" cy="138.66" rx="4.51" ry="1.94" fill="#d199e4" />
        <ellipse cx="1367.2" cy="134.15" rx="2.01" ry="0.87" fill="#d199e4" />
        <ellipse cx="1372.06" cy="138.66" rx="2.01" ry="0.87" fill="#d199e4" />
        <path
          d="M1386.79,206.13h-28.64c-.71-.65-1.42-1.33-2.14-2l1-1c-.06-.47-.13-.63-.19-.33,0-.37-.11-3.11,0-4.91s.12-3,.09-3.52a8.24,8.24,0,0,1,.13,1.8c0-1.3.07-2.33.14-3a23.84,23.84,0,0,0,.09-3.06,51.57,51.57,0,0,1,.21,7.83,8.13,8.13,0,0,1,.16-1.51v.17c.14-2.87.26-4.83.22-5.87a28.24,28.24,0,0,1,.26,4.92c.09-3.07.25-5.34.42-6.57a45.41,45.41,0,0,0,.32-7c.16,0,.41,4.63.41,11.37a4.77,4.77,0,0,1,.18-.87,13.46,13.46,0,0,0,.34-3.79,56.41,56.41,0,0,1,.11,6.11c.11-.75.22-1.3.33-2.14a60.31,60.31,0,0,0,.46-8.22c0-.84.12-1.06.16-.51.06.84.11,1.75.14,2.71a16.66,16.66,0,0,1,.26,3.65c0-2.66.15-4.76.28-6a47.63,47.63,0,0,0,.19-6.24c.18-.32.6,6.34.43,16a19.21,19.21,0,0,1,.31-3.1c0,.11,0,.23,0,.36.29-5.85.53-9.84.45-12a58.19,58.19,0,0,1,.53,10c.18-6.25.5-10.87.86-13.38a91.85,91.85,0,0,0,.64-14.25c.33,0,.85,9.43.84,23.16a9.48,9.48,0,0,1,.36-1.76,27.3,27.3,0,0,0,.7-7.73,118.47,118.47,0,0,1,.23,12.44c.22-1.52.45-2.64.66-4.35a118.73,118.73,0,0,0,.94-16.75c0-1.71.25-2.16.33-1a189.67,189.67,0,0,1,.2,20.64c-.14,3.83-.33,7.05-.53,9.68l.26,0a.25.25,0,0,1,0-.08c.15-1.09.31-1.81.45-3a76.06,76.06,0,0,0,.59-10.52c0-1.08.15-1.36.21-.65a119.78,119.78,0,0,1,.12,13c0,.37,0,.72,0,1.07l.88-.08c0-.31,0-.6,0-.88.08-2.37.16-4,.13-4.65a11.18,11.18,0,0,1,.17,2.38c0-1.72.09-3.08.18-3.9a31.08,31.08,0,0,0,.12-4c.12-.21.39,4.1.28,10.32a12.18,12.18,0,0,1,.2-2,2,2,0,0,0,0,.23c.19-3.78.34-6.37.29-7.73a37.59,37.59,0,0,1,.34,6.48c.12-4,.33-7,.56-8.66a60.43,60.43,0,0,0,.41-9.21c.22,0,.55,6.1.54,15a6,6,0,0,1,.24-1.14,17.92,17.92,0,0,0,.45-5,78,78,0,0,1,.15,8c.14-1,.29-1.71.43-2.82a77.44,77.44,0,0,0,.61-10.83c0-1.11.15-1.4.21-.67a124.1,124.1,0,0,1,.13,13.35q-.13,3.57-.33,6.07l.17,0c.09-.66.19-1.13.28-1.86a49.12,49.12,0,0,0,.38-6.8c0-.7.1-.88.14-.42a77.78,77.78,0,0,1,.08,8.39c0,.31,0,.6,0,.9,4.49,1.21,8,4.12,11.64,7.77C1388.21,204.8,1387.5,205.48,1386.79,206.13Zm-26-7c0-.43,0-.88,0-1.34-.06.83-.11,1.56-.17,2.19l.11-.09C1360.72,199.64,1360.75,199.38,1360.77,199.14Z"
          fill="#8ac72f"
        />
      </g>
      <g>
        <ellipse cx="35.36" cy="224.29" rx="18.58" ry="9.04" fill="#72a139" />
        <path
          d="M17.31,227.4c.57,2.82,5.08,6.2,12.13,6.2s11-4.79,10.71-6.77-5.35-12.4-5.35-12.4S50.87,211,50.31,200.61s-1.7-21.43-19.18-24S2.08,184.25.39,194.4,2.65,211,8.85,213.86a22.73,22.73,0,0,0,11,2.26Z"
          fill="#f8e75b"
        />
        <path
          d="M40.15,226.83c-.25-1.78-4.44-10.52-5.23-12.14a78.76,78.76,0,0,1-15.08,1.49L17.31,227.4c.57,2.82,5.08,6.2,12.13,6.2S40.44,228.81,40.15,226.83Z"
          fill="#efc557"
        />
        <path
          d="M19.84,216.18s6.21,5.72,10.87,4.59,4.21-6.08,4.21-6.08S25,216.1,19.84,216.18Z"
          fill="#ca8e78"
        />
        <path
          d="M42.81,180.92c-2.72-2-6.47-3.53-11.68-4.28C16,174.44,5.26,181.78,1.58,190.4c10.51,13.1,21.09,15.11,35.47,6.26C45.66,191.37,45.62,185.68,42.81,180.92Z"
          fill="#c5d359"
        />
        <ellipse cx="12.52" cy="199.18" rx="8.84" ry="5.53" fill="#ffffcd" />
        <ellipse cx="14.59" cy="189.4" rx="3.74" ry="2.34" fill="#ffffcd" />
        <ellipse cx="23.92" cy="206.88" rx="3.74" ry="2.34" fill="#ffffcd" />
        <ellipse cx="34.26" cy="186.02" rx="7.16" ry="4.48" fill="#ffffcd" />
        <ellipse cx="38.52" cy="193.73" rx="3" ry="1.88" fill="#ffffcd" />
        <path
          d="M50.31,200.61a46.42,46.42,0,0,0-1.57-11.06c0,3.44-3.21,9.9-6.61,13.6-7,7.61-22.28,11.84-35.59,9.41a15.38,15.38,0,0,0,2.31,1.3,22.73,22.73,0,0,0,11,2.26l0,.14c7.22.7,15.1-1.57,15.1-1.57S50.87,211,50.31,200.61Z"
          fill="#eebf57"
        />
        <path
          d="M47.25,237.74,20,237.45l-2-.53,1-.24c-.06-.12-.12-.16-.18-.09a6.72,6.72,0,0,1,0-1.23,5.58,5.58,0,0,0,.1-.88.65.65,0,0,1,.12.46,2.54,2.54,0,0,1,.14-.74,1.58,1.58,0,0,0,.09-.77,3.48,3.48,0,0,1,.18,2,.65.65,0,0,1,.16-.37v0a6.33,6.33,0,0,0,.22-1.47,2,2,0,0,1,.24,1.24,4.78,4.78,0,0,1,.42-1.64,3.15,3.15,0,0,0,.32-1.75c.15,0,.38,1.16.36,2.85a.55.55,0,0,1,.17-.21,1.18,1.18,0,0,0,.34-1,4,4,0,0,1,.09,1.53c.1-.19.21-.32.31-.53a4.07,4.07,0,0,0,.46-2c0-.21.12-.27.16-.13a3.57,3.57,0,0,1,.12.68,1.27,1.27,0,0,1,.24.92,5.8,5.8,0,0,1,.28-1.51,3.08,3.08,0,0,0,.2-1.56c.18-.08.56,1.6.36,4a1.45,1.45,0,0,1,.32-.77v.08a13.3,13.3,0,0,0,.46-3,4.18,4.18,0,0,1,.48,2.51,10.12,10.12,0,0,1,.85-3.33,6.49,6.49,0,0,0,.65-3.56c.32,0,.79,2.37.74,5.8a1.19,1.19,0,0,1,.35-.44,2.3,2.3,0,0,0,.68-1.92,8,8,0,0,1,.19,3.11c.22-.38.44-.66.64-1.08a8.43,8.43,0,0,0,.94-4.18c0-.43.24-.54.31-.25a12.44,12.44,0,0,1,.14,5.16A18.16,18.16,0,0,1,30,235h.24v0c.15-.27.3-.45.44-.74a5.25,5.25,0,0,0,.59-2.62c0-.27.15-.34.2-.16a8,8,0,0,1,.09,3.24c0,.09,0,.18-.05.27l.84,0a1.64,1.64,0,0,1,0-.22,6.42,6.42,0,0,0,.12-1.16.77.77,0,0,1,.16.6,3.48,3.48,0,0,1,.18-1,1.92,1.92,0,0,0,.13-1,4.7,4.7,0,0,1,.24,2.58,1.05,1.05,0,0,1,.2-.5v.06a8.29,8.29,0,0,0,.3-1.93,2.72,2.72,0,0,1,.31,1.63,6.5,6.5,0,0,1,.55-2.16,4.21,4.21,0,0,0,.42-2.3c.2,0,.51,1.53.48,3.75a.75.75,0,0,1,.22-.28,1.5,1.5,0,0,0,.45-1.25,5.54,5.54,0,0,1,.12,2c.14-.24.28-.42.41-.69a5.48,5.48,0,0,0,.61-2.71c0-.27.15-.34.2-.16a8.11,8.11,0,0,1,.09,3.34,10.52,10.52,0,0,1-.33,1.51h.16c.09-.16.19-.28.28-.46a3.55,3.55,0,0,0,.38-1.7c0-.17.09-.22.12-.1a5,5,0,0,1,.06,2.1,1.7,1.7,0,0,1,0,.22,57.46,57.46,0,0,1,11.06,2.06C48.61,237.42,47.93,237.59,47.25,237.74Zm-24.75-2c0-.11,0-.22,0-.34a4.53,4.53,0,0,1-.17.55l.12,0Z"
          fill="#8ac72f"
        />
      </g>
      <g>
        <ellipse cx="1157.3" cy="495.46" rx="13.41" ry="12.29" fill="#faef88" />
        <ellipse cx="1176.66" cy="513.71" rx="10.76" ry="9.87" fill="#faef88" />
        <path
          d="M1181.5,483c0,7.33-10.67,13.27-23.83,13.27s-23.83-5.94-23.83-13.27,10.67-16,23.83-16S1181.5,475.71,1181.5,483Z"
          fill="#b42169"
        />
        <path
          d="M1190.44,507.74c0,4-5.78,7.19-12.91,7.19s-12.91-3.22-12.91-7.19,5.78-8.66,12.91-8.66S1190.44,503.77,1190.44,507.74Z"
          fill="#b42169"
        />
        <path
          d="M1185.34,522.67a5.26,5.26,0,0,0-3.24,3.21,16.37,16.37,0,0,0-.15-4.53l-1.69,2.73-.5-1.62a14.61,14.61,0,0,0-2.48,2.67,18.53,18.53,0,0,0-4.68-7.92c-1.41,1.88-.41,4.56-.75,6.89a.87.87,0,0,1-1.17.86,9.55,9.55,0,0,1-5.11-2.44l-.63,2.33a1.4,1.4,0,0,0-.62-1l-.42,1.61a4.72,4.72,0,0,0-6.41-.57c2.07,1.83,4.82,2.66,7.51,3.31a73.51,73.51,0,0,0,19.19,2.27c5.54-.19,5-4,5.66-8.56A11.39,11.39,0,0,0,1185.34,522.67Z"
          fill="#8ac72f"
        />
        <path
          d="M1164.12,494.32c-13.16,0-23.83-5.94-23.83-13.27,0-4.89,4.76-10.35,11.83-13.45-10.48,2-18.28,9.18-18.28,15.44,0,7.33,10.67,13.27,23.83,13.27a37.14,37.14,0,0,0,14.6-2.8A40.72,40.72,0,0,1,1164.12,494.32Z"
          fill="#9a1c5f"
        />
        <path
          d="M1182,513.62c-7.13,0-12.91-3.21-12.91-7.18,0-2.6,2.47-5.49,6.17-7.19-6,.85-10.64,4.95-10.64,8.49,0,4,5.78,7.19,12.91,7.19a20,20,0,0,0,8.1-1.6A22.34,22.34,0,0,1,1182,513.62Z"
          fill="#9a1c5f"
        />
        <ellipse cx="1163.63" cy="477.4" rx="8.56" ry="3.54" fill="#da53a7" />
        <ellipse cx="1183.64" cy="504.31" rx="3.02" ry="1.25" fill="#da53a7" />
        <ellipse cx="1167.72" cy="484.23" rx="3.97" ry="1.64" fill="#da53a7" />
        <ellipse cx="1151.09" cy="473.68" rx="3.97" ry="1.64" fill="#da53a7" />
      </g>
      {/* <g>
        <ellipse cx="1336.22" cy="514.51" rx="9" ry="8.25" fill="#faef88" />
        <ellipse cx="1349.22" cy="526.76" rx="7.23" ry="6.62" fill="#faef88" />
        <path
          d="M1352.47,506.17c0,4.92-7.16,8.91-16,8.91s-16-4-16-8.91,7.16-10.73,16-10.73S1352.47,501.25,1352.47,506.17Z"
          fill="#b42169"
        />
        <path
          d="M1358.47,522.75c0,2.67-3.88,4.83-8.67,4.83s-8.66-2.16-8.66-4.83,3.88-5.81,8.66-5.81S1358.47,520.09,1358.47,522.75Z"
          fill="#b42169"
        />
        <path
          d="M1355.05,532.77a3.52,3.52,0,0,0-2.17,2.16,11.06,11.06,0,0,0-.11-3l-1.13,1.84-.33-1.1a9.83,9.83,0,0,0-1.67,1.8,12.4,12.4,0,0,0-3.15-5.32c-.94,1.27-.27,3.06-.5,4.63a.73.73,0,0,1-.24.51.78.78,0,0,1-.54.07,6.42,6.42,0,0,1-3.43-1.65l-.43,1.57a.92.92,0,0,0-.41-.66l-.29,1.08a3.17,3.17,0,0,0-4.3-.39,11.42,11.42,0,0,0,5.05,2.22,49,49,0,0,0,12.88,1.53c3.72-.13,3.34-2.66,3.8-5.75A7.85,7.85,0,0,0,1355.05,532.77Z"
          fill="#8ac72f"
        />
        <path
          d="M1340.8,513.74c-8.83,0-16-4-16-8.91,0-3.28,3.2-6.94,8-9-7,1.32-12.28,6.16-12.28,10.37,0,4.92,7.16,8.91,16,8.91a25.08,25.08,0,0,0,9.81-1.88A27.38,27.38,0,0,1,1340.8,513.74Z"
          fill="#9a1c5f"
        />
        <path
          d="M1352.8,526.7c-4.78,0-8.66-2.16-8.66-4.82,0-1.74,1.66-3.69,4.14-4.83-4.06.57-7.14,3.33-7.14,5.7,0,2.67,3.88,4.83,8.66,4.83a13.46,13.46,0,0,0,5.45-1.08A14.91,14.91,0,0,1,1352.8,526.7Z"
          fill="#9a1c5f"
        />
        <ellipse cx="1340.47" cy="502.38" rx="5.75" ry="2.37" fill="#da53a7" />
        <ellipse cx="1353.91" cy="520.45" rx="2.03" ry="0.84" fill="#da53a7" />
        <ellipse cx="1343.22" cy="506.97" rx="2.66" ry="1.1" fill="#da53a7" />
        <ellipse cx="1332.05" cy="499.88" rx="2.66" ry="1.1" fill="#da53a7" />
      </g> */}
      <g>
        <ellipse cx="450.75" cy="497.11" rx="9" ry="8.25" fill="#faef88" />
        <ellipse cx="463.75" cy="509.36" rx="7.23" ry="6.62" fill="#faef88" />
        <path
          d="M467,488.77c0,4.92-7.16,8.91-16,8.91s-16-4-16-8.91S442.17,478,451,478,467,483.85,467,488.77Z"
          fill="#b42169"
        />
        <path
          d="M473,505.35c0,2.66-3.88,4.83-8.66,4.83s-8.67-2.17-8.67-4.83,3.88-5.81,8.67-5.81S473,502.68,473,505.35Z"
          fill="#b42169"
        />
        <path
          d="M469.58,515.37a3.52,3.52,0,0,0-2.17,2.16,11.06,11.06,0,0,0-.11-3l-1.13,1.83-.33-1.09a10.11,10.11,0,0,0-1.67,1.79,12.44,12.44,0,0,0-3.14-5.31c-.95,1.26-.28,3.06-.51,4.62a.73.73,0,0,1-.24.52.77.77,0,0,1-.54.06,6.34,6.34,0,0,1-3.43-1.64l-.42,1.57a1,1,0,0,0-.42-.67l-.29,1.08a3.16,3.16,0,0,0-4.29-.38,11.38,11.38,0,0,0,5,2.22,49,49,0,0,0,12.88,1.53c3.72-.13,3.34-2.66,3.8-5.75A7.67,7.67,0,0,0,469.58,515.37Z"
          fill="#8ac72f"
        />
        <path
          d="M455.34,496.34c-8.84,0-16-4-16-8.91,0-3.28,3.19-6.95,7.94-9-7,1.32-12.28,6.16-12.28,10.37,0,4.92,7.17,8.91,16,8.91a25.08,25.08,0,0,0,9.81-1.88A28.1,28.1,0,0,1,455.34,496.34Z"
          fill="#9a1c5f"
        />
        <path
          d="M467.34,509.3c-4.79,0-8.67-2.16-8.67-4.83,0-1.74,1.66-3.68,4.15-4.82-4.06.57-7.15,3.32-7.15,5.7,0,2.66,3.88,4.83,8.67,4.83a13.45,13.45,0,0,0,5.44-1.08A14.79,14.79,0,0,1,467.34,509.3Z"
          fill="#9a1c5f"
        />
        <ellipse cx="455" cy="484.98" rx="5.75" ry="2.37" fill="#da53a7" />
        <ellipse cx="468.44" cy="503.05" rx="2.03" ry="0.84" fill="#da53a7" />
        <ellipse cx="457.75" cy="489.57" rx="2.66" ry="1.1" fill="#da53a7" />
        <ellipse cx="446.59" cy="482.48" rx="2.66" ry="1.1" fill="#da53a7" />
      </g>
      {/* <g>
        <ellipse cx="242.24" cy="292.5" rx="14.46" ry="13.26" fill="#faef88" />
        <ellipse cx="263.13" cy="312.19" rx="11.61" ry="10.64" fill="#faef88" />
        <path
          d="M268.35,279.1c0,7.91-11.51,14.32-25.71,14.32S216.93,287,216.93,279.1s11.51-17.24,25.71-17.24S268.35,271.19,268.35,279.1Z"
          fill="#b42169"
        />
        <path
          d="M278,305.75c0,4.28-6.24,7.75-13.93,7.75s-13.93-3.47-13.93-7.75,6.24-9.34,13.93-9.34S278,301.46,278,305.75Z"
          fill="#b42169"
        />
        <path
          d="M272.49,321.85a5.71,5.71,0,0,0-3.48,3.46,18.05,18.05,0,0,0-.17-4.87L267,323.38l-.53-1.75a15.58,15.58,0,0,0-2.68,2.88,19.72,19.72,0,0,0-5.05-8.54c-1.52,2-.44,4.92-.81,7.43a1.13,1.13,0,0,1-.39.82,1.23,1.23,0,0,1-.87.11,10.31,10.31,0,0,1-5.51-2.64l-.68,2.51a1.5,1.5,0,0,0-.67-1.06l-.46,1.74a5.07,5.07,0,0,0-6.9-.62c2.23,2,5.2,2.87,8.1,3.57a78.92,78.92,0,0,0,20.7,2.45c6-.2,5.37-4.27,6.1-9.23A12.32,12.32,0,0,0,272.49,321.85Z"
          fill="#8ac72f"
        />
        <path
          d="M249.61,291.27c-14.2,0-25.71-6.41-25.71-14.31,0-5.28,5.13-11.17,12.76-14.52-11.31,2.12-19.73,9.9-19.73,16.66,0,7.91,11.51,14.32,25.71,14.32a40.24,40.24,0,0,0,15.76-3A44.86,44.86,0,0,1,249.61,291.27Z"
          fill="#9a1c5f"
        />
        <path
          d="M268.89,312.1c-7.69,0-13.93-3.48-13.93-7.76,0-2.8,2.68-5.92,6.67-7.75-6.53.92-11.49,5.34-11.49,9.16,0,4.28,6.24,7.75,13.93,7.75a21.62,21.62,0,0,0,8.75-1.72A24.91,24.91,0,0,1,268.89,312.1Z"
          fill="#9a1c5f"
        />
        <ellipse cx="249.07" cy="273.02" rx="9.24" ry="3.82" fill="#da53a7" />
        <ellipse cx="270.66" cy="302.05" rx="3.26" ry="1.35" fill="#da53a7" />
        <ellipse cx="253.49" cy="280.38" rx="4.28" ry="1.77" fill="#da53a7" />
        <ellipse cx="235.55" cy="269" rx="4.28" ry="1.77" fill="#da53a7" />
      </g> */}
      <g>
        <ellipse cx="915.52" cy="253.43" rx="9" ry="8.25" fill="#faef88" />
        <ellipse cx="928.52" cy="265.68" rx="7.23" ry="6.62" fill="#faef88" />
        <path
          d="M931.77,245.09c0,4.92-7.17,8.9-16,8.9s-16-4-16-8.9,7.16-10.73,16-10.73S931.77,240.17,931.77,245.09Z"
          fill="#b42169"
        />
        <path
          d="M937.77,261.67c0,2.66-3.88,4.82-8.67,4.82s-8.67-2.16-8.67-4.82,3.88-5.81,8.67-5.81S937.77,259,937.77,261.67Z"
          fill="#b42169"
        />
        <path
          d="M934.34,271.69a3.55,3.55,0,0,0-2.17,2.16,11.06,11.06,0,0,0-.1-3l-1.14,1.83-.33-1.09a10.11,10.11,0,0,0-1.67,1.79,12.24,12.24,0,0,0-3.14-5.31c-.95,1.26-.27,3.06-.5,4.62a.74.74,0,0,1-.25.52.76.76,0,0,1-.54.06,6.34,6.34,0,0,1-3.42-1.64l-.43,1.56a1,1,0,0,0-.41-.66l-.29,1.08a3.17,3.17,0,0,0-4.3-.38,11.43,11.43,0,0,0,5,2.22,49.14,49.14,0,0,0,12.88,1.53c3.72-.13,3.34-2.66,3.8-5.75A7.7,7.7,0,0,0,934.34,271.69Z"
          fill="#8ac72f"
        />
        <path
          d="M920.1,252.66c-8.84,0-16-4-16-8.91,0-3.28,3.2-6.95,7.94-9-7,1.32-12.27,6.16-12.27,10.37,0,4.92,7.16,8.9,16,8.9a25,25,0,0,0,9.8-1.87A28,28,0,0,1,920.1,252.66Z"
          fill="#9a1c5f"
        />
        <path
          d="M932.1,265.62c-4.79,0-8.67-2.16-8.67-4.83,0-1.74,1.67-3.68,4.15-4.82-4.06.57-7.15,3.32-7.15,5.7,0,2.66,3.88,4.82,8.67,4.82a13.45,13.45,0,0,0,5.44-1.07A14.7,14.7,0,0,1,932.1,265.62Z"
          fill="#9a1c5f"
        />
        <ellipse cx="919.77" cy="241.3" rx="5.75" ry="2.37" fill="#da53a7" />
        <ellipse cx="933.2" cy="259.37" rx="2.03" ry="0.84" fill="#da53a7" />
        <ellipse cx="922.52" cy="245.89" rx="2.66" ry="1.1" fill="#da53a7" />
        <ellipse cx="911.35" cy="238.8" rx="2.66" ry="1.1" fill="#da53a7" />
      </g>
      <g transform="translate(-20, -20)">
        <ellipse cx="1268.82" cy="32.69" rx="14.31" ry="13.12" fill="#faef88" />
        <ellipse cx="1289.49" cy="52.17" rx="11.49" ry="10.53" fill="#faef88" />
        <path
          d="M1294.66,19.43c0,7.82-11.39,14.16-25.44,14.16s-25.44-6.34-25.44-14.16,11.39-17.06,25.44-17.06S1294.66,11.6,1294.66,19.43Z"
          fill="#b42169"
        />
        <path
          d="M1304.2,45.8c0,4.23-6.17,7.67-13.78,7.67s-13.78-3.44-13.78-7.67,6.17-9.24,13.78-9.24S1304.2,41.56,1304.2,45.8Z"
          fill="#b42169"
        />
        <path
          d="M1298.76,61.73a5.64,5.64,0,0,0-3.45,3.43,17.76,17.76,0,0,0-.17-4.83l-1.81,2.92-.52-1.74a15.57,15.57,0,0,0-2.65,2.85,19.73,19.73,0,0,0-5-8.45c-1.51,2-.43,4.87-.8,7.35a1.21,1.21,0,0,1-.39.82,1.16,1.16,0,0,1-.86.1,10.13,10.13,0,0,1-5.45-2.61l-.68,2.49a1.5,1.5,0,0,0-.65-1.05l-.46,1.71a5,5,0,0,0-6.84-.6c2.21,1.95,5.15,2.84,8,3.53a78.19,78.19,0,0,0,20.48,2.42c5.92-.2,5.32-4.22,6-9.14A12.41,12.41,0,0,0,1298.76,61.73Z"
          fill="#8ac72f"
        />
        <path
          d="M1276.11,31.47c-14,0-25.44-6.34-25.44-14.16,0-5.22,5.08-11,12.63-14.37-11.19,2.1-19.52,9.8-19.52,16.49,0,7.82,11.39,14.16,25.44,14.16a39.67,39.67,0,0,0,15.59-3A43.2,43.2,0,0,1,1276.11,31.47Z"
          fill="#9a1c5f"
        />
        <path
          d="M1295.19,52.08c-7.61,0-13.78-3.44-13.78-7.68,0-2.76,2.64-5.85,6.59-7.66-6.45.9-11.36,5.28-11.36,9.06,0,4.23,6.17,7.67,13.78,7.67a21.34,21.34,0,0,0,8.66-1.71A23.29,23.29,0,0,1,1295.19,52.08Z"
          fill="#9a1c5f"
        />
        <ellipse cx="1275.58" cy="13.41" rx="9.14" ry="3.78" fill="#da53a7" />
        <ellipse cx="1296.95" cy="42.14" rx="3.23" ry="1.33" fill="#da53a7" />
        <ellipse cx="1279.95" cy="20.7" rx="4.24" ry="1.75" fill="#da53a7" />
        <ellipse cx="1262.2" cy="9.43" rx="4.24" ry="1.75" fill="#da53a7" />
      </g>
      <g>
        <ellipse cx="794.44" cy="156.93" rx="11.85" ry="10.86" fill="#faef88" />
        <ellipse cx="811.56" cy="173.06" rx="9.52" ry="8.72" fill="#faef88" />
        <path
          d="M815.84,146c0,6.48-9.43,11.73-21.07,11.73S773.7,152.43,773.7,146s9.43-14.13,21.07-14.13S815.84,139.47,815.84,146Z"
          fill="#b42169"
        />
        <path
          d="M823.74,167.78c0,3.51-5.11,6.36-11.41,6.36s-11.42-2.85-11.42-6.36,5.11-7.65,11.42-7.65S823.74,164.27,823.74,167.78Z"
          fill="#b42169"
        />
        <path
          d="M819.23,181a4.66,4.66,0,0,0-2.86,2.84,14.5,14.5,0,0,0-.14-4l-1.49,2.41-.44-1.43a12.92,12.92,0,0,0-2.19,2.36,16.27,16.27,0,0,0-4.14-7c-1.25,1.66-.36,4-.67,6.09a.91.91,0,0,1-.32.67,1,1,0,0,1-.71.09,8.44,8.44,0,0,1-4.51-2.16l-.56,2.06a1.25,1.25,0,0,0-.55-.87l-.37,1.42a4.16,4.16,0,0,0-5.66-.5,15.13,15.13,0,0,0,6.63,2.92,65.14,65.14,0,0,0,17,2c4.89-.17,4.4-3.5,5-7.57A10.12,10.12,0,0,0,819.23,181Z"
          fill="#8ac72f"
        />
        <path
          d="M800.48,155.92c-11.64,0-21.07-5.25-21.07-11.73,0-4.32,4.21-9.15,10.45-11.89C780.6,134,773.7,140.41,773.7,146c0,6.48,9.43,11.73,21.07,11.73a32.82,32.82,0,0,0,12.91-2.48A36,36,0,0,1,800.48,155.92Z"
          fill="#9a1c5f"
        />
        <path
          d="M816.28,173c-6.31,0-11.42-2.85-11.42-6.36,0-2.29,2.19-4.85,5.46-6.35-5.34.75-9.41,4.38-9.41,7.5,0,3.51,5.11,6.36,11.42,6.36a17.74,17.74,0,0,0,7.16-1.41A20.76,20.76,0,0,1,816.28,173Z"
          fill="#9a1c5f"
        />
        <ellipse cx="800.04" cy="140.96" rx="7.57" ry="3.13" fill="#da53a7" />
        <ellipse cx="817.73" cy="164.75" rx="2.67" ry="1.1" fill="#da53a7" />
        <ellipse cx="803.66" cy="147" rx="3.51" ry="1.45" fill="#da53a7" />
        <ellipse cx="788.95" cy="137.67" rx="3.51" ry="1.45" fill="#da53a7" />
      </g>
      <g>
        <ellipse cx="347.91" cy="147.86" rx="9" ry="8.25" fill="#faef88" />
        <ellipse cx="360.91" cy="160.11" rx="7.23" ry="6.62" fill="#faef88" />
        <path
          d="M364.16,139.52c0,4.92-7.16,8.91-16,8.91s-16-4-16-8.91,7.16-10.73,16-10.73S364.16,134.6,364.16,139.52Z"
          fill="#b42169"
        />
        <path
          d="M370.16,156.1c0,2.67-3.88,4.83-8.67,4.83s-8.66-2.16-8.66-4.83,3.88-5.81,8.66-5.81S370.16,153.44,370.16,156.1Z"
          fill="#b42169"
        />
        <path
          d="M366.74,166.12a3.5,3.5,0,0,0-2.17,2.16,11.47,11.47,0,0,0-.11-3l-1.13,1.83L363,166a10.43,10.43,0,0,0-1.66,1.79,12.42,12.42,0,0,0-3.15-5.31c-.94,1.26-.27,3.06-.5,4.62a.73.73,0,0,1-.24.52.79.79,0,0,1-.55.06,6.34,6.34,0,0,1-3.42-1.64l-.43,1.57a1,1,0,0,0-.41-.67l-.29,1.08a3.18,3.18,0,0,0-4.3-.38,11.43,11.43,0,0,0,5,2.22A49.17,49.17,0,0,0,366,171.37c3.71-.13,3.34-2.66,3.8-5.75A7.64,7.64,0,0,0,366.74,166.12Z"
          fill="#8ac72f"
        />
        <path
          d="M352.49,147.09c-8.83,0-16-4-16-8.91,0-3.28,3.2-7,7.94-9-7,1.32-12.27,6.16-12.27,10.37,0,4.92,7.16,8.91,16,8.91a25.08,25.08,0,0,0,9.81-1.88A28.13,28.13,0,0,1,352.49,147.09Z"
          fill="#9a1c5f"
        />
        <path
          d="M364.49,160.05c-4.78,0-8.66-2.16-8.66-4.82,0-1.75,1.66-3.69,4.14-4.83-4.06.57-7.14,3.32-7.14,5.7,0,2.67,3.88,4.83,8.66,4.83a13.46,13.46,0,0,0,5.45-1.08A14.91,14.91,0,0,1,364.49,160.05Z"
          fill="#9a1c5f"
        />
        <ellipse cx="352.16" cy="135.73" rx="5.75" ry="2.37" fill="#da53a7" />
        <ellipse cx="365.6" cy="153.8" rx="2.03" ry="0.84" fill="#da53a7" />
        <ellipse cx="354.91" cy="140.32" rx="2.66" ry="1.1" fill="#da53a7" />
        <ellipse cx="343.74" cy="133.23" rx="2.66" ry="1.1" fill="#da53a7" />
      </g>
      <g>
        <ellipse cx="58.36" cy="106.81" rx="10.61" ry="4.65" fill="#72a139" />
        <path
          d="M51,62.39c-.17,3.11.32,10.31-1.8,14.73s-5.4,6.54-3.11,12.44,2.13,13.91,1.63,15.71-.65,2.45-.65,2.45a2.18,2.18,0,0,0,2.29.9c1.64-.24,2.54-2.45,2.62-3.68A45.62,45.62,0,0,0,51.74,92,51.61,51.61,0,0,1,50.43,81c-.08-3.6,1.56-5.72,2-8.42s.9-10,.9-10,5.48.66,6.14-.08c.65-1.63.41-7.2-6.55-6.87s-8.43,5.07-8.1,6.38S51,62.39,51,62.39Z"
          fill="#c53964"
        />
        <path
          d="M53.38,62.55s5.48.66,6.14-.08c.65-1.63.41-7.2-6.55-6.87s-8.43,5.07-8.1,6.38,6.14.41,6.14.41a.86.86,0,0,0,0,.16,7.24,7.24,0,0,1,1.15.09l1.22.16C53.38,62.64,53.38,62.55,53.38,62.55Z"
          fill="#c53964"
        />
        <path
          d="M51,62.39a6.74,6.74,0,0,1,2.37.16s-.49,9.09-1,10.56C51.66,63.7,51,62.39,51,62.39Z"
          fill="#a03964"
        />
        <path
          d="M50,111.32c0,1.64,1.63,2.37,3.51,2.62s5.08-.25,5.24-1.47,0-22.5-.49-23.57c1.47-.33,5.15-1.55,4.91-4.09s-1.8-6.06-7-6.55-8.83,2-8.34,5.4S53.13,89,53.13,89a49.64,49.64,0,0,1,.74,8.43C54,102.65,50,111.32,50,111.32Z"
          fill="#9a7ce3"
        />
        <path
          d="M51.74,55.6c-1.53.25-4.09,1.14-4.82,2.37s2.7,2.29,5.31,2.05,6.14.57,6.39-1-.33-2.45-2-3A9.84,9.84,0,0,0,51.74,55.6Z"
          fill="#c9679b"
        />
        <ellipse cx="49.04" cy="59.72" rx="1.64" ry="0.82" fill="#dfd5b0" />
        <ellipse cx="50.84" cy="58.38" rx="0.78" ry="0.39" fill="#dfd5b0" />
        <ellipse cx="48.23" cy="58.13" rx="1.06" ry="0.53" fill="#dfd5b0" />
        <ellipse cx="55.7" cy="60.29" rx="1.5" ry="0.75" fill="#dfd5b0" />
        <ellipse cx="57.56" cy="58.97" rx="0.65" ry="0.32" fill="#dfd5b0" />
        <ellipse cx="53.24" cy="56.95" rx="1.39" ry="0.69" fill="#dfd5b0" />
        <path
          d="M53.54,113.94c1.89.25,5.08-.25,5.24-1.47s0-21.08-.44-23.39c-1.93,0-4.44-.24-5.82-.39.37.19.61.29.61.29a49.64,49.64,0,0,1,.74,8.43C54,102.65,50,111.32,50,111.32,50,113,51.66,113.69,53.54,113.94Z"
          fill="#806ce3"
        />
        <path
          d="M58.33,89l0-.12c1.47-.33,5.16-1.55,4.91-4.09a7.59,7.59,0,0,0-1.33-3.65c-.14,4.8-6.28,6.92-12.75,5a11.42,11.42,0,0,0,3.37,2.53l.64.3S55.74,89.14,58.33,89Z"
          fill="#735dc9"
        />
        <path
          d="M53.13,89s2.71,2.58,4.14,2.13,1-2.21,1-2.21S53.75,89.07,53.13,89Z"
          fill="#5243c8"
        />
        <ellipse cx="52.21" cy="83.45" rx="2.78" ry="1.2" fill="#d199e4" />
        <ellipse cx="54.12" cy="80.66" rx="1.24" ry="0.53" fill="#d199e4" />
        <ellipse cx="57.12" cy="83.45" rx="1.24" ry="0.53" fill="#d199e4" />
        <path
          d="M66.21,133.58H48.53q-.66-1-1.32-2l.64-1c0-.47-.08-.64-.11-.33,0-.37-.07-3.11,0-4.91s.08-3,.06-3.52a13.84,13.84,0,0,1,.08,1.8c0-1.3,0-2.34.08-3s.1-2.09.06-3.06c.06-.16.19,3.11.13,7.83a13.88,13.88,0,0,1,.1-1.51V124c.09-2.87.16-4.83.13-5.87a45.75,45.75,0,0,1,.17,4.92c.05-3.07.15-5.34.26-6.57s.27-4.4.19-7c.1,0,.26,4.62.25,11.37a6.61,6.61,0,0,1,.12-.87,22,22,0,0,0,.21-3.79c.05.35.09,2.84.07,6.11.06-.75.13-1.3.2-2.14.25-3.42.26-4.7.28-8.22,0-.84.08-1.06.1-.51,0,.84.07,1.75.09,2.71a27.27,27.27,0,0,1,.16,3.65c0-2.66.09-4.76.17-6s.2-4.27.12-6.24c.11-.32.37,6.34.26,16a29.58,29.58,0,0,1,.2-3.09v.36c.18-5.85.33-9.84.28-12a95.43,95.43,0,0,1,.33,10c.11-6.25.31-10.88.52-13.38s.55-9,.4-14.25c.21,0,.53,9.43.52,23.16a14.87,14.87,0,0,1,.22-1.76,43.3,43.3,0,0,0,.43-7.73c.11.71.2,5.78.15,12.44.13-1.52.28-2.64.41-4.35.52-7,.53-9.57.58-16.75,0-1.71.15-2.16.2-1,.26,5.61.31,12.6.12,20.64-.09,3.82-.2,7-.33,9.68l.16,0a.22.22,0,0,0,0-.08c.09-1.09.19-1.81.28-3,.33-4.37.33-6,.36-10.52,0-1.08.1-1.36.13-.66.16,3.52.2,7.92.08,13,0,.37,0,.72,0,1.07l.54-.08c0-.31,0-.61,0-.88,0-2.38.1-4,.08-4.65a18.66,18.66,0,0,1,.11,2.38c0-1.72,0-3.08.11-3.9s.12-2.76.07-4c.08-.21.24,4.1.17,10.31a17.58,17.58,0,0,1,.13-2v.22c.12-3.78.21-6.36.18-7.73a58.34,58.34,0,0,1,.21,6.49c.08-4,.2-7,.34-8.66s.36-5.79.26-9.21c.13,0,.34,6.09.34,15a9.79,9.79,0,0,1,.14-1.14,27.16,27.16,0,0,0,.28-5c.07.46.13,3.74.09,8,.09-1,.18-1.7.27-2.81.34-4.5.34-6.19.37-10.83,0-1.11.1-1.4.13-.67.17,3.62.2,8.14.08,13.35q-.08,3.56-.2,6.07l.1,0c.06-.66.12-1.13.18-1.86.21-2.83.22-3.89.23-6.8,0-.7.07-.88.09-.42.1,2.27.12,5.11,0,8.38,0,.32,0,.61,0,.91,2.78,1.21,4.92,4.12,7.19,7.77Q66.87,132.61,66.21,133.58Zm-16.06-7c0-.44,0-.88,0-1.34,0,.83-.07,1.55-.11,2.19l.08-.09C50.12,127.08,50.13,126.83,50.15,126.59Z"
          fill="#68c902"
        />
      </g>
      <g>
        <ellipse cx="1455.09" cy="323.92" rx="18.24" ry="8.87" fill="#72a139" />
        <path
          d="M1437.37,327c.55,2.77,5,6.09,11.91,6.09s10.8-4.71,10.52-6.64-5.26-12.19-5.26-12.19,15.78-3.32,15.23-13.56-1.66-21.05-18.83-23.54-28.52,7.48-30.18,17.44,2.21,16.34,8.3,19.11a22.22,22.22,0,0,0,10.8,2.21Z"
          fill="#f8e75b"
        />
        <path
          d="M1459.8,326.43c-.25-1.76-4.37-10.34-5.14-11.93a78.13,78.13,0,0,1-14.81,1.47l-2.48,11c.55,2.77,5,6.09,11.91,6.09S1460.08,328.36,1459.8,326.43Z"
          fill="#efc557"
        />
        <path
          d="M1439.85,316s6.1,5.61,10.67,4.5,4.14-6,4.14-6S1445,315.89,1439.85,316Z"
          fill="#ca8e78"
        />
        <path
          d="M1462.41,281.35c-2.68-2-6.36-3.47-11.47-4.21-14.89-2.16-25.4,5.05-29,13.51,10.31,12.87,20.71,14.84,34.82,6.15C1465.2,291.6,1465.16,286,1462.41,281.35Z"
          fill="#c5d359"
        />
        <ellipse cx="1432.66" cy="299.27" rx="8.68" ry="5.43" fill="#ffffcd" />
        <ellipse cx="1434.69" cy="289.68" rx="3.67" ry="2.3" fill="#ffffcd" />
        <ellipse cx="1443.86" cy="306.84" rx="3.67" ry="2.3" fill="#ffffcd" />
        <ellipse cx="1454.01" cy="286.35" rx="7.03" ry="4.4" fill="#ffffcd" />
        <ellipse cx="1458.19" cy="293.92" rx="2.95" ry="1.85" fill="#ffffcd" />
        <path
          d="M1469.77,300.68a45.25,45.25,0,0,0-1.54-10.86c0,3.38-3.16,9.72-6.49,13.35-6.88,7.47-21.88,11.63-35,9.24a15.36,15.36,0,0,0,2.27,1.28,22.22,22.22,0,0,0,10.8,2.21l0,.14c7.09.69,14.83-1.54,14.83-1.54S1470.32,310.92,1469.77,300.68Z"
          fill="#eebf57"
        />
        <path
          d="M1466.77,337.23,1440,337l-2-.53c.33-.09.65-.17,1-.24-.06-.12-.12-.16-.18-.09a6.72,6.72,0,0,1,0-1.23,5.58,5.58,0,0,0,.1-.88.65.65,0,0,1,.12.46,2.6,2.6,0,0,1,.13-.74,1.57,1.57,0,0,0,.1-.77,3.66,3.66,0,0,1,.17,2,.9.9,0,0,1,.15-.38v.05a6.53,6.53,0,0,0,.23-1.47,2.08,2.08,0,0,1,.23,1.24,4.82,4.82,0,0,1,.41-1.64,3.16,3.16,0,0,0,.31-1.75c.16,0,.38,1.16.36,2.85a.47.47,0,0,1,.17-.21,1.18,1.18,0,0,0,.33-.95,4,4,0,0,1,.09,1.53c.1-.19.21-.32.31-.53a4.28,4.28,0,0,0,.45-2.05c0-.21.11-.27.15-.13a3.57,3.57,0,0,1,.12.68,1.25,1.25,0,0,1,.24.91,5.46,5.46,0,0,1,.27-1.5,3.19,3.19,0,0,0,.2-1.56c.17-.08.55,1.59.35,4a1.57,1.57,0,0,1,.31-.76v.08a13.3,13.3,0,0,0,.46-3,4.27,4.27,0,0,1,.47,2.51,10.22,10.22,0,0,1,.83-3.33,6.51,6.51,0,0,0,.64-3.56c.31,0,.77,2.37.72,5.8a1.43,1.43,0,0,1,.35-.44,2.3,2.3,0,0,0,.67-1.92,8.27,8.27,0,0,1,.18,3.11c.22-.38.43-.66.63-1.08a8.56,8.56,0,0,0,.93-4.18c0-.43.23-.54.31-.26a13.05,13.05,0,0,1,.13,5.17,20.09,20.09,0,0,1-.52,2.41h.24v0c.14-.27.29-.45.43-.74a5.48,5.48,0,0,0,.58-2.63c0-.26.14-.33.19-.16a7.87,7.87,0,0,1,.08,3.25,2.34,2.34,0,0,1,0,.26h.82a1.5,1.5,0,0,1,0-.22,8.13,8.13,0,0,0,.13-1.16.85.85,0,0,1,.15.6,3.65,3.65,0,0,1,.18-1,2.08,2.08,0,0,0,.13-1,4.88,4.88,0,0,1,.23,2.58,1.09,1.09,0,0,1,.19-.5v.06a8.29,8.29,0,0,0,.3-1.93,2.64,2.64,0,0,1,.3,1.62,7,7,0,0,1,.54-2.15,4.23,4.23,0,0,0,.42-2.3c.2,0,.5,1.53.46,3.75a.81.81,0,0,1,.23-.29,1.51,1.51,0,0,0,.43-1.24,5.3,5.3,0,0,1,.12,2,7.6,7.6,0,0,0,.41-.7,5.66,5.66,0,0,0,.6-2.7c0-.28.15-.35.19-.17a8.11,8.11,0,0,1,.09,3.34,12,12,0,0,1-.32,1.52h.15c.09-.17.19-.28.27-.46a3.57,3.57,0,0,0,.38-1.7c0-.18.09-.22.12-.11a5.16,5.16,0,0,1,.06,2.1c0,.08,0,.15,0,.23a55.6,55.6,0,0,1,10.86,2.06Zm-24.3-2c0-.11,0-.22,0-.34-.06.21-.11.39-.17.55l.11,0A1.07,1.07,0,0,1,1442.47,335.23Z"
          fill="#8ac72f"
        />
      </g>
      <g>
        <ellipse cx="1430.59" cy="375.45" rx="9.24" ry="4.49" fill="#72a139" />
        <path
          d="M1421.61,377c.28,1.4,2.53,3.09,6,3.09s5.47-2.39,5.33-3.37a57.4,57.4,0,0,0-2.66-6.17s8-1.68,7.71-6.87-.84-10.67-9.54-11.93-14.44,3.79-15.29,8.84,1.13,8.28,4.21,9.68a11.3,11.3,0,0,0,5.47,1.12Z"
          fill="#f8e75b"
        />
        <path
          d="M1433,376.72a51.6,51.6,0,0,0-2.6-6,39.35,39.35,0,0,1-7.5.74l-1.26,5.58c.28,1.4,2.53,3.09,6,3.09S1433.11,377.7,1433,376.72Z"
          fill="#efc557"
        />
        <path
          d="M1422.87,371.42s3.09,2.85,5.4,2.29a2.86,2.86,0,0,0,2.1-3S1425.45,371.38,1422.87,371.42Z"
          fill="#ca8e78"
        />
        <path
          d="M1434.29,353.88a12.63,12.63,0,0,0-5.81-2.13c-7.54-1.09-12.86,2.56-14.69,6.85,5.22,6.52,10.49,7.51,17.64,3.11C1435.71,359.08,1435.69,356.25,1434.29,353.88Z"
          fill="#c5d359"
        />
        <ellipse cx="1419.23" cy="362.97" rx="4.4" ry="2.75" fill="#ffffcd" />
        <ellipse cx="1420.25" cy="358.1" rx="1.86" ry="1.16" fill="#ffffcd" />
        <ellipse cx="1424.9" cy="366.8" rx="1.86" ry="1.16" fill="#ffffcd" />
        <ellipse cx="1430.04" cy="356.42" rx="3.56" ry="2.23" fill="#ffffcd" />
        <ellipse cx="1432.16" cy="360.25" rx="1.49" ry="0.94" fill="#ffffcd" />
        <path
          d="M1438,363.68a22.68,22.68,0,0,0-.78-5.5c0,1.71-1.59,4.92-3.29,6.76-3.48,3.79-11.08,5.89-17.7,4.68a8.1,8.1,0,0,0,1.15.65,11.3,11.3,0,0,0,5.47,1.12v.07a23.34,23.34,0,0,0,7.51-.78S1438.3,368.87,1438,363.68Z"
          fill="#eebf57"
        />
        <path
          d="M1436.47,384.93l-13.56-.14-1-.52.5-.25c0-.12-.06-.16-.09-.08a11.25,11.25,0,0,1,0-1.23c0-.45.06-.76,0-.88a1.23,1.23,0,0,1,.06.45,5,5,0,0,1,.07-.74,2.93,2.93,0,0,0,0-.76,6.35,6.35,0,0,1,.08,2,1.17,1.17,0,0,1,.08-.38v0a11,11,0,0,0,.12-1.47,3.78,3.78,0,0,1,.11,1.24,8.57,8.57,0,0,1,.22-1.64,6.26,6.26,0,0,0,.17-1.75,11.84,11.84,0,0,1,.16,2.84.72.72,0,0,1,.09-.21,2,2,0,0,0,.17-1,7.67,7.67,0,0,1,0,1.53c0-.19.11-.32.16-.53a8.41,8.41,0,0,0,.24-2.06c0-.21.06-.26.07-.12a6.67,6.67,0,0,1,.06.67,2.19,2.19,0,0,1,.12.92,10.33,10.33,0,0,1,.14-1.51,5.72,5.72,0,0,0,.11-1.56,14,14,0,0,1,.16,4,2.66,2.66,0,0,1,.16-.77v.09a25.24,25.24,0,0,0,.25-3,7.71,7.71,0,0,1,.22,2.5,20.08,20.08,0,0,1,.44-3.34,12,12,0,0,0,.35-3.55c.15,0,.37,2.36.33,5.79a1.49,1.49,0,0,1,.18-.44,3.88,3.88,0,0,0,.35-1.93,16.3,16.3,0,0,1,.07,3.11c.11-.38.23-.65.33-1.08A15.89,15.89,0,0,0,1428,375c0-.43.12-.54.16-.26a25.61,25.61,0,0,1,0,5.16c-.08.95-.18,1.76-.28,2.42h.12v0c.07-.28.15-.46.22-.75a10.49,10.49,0,0,0,.31-2.62c0-.27.07-.34.1-.17a16.48,16.48,0,0,1,0,3.25c0,.09,0,.17,0,.26h.41a1.7,1.7,0,0,0,0-.22c0-.6.09-1,.07-1.16a1.37,1.37,0,0,1,.08.59,7.46,7.46,0,0,1,.09-1,3.51,3.51,0,0,0,.07-1,8.88,8.88,0,0,1,.11,2.58,1.71,1.71,0,0,1,.1-.5v.06a17,17,0,0,0,.16-1.93,5.25,5.25,0,0,1,.15,1.62,11.86,11.86,0,0,1,.28-2.16,7.94,7.94,0,0,0,.22-2.3,14.59,14.59,0,0,1,.22,3.75,1.36,1.36,0,0,1,.11-.29,2.44,2.44,0,0,0,.23-1.25,10.48,10.48,0,0,1,0,2c.07-.25.14-.43.21-.71a10.61,10.61,0,0,0,.32-2.7c0-.28.07-.35.1-.17a15.93,15.93,0,0,1,0,3.34c0,.6-.1,1.1-.17,1.52h.08c.05-.17.1-.28.14-.47a6.43,6.43,0,0,0,.2-1.7c0-.17,0-.22.06-.1a9.6,9.6,0,0,1,0,2.1c0,.07,0,.15,0,.22a16.45,16.45,0,0,1,5.49,2C1437.15,384.61,1436.81,384.77,1436.47,384.93Zm-12.3-1.88v-.33c0,.21-.06.39-.09.55l.06,0Z"
          fill="#8ac72f"
        />
      </g>
      <g>
        <ellipse cx="1052.1" cy="445.89" rx="18.24" ry="8.87" fill="#72a139" />
        <path
          d="M1034.38,449c.56,2.77,5,6.09,11.91,6.09s10.8-4.71,10.52-6.64-5.26-12.19-5.26-12.19,15.78-3.32,15.23-13.56-1.66-21-18.83-23.54-28.52,7.48-30.18,17.44,2.21,16.34,8.31,19.11a22.18,22.18,0,0,0,10.79,2.21Z"
          fill="#f8e75b"
        />
        <path
          d="M1056.81,448.4c-.25-1.76-4.37-10.34-5.14-11.93a78.13,78.13,0,0,1-14.81,1.47l-2.48,11c.56,2.77,5,6.09,11.91,6.09S1057.09,450.33,1056.81,448.4Z"
          fill="#efc557"
        />
        <path
          d="M1036.86,437.94s6.11,5.61,10.67,4.5,4.14-6,4.14-6S1042,437.86,1036.86,437.94Z"
          fill="#ca8e78"
        />
        <path
          d="M1059.42,403.32c-2.68-2-6.36-3.47-11.47-4.21-14.89-2.16-25.4,5.05-29,13.51,10.32,12.87,20.71,14.84,34.82,6.15C1062.21,413.57,1062.17,408,1059.42,403.32Z"
          fill="#c5d359"
        />
        <ellipse cx="1029.67" cy="421.24" rx="8.68" ry="5.43" fill="#ffffcd" />
        <ellipse cx="1031.71" cy="411.65" rx="3.67" ry="2.3" fill="#ffffcd" />
        <ellipse cx="1040.87" cy="428.81" rx="3.67" ry="2.3" fill="#ffffcd" />
        <ellipse cx="1051.02" cy="408.32" rx="7.03" ry="4.4" fill="#ffffcd" />
        <ellipse cx="1055.2" cy="415.89" rx="2.95" ry="1.85" fill="#ffffcd" />
        <path
          d="M1066.78,422.65a45.25,45.25,0,0,0-1.54-10.86c0,3.38-3.16,9.72-6.49,13.35-6.88,7.47-21.88,11.63-35,9.24a15,15,0,0,0,2.28,1.28,22.18,22.18,0,0,0,10.79,2.21l0,.14c7.09.69,14.83-1.54,14.83-1.54S1067.33,432.89,1066.78,422.65Z"
          fill="#eebf57"
        />
        <path
          d="M1063.78,459.2l-26.77-.28-2-.53c.33-.09.65-.17,1-.24-.06-.12-.12-.16-.18-.09a6.72,6.72,0,0,1,0-1.23,5.58,5.58,0,0,0,.1-.88.65.65,0,0,1,.12.46,2.6,2.6,0,0,1,.13-.74,1.57,1.57,0,0,0,.1-.77,3.66,3.66,0,0,1,.17,2,.9.9,0,0,1,.15-.38v0a6.53,6.53,0,0,0,.23-1.47,2.08,2.08,0,0,1,.23,1.24,4.82,4.82,0,0,1,.41-1.64,3.16,3.16,0,0,0,.31-1.75c.16,0,.38,1.16.36,2.85a.47.47,0,0,1,.17-.21,1.18,1.18,0,0,0,.33-.95,4,4,0,0,1,.09,1.53c.1-.19.21-.32.31-.53a4.28,4.28,0,0,0,.45-2.05c0-.21.11-.27.15-.13a3.57,3.57,0,0,1,.12.68,1.25,1.25,0,0,1,.24.91,5.46,5.46,0,0,1,.27-1.5,3.19,3.19,0,0,0,.2-1.56c.17-.08.55,1.59.35,4a1.57,1.57,0,0,1,.31-.76v.08a13.3,13.3,0,0,0,.46-3,4.19,4.19,0,0,1,.47,2.51,10.48,10.48,0,0,1,.83-3.33,6.51,6.51,0,0,0,.64-3.56c.31,0,.77,2.37.72,5.8a1.43,1.43,0,0,1,.35-.44,2.3,2.3,0,0,0,.67-1.92,8.27,8.27,0,0,1,.18,3.11c.22-.38.43-.66.63-1.08a8.56,8.56,0,0,0,.93-4.18c0-.43.23-.54.31-.26a13,13,0,0,1,.13,5.16,18.14,18.14,0,0,1-.52,2.42h.24v0c.14-.27.29-.45.43-.74a5.48,5.48,0,0,0,.58-2.63c0-.26.14-.33.19-.16a8,8,0,0,1,.09,3.25c0,.09,0,.17-.05.26h.82c0-.08,0-.15,0-.22a8.13,8.13,0,0,0,.13-1.16.85.85,0,0,1,.15.6,3.65,3.65,0,0,1,.18-1,2.08,2.08,0,0,0,.13-1,4.88,4.88,0,0,1,.23,2.58,1.09,1.09,0,0,1,.19-.5v.06a8.29,8.29,0,0,0,.3-1.93,2.71,2.71,0,0,1,.31,1.62,6.79,6.79,0,0,1,.53-2.15,4.23,4.23,0,0,0,.42-2.3c.2,0,.5,1.53.46,3.75a.81.81,0,0,1,.23-.29,1.51,1.51,0,0,0,.43-1.24,5.05,5.05,0,0,1,.12,2,7.6,7.6,0,0,0,.41-.7,5.66,5.66,0,0,0,.6-2.7c0-.28.15-.35.19-.17a8.11,8.11,0,0,1,.09,3.34,12,12,0,0,1-.32,1.52h.16c.09-.17.18-.28.26-.46a3.57,3.57,0,0,0,.38-1.7c0-.18.09-.22.12-.11a5.16,5.16,0,0,1,.06,2.1c0,.08,0,.15,0,.23a55.6,55.6,0,0,1,10.86,2.06Zm-24.3-2c0-.11,0-.22,0-.34-.06.21-.11.39-.17.55l.11,0A1.07,1.07,0,0,1,1039.48,457.2Z"
          fill="#8ac72f"
        />
      </g>
      <g>
        <ellipse cx="1435.77" cy="72.71" rx="18.24" ry="8.87" fill="#72a139" />
        <path
          d="M1418.06,75.76c.55,2.77,5,6.09,11.9,6.09s10.8-4.7,10.52-6.64S1435.22,63,1435.22,63s15.79-3.32,15.23-13.56-1.66-21-18.83-23.54-28.51,7.48-30.18,17.45,2.22,16.33,8.31,19.1a22.3,22.3,0,0,0,10.8,2.22Z"
          fill="#f8e75b"
        />
        <path
          d="M1440.48,75.21c-.25-1.76-4.36-10.33-5.13-11.93a77.41,77.41,0,0,1-14.82,1.47l-2.47,11c.55,2.77,5,6.09,11.9,6.09S1440.76,77.15,1440.48,75.21Z"
          fill="#efc557"
        />
        <path
          d="M1420.53,64.75s6.11,5.61,10.68,4.5,4.14-6,4.14-6S1425.64,64.67,1420.53,64.75Z"
          fill="#ca8e78"
        />
        <path
          d="M1443.09,30.13c-2.67-2-6.35-3.47-11.47-4.21-14.89-2.16-25.4,5-29,13.51,10.32,12.87,20.71,14.84,34.83,6.15C1445.88,40.38,1445.85,34.8,1443.09,30.13Z"
          fill="#c5d359"
        />
        <ellipse cx="1413.35" cy="48.06" rx="8.68" ry="5.43" fill="#ffffcd" />
        <ellipse cx="1415.38" cy="38.46" rx="3.67" ry="2.3" fill="#ffffcd" />
        <ellipse cx="1424.54" cy="55.62" rx="3.67" ry="2.3" fill="#ffffcd" />
        <ellipse cx="1434.69" cy="35.13" rx="7.03" ry="4.4" fill="#ffffcd" />
        <ellipse cx="1438.88" cy="42.71" rx="2.95" ry="1.85" fill="#ffffcd" />
        <path
          d="M1450.45,49.46a44.76,44.76,0,0,0-1.54-10.86c0,3.38-3.15,9.72-6.49,13.35-6.88,7.47-21.87,11.63-34.94,9.25a15.2,15.2,0,0,0,2.27,1.27,22.3,22.3,0,0,0,10.8,2.22l0,.13c7.09.7,14.83-1.54,14.83-1.54S1451,59.7,1450.45,49.46Z"
          fill="#eebf57"
        />
        <path
          d="M1447.45,86l-26.77-.29-2-.53,1-.24c-.05-.12-.12-.16-.17-.09a5.84,5.84,0,0,1,0-1.22,7.32,7.32,0,0,0,.1-.89.66.66,0,0,1,.11.46,2.93,2.93,0,0,1,.14-.74,1.56,1.56,0,0,0,.09-.77,3.65,3.65,0,0,1,.18,2,.77.77,0,0,1,.15-.37v0a6.26,6.26,0,0,0,.22-1.46,2.12,2.12,0,0,1,.24,1.23,5.21,5.21,0,0,1,.4-1.64,3.15,3.15,0,0,0,.32-1.75,6,6,0,0,1,.35,2.85.66.66,0,0,1,.17-.21,1.15,1.15,0,0,0,.33-1,4,4,0,0,1,.09,1.53c.11-.19.21-.32.31-.53a4.29,4.29,0,0,0,.46-2c0-.21.11-.27.15-.13a6.38,6.38,0,0,1,.12.68,1.34,1.34,0,0,1,.23.92,5.4,5.4,0,0,1,.28-1.51,3.09,3.09,0,0,0,.19-1.56c.18-.07.55,1.6.36,4a1.48,1.48,0,0,1,.31-.77v.09a12.66,12.66,0,0,0,.45-3,4.19,4.19,0,0,1,.47,2.51,10.17,10.17,0,0,1,.84-3.33,6.59,6.59,0,0,0,.64-3.56c.31,0,.77,2.37.72,5.8a1.19,1.19,0,0,1,.35-.44,2.34,2.34,0,0,0,.67-1.92,8.29,8.29,0,0,1,.18,3.11c.21-.38.43-.66.63-1.08a8.63,8.63,0,0,0,.92-4.18c0-.43.24-.54.31-.25a12.64,12.64,0,0,1,.13,5.16,16.82,16.82,0,0,1-.52,2.41h.24v0c.15-.27.3-.45.43-.74a5.35,5.35,0,0,0,.58-2.62c0-.27.15-.34.2-.16a8.18,8.18,0,0,1,.08,3.24c0,.09,0,.18,0,.26h.82c0-.07,0-.15,0-.22a6.82,6.82,0,0,0,.13-1.16.86.86,0,0,1,.16.6,3.15,3.15,0,0,1,.18-1,2.15,2.15,0,0,0,.12-1,4.76,4.76,0,0,1,.23,2.58,1.05,1.05,0,0,1,.2-.5v.06a8.1,8.1,0,0,0,.29-1.93,2.72,2.72,0,0,1,.31,1.63,6.55,6.55,0,0,1,.54-2.16,4.24,4.24,0,0,0,.41-2.3c.2,0,.5,1.53.47,3.75a.68.68,0,0,1,.22-.28,1.5,1.5,0,0,0,.44-1.25,5.54,5.54,0,0,1,.12,2c.13-.24.27-.42.4-.7a5.54,5.54,0,0,0,.6-2.7c0-.27.15-.35.2-.16a8.43,8.43,0,0,1,.09,3.33,10.38,10.38,0,0,1-.33,1.52h.16c.09-.17.18-.28.27-.46a3.45,3.45,0,0,0,.37-1.7c0-.17.1-.22.13-.1a5.12,5.12,0,0,1,.05,2.09l0,.23a55.63,55.63,0,0,1,10.85,2.06Zm-24.3-2c0-.11,0-.22,0-.34-.05.21-.11.39-.16.55l.11,0A1.06,1.06,0,0,1,1423.15,84Z"
          fill="#8ac72f"
        />
      </g>
      <g>
        <ellipse cx="987.71" cy="89" rx="18.24" ry="8.87" fill="#72a139" />
        <path
          d="M970,92.06c.56,2.76,5,6.09,11.91,6.09s10.8-4.71,10.52-6.65-5.26-12.18-5.26-12.18,15.78-3.32,15.23-13.57-1.66-21-18.83-23.53S955,49.69,953.38,59.66s2.21,16.34,8.31,19.11A22.32,22.32,0,0,0,972.48,81Z"
          fill="#f8e75b"
        />
        <path
          d="M992.42,91.5c-.25-1.75-4.37-10.33-5.14-11.92A77.21,77.21,0,0,1,972.47,81l-2.48,11c.56,2.76,5,6.09,11.91,6.09S992.7,93.44,992.42,91.5Z"
          fill="#efc557"
        />
        <path
          d="M972.47,81s6.11,5.62,10.67,4.51,4.14-6,4.14-6S977.58,81,972.47,81Z"
          fill="#ca8e78"
        />
        <path
          d="M995,46.43c-2.68-2-6.36-3.47-11.47-4.21-14.89-2.16-25.4,5.05-29,13.51,10.32,12.87,20.71,14.83,34.82,6.15C997.82,56.68,997.79,51.1,995,46.43Z"
          fill="#c5d359"
        />
        <ellipse cx="965.29" cy="64.35" rx="8.68" ry="5.43" fill="#ffffcd" />
        <ellipse cx="967.32" cy="54.75" rx="3.67" ry="2.3" fill="#ffffcd" />
        <ellipse cx="976.48" cy="71.91" rx="3.67" ry="2.3" fill="#ffffcd" />
        <ellipse cx="986.63" cy="51.42" rx="7.03" ry="4.4" fill="#ffffcd" />
        <ellipse cx="990.81" cy="59" rx="2.95" ry="1.85" fill="#ffffcd" />
        <path
          d="M1002.39,65.75a45.24,45.24,0,0,0-1.54-10.85c0,3.38-3.15,9.72-6.49,13.34-6.88,7.48-21.88,11.63-34.94,9.25a15.25,15.25,0,0,0,2.27,1.28A22.32,22.32,0,0,0,972.48,81l0,.14c7.1.69,14.83-1.54,14.83-1.54S1002.94,76,1002.39,65.75Z"
          fill="#eebf57"
        />
        <path
          d="M999.39,102.31,972.62,102c-.66-.16-1.33-.34-2-.53l1-.24c-.06-.12-.12-.16-.18-.08a6.15,6.15,0,0,1,0-1.23,5.22,5.22,0,0,0,.09-.88.64.64,0,0,1,.12.45,2.75,2.75,0,0,1,.13-.74,1.41,1.41,0,0,0,.1-.76,3.6,3.6,0,0,1,.18,2,.65.65,0,0,1,.15-.38v0a6.33,6.33,0,0,0,.22-1.47,2.06,2.06,0,0,1,.23,1.23,4.82,4.82,0,0,1,.41-1.63,3.16,3.16,0,0,0,.31-1.75c.16,0,.38,1.16.36,2.85a.6.6,0,0,1,.17-.22,1.14,1.14,0,0,0,.33-.94,4,4,0,0,1,.09,1.52c.1-.18.21-.32.31-.53a4.17,4.17,0,0,0,.45-2c0-.21.12-.26.15-.12a4.56,4.56,0,0,1,.13.68,1.29,1.29,0,0,1,.23.91,5.32,5.32,0,0,1,.28-1.5,3.34,3.34,0,0,0,.19-1.56c.17-.08.55,1.59.36,4a1.61,1.61,0,0,1,.3-.77v.09a13.38,13.38,0,0,0,.46-3,4.19,4.19,0,0,1,.47,2.51,10.64,10.64,0,0,1,.83-3.34,6.46,6.46,0,0,0,.64-3.55c.31,0,.77,2.36.72,5.8a1.22,1.22,0,0,1,.35-.44,2.33,2.33,0,0,0,.67-1.93,8.07,8.07,0,0,1,.18,3.11,11,11,0,0,0,.64-1.08,8.62,8.62,0,0,0,.92-4.17c0-.43.23-.54.31-.26A12.82,12.82,0,0,1,983,97.2a16.68,16.68,0,0,1-.52,2.42h.24v0c.14-.27.29-.45.43-.74a5.48,5.48,0,0,0,.58-2.63c0-.27.15-.34.19-.16A8,8,0,0,1,984,99.3c0,.1,0,.18,0,.27h.82c0-.08,0-.15,0-.22a8.13,8.13,0,0,0,.13-1.16.79.79,0,0,1,.15.59,3.56,3.56,0,0,1,.18-1,2.13,2.13,0,0,0,.13-1,4.91,4.91,0,0,1,.23,2.59.86.86,0,0,1,.2-.5v.06a8.75,8.75,0,0,0,.29-1.93,2.71,2.71,0,0,1,.31,1.62,7,7,0,0,1,.53-2.16,4.19,4.19,0,0,0,.42-2.3c.2,0,.5,1.53.47,3.75a.85.85,0,0,1,.22-.28,1.49,1.49,0,0,0,.43-1.25,5.11,5.11,0,0,1,.12,2c.14-.25.28-.43.41-.7a5.66,5.66,0,0,0,.6-2.7c0-.28.15-.35.2-.17a8.31,8.31,0,0,1,.08,3.34,11.84,11.84,0,0,1-.32,1.51h.16a5,5,0,0,0,.26-.46,3.53,3.53,0,0,0,.38-1.69c0-.18.09-.22.13-.11a5.34,5.34,0,0,1,.05,2.1c0,.08,0,.15,0,.22a56.35,56.35,0,0,1,10.86,2.06C1000.72,102,1000.05,102.16,999.39,102.31Zm-24.3-2c0-.1,0-.22,0-.33a4.53,4.53,0,0,1-.17.55l.11,0A1.46,1.46,0,0,1,975.09,100.3Z"
          fill="#8ac72f"
        />
      </g>
      <g transform="translate(0, -20)">
        <ellipse cx="1331.58" cy="222.29" rx="86.05" ry="30.4" fill="#72a139" />
        <path
          d="M1328.8,241.9c.76-1,1-2.35,1.84-3.35,1.18-1.49,3.2-1.94,5.06-2.29a16.71,16.71,0,0,1,5.16-.43c1.79.23,3.49,1,5.29,1,4.92,0,17.27-14.41,11.88-18.63-5.2-4.07-5.63,12.56-9.11,14.13a7.72,7.72,0,0,1-3.32.4,55.76,55.76,0,0,0-15.21,1.86,8.9,8.9,0,0,0-4.17,2c-1,1.06-1.54,2.54-2.5,3.67s-2.81,1.83-3.89.82a1.78,1.78,0,0,1,1.22,2.26,5.14,5.14,0,0,1-1.69,2.32c2.27-2.13,6.54-1.16,8-4,1.78-3.56-3.07-8.39-6-9.5a6.27,6.27,0,0,1-2.49-1.27c-1.61-1.73,0-4.5-.11-6.86-.19-2.73-2.78-4.61-4-7.07-1.6-3.25-.61-7.1-.35-10.72a26,26,0,0,0-6.15-18.59c-2.32,3.25-5.42,7.9-4.17,11.69,1,3,4.18,5,5.2,8,1.24,3.67-.92,8.17,1.25,11.39.87,1.29,2.29,2.09,3.43,3.14a9.84,9.84,0,0,1,3.15,7.4c0,2.09-.7,4.4.51,6.1,1,1.33,2.72,1.74,4.27,2.26S1328.66,240.26,1328.8,241.9Z"
          fill="#7b611c"
        />
        <path
          d="M1233.92,188.57c.15,4.44.27,9.92,4.24,11.9a15.76,15.76,0,0,0,4.94,1c7.13,1,12.92,6.08,18.26,10.91l12.15,11a10.41,10.41,0,0,0,3.82,2.54,3.58,3.58,0,0,0,4.09-1.26c-6.25-7.62-16.46-11.1-22.76-18.69-1.54-1.85-2.84-3.95-4.75-5.42-3.21-2.47-7.66-2.81-11-5.17-4.09-2.93-5.56-8.44-5.29-13.47a13.53,13.53,0,0,0-.12-4.45c-.84-2.93-4.11-5.73-5.78-2.66C1230.72,176.75,1233.83,185.92,1233.92,188.57Z"
          fill="#7b611c"
        />
        <path
          d="M1393.61,229.32c3.29.15,6.4-1.6,8.8-3.85a22.21,22.21,0,0,0,6.75-18.65,4.58,4.58,0,0,0,1.77.07,9.91,9.91,0,0,0,3.17-18.74c-.06-6.23-1.26-13.48-6.73-16.47-1.92-1.06-4.18-1.44-6-2.7s-3-3.26-4.88-4.31-5.08-.19-5,2c0-2.14-3.12-3.44-4.62-1.92a53.58,53.58,0,0,0-30.53-16.44l-.22,4a31.17,31.17,0,0,0-10.3,29.47c-2.91,3.28-.26,13.2,4.71,17.37a44.92,44.92,0,0,0-27.13-6.58,123.33,123.33,0,0,0-7.5,25,16.76,16.76,0,0,0,8.86,1c-2,1.56-1.7,4.89,0,6.76s4.3,2.62,6.79,3.05c2.33.4,5.52,2.1,4.32,4.14,4.45-1,18.4-5.56,20.26-.18,5.52-3.64,8.8-2.6,14.79-2.15,6.76.52,10.85-1.76,15.8-6.5A7.41,7.41,0,0,0,1393.61,229.32Z"
          fill="#557520"
        />
        <path
          d="M1299.46,207.32c6.41,2.68,13.09,5.41,20,5s14.1-4.92,15.43-12c1,3.2,5.92,2.25,7.85-.45s2.56-6.36,5-8.56c3.37-3.06,8.47-2,13-2s10.07-3.09,9.07-7.62l4.81,5.76a14.78,14.78,0,0,1,8.08-1.14c8.17-22.06,1.72-49.08-15.42-64.65-3.71-3.37-11.19-5-12.14,0-1.43-5.68-3.08-11.74-7.43-15.49s-12.29-3.44-14.47,2c-1.62-4.13-7.85-5.14-10.6-1.71-4.2-6.06-8.61-12.31-14.89-16s-15-3.89-20,1.47c-6.11-6.54-18.71-3.31-21.17,5.44-4.11-3-9.08,2.25-11.54,6.78l-12.24,22.59-5.1-6.07c-15.3,11.46-23,32.85-18.7,51.91a19,19,0,0,0,3.16,7.61c2.81,3.6,7.45,5.08,11.89,5.55a36.64,36.64,0,0,0,25.4-7c-3.43-.83-5.35,4-5.28,7.68a23.55,23.55,0,0,0,1.1,7.18,16.73,16.73,0,0,0,6.08,8.26c7.36,5.23,17.42,3.37,25.75,6.64,3.72,1.46,9.91,2.36,9.83-1.77a35.94,35.94,0,0,0,24.8,6.2"
          fill="#557520"
        />
        <path
          d="M1249.77,126.8a25.83,25.83,0,0,0-10.42-13.1,5,5,0,0,0-.18,3.74,16.21,16.21,0,0,0-11.91-3.59,25.34,25.34,0,0,1,3.55,5.94,17.39,17.39,0,0,0-9,1.65c0,1.5,2.38,2.14,2.42,3.65a2.86,2.86,0,0,1-.8,1.71,24.57,24.57,0,0,0-4.69,11.08,4.19,4.19,0,0,0,.58,3.46c.81.9,2.72.64,2.79-.57q.06,8.1.5,16.19a12.35,12.35,0,0,0,7.43-5.21,10,10,0,0,0,2.41,7.34l4.34-3c.21.92.33,1.77.54,2.7,1.39.9,3.48,1.71,4.47.38a3.41,3.41,0,0,0,.48-1.24l.94-4a7.63,7.63,0,0,0,1.69,2.74,1.08,1.08,0,0,0,.58.36,1.15,1.15,0,0,0,.7-.23l6.74-4.05c3.21-1.93,7.07-2.9,9.68-5.59a28.81,28.81,0,0,0,.39,6.69l6.87-7.27a7.55,7.55,0,0,0,7.86-3.34,3.15,3.15,0,0,0,.55-1.69,4.12,4.12,0,0,0-.51-1.59l-3.1-6.36-.9.88a7.2,7.2,0,0,1-2.09-4.11c-.07-.54-.16-1.19-.67-1.39a1.39,1.39,0,0,0-1.17.28A67.65,67.65,0,0,0,1263,134a5,5,0,0,0-2.37-3.77,2.9,2.9,0,0,0-3.94,1.16c-1.55-.57-.46-3.8-2.08-4.13a5.52,5.52,0,0,0-1.14.08c-1,0-1.7-.91-2.41-1.6S1250.43,126.06,1249.77,126.8Z"
          fill="#7b9933"
        />
        <path
          d="M1264.25,167.79c-.07-1.42-2-2.24-3.21-1.57a3.26,3.26,0,0,0-1.34,3.71,6.31,6.31,0,0,0,2.57,3.29,25,25,0,0,0,7.59,3.24,4.35,4.35,0,0,0,2.68.21c.65-.24,1.2-.79,1.9-.79a2.65,2.65,0,0,1,1.34.54,31,31,0,0,0,19.86,4.58,43.87,43.87,0,0,0,.3-10.43c-2.24-.49-5.07.45-6.53-1.31s.09-4.71-.75-6.92c-1.77,1.23-4.06-.27-6-1.26a23.09,23.09,0,0,0-10.6-2.31C1266.58,159.11,1266.12,163.23,1264.25,167.79Z"
          fill="#7b9933"
        />
        <path
          d="M1370.1,208.45l6.26-6.2a3.06,3.06,0,0,0,.07-5.14l-5.4-6.29a4.24,4.24,0,0,0-2,2.09,14.67,14.67,0,0,0-3.36-8.14l-2.57,1.53c-1.18-2-2.49-4.06-4.6-5s-5.17,0-5.49,2.32c-1.38-2.57-4.14-4.67-7-4.27s-5,4.21-3.19,6.48c-5.39,1.7-8.21,8.84-5.45,13.76a70.75,70.75,0,0,0-20.73-1.39,2.17,2.17,0,0,0-1.61.59,2.27,2.27,0,0,0-.34,1.48l0,5.77c3.76,1.53,8,.87,12.06.66a52.35,52.35,0,0,1,10.76.54c-.65,3.41,3.06,6.37,6.53,6.33s6.57-2.07,9.43-4c-.73,1.61.78,3.52,2.51,3.89s3.5-.3,5.14-1c5.17-2.08,10.59-4.35,14-8.77"
          fill="#7b9933"
        />
        <path
          d="M1357,149.78c1.77,2.07,5.26,1.91,7.34.15s2.88-4.64,2.84-7.35c-.57.28-.07,1.27.57,1.22s1-.66,1.33-1.23a11.66,11.66,0,0,0,1.11-6.47,2.29,2.29,0,0,0-.62-1.5,2.42,2.42,0,0,0-1.08-.42l-9.12-1.94a7.82,7.82,0,0,0-.8,4,3.22,3.22,0,0,0-4.82,2l-9.61-3.83c-1.13-.45-2.41-.9-3.52-.42a4,4,0,0,0-1.77,1.92,13.61,13.61,0,0,0-1.52,7.72,2.46,2.46,0,1,0-3.52,3.42,9.73,9.73,0,0,0-5.7,9.85,10.92,10.92,0,0,0-2.61,5.07,16.5,16.5,0,0,0,1.74,1c-.56,5.29,6.06.41,8.41.38,3,0,5.07,2.56,7.87,2.95,4.85.68,5.13-2.87,8.28-5.58,1.65-1.41,2.57-.38,4-2.83C1356.18,157.1,1357.38,150.27,1357,149.78Z"
          fill="#7b9933"
        />
        <path
          d="M1298.68,168c4.2-4.78-7.44-10.13-13.34-11.89C1285.33,162.7,1292.62,174.93,1298.68,168Z"
          fill="#557520"
        />
        <path
          d="M1296.76,173c6.14,1.68,5.84-11.12,4.85-17.2C1295.7,158.65,1287.89,170.56,1296.76,173Z"
          fill="#557520"
        />
        <path
          d="M1322.57,165.8c4.21-4.78-7.44-10.13-13.33-11.89C1309.22,160.47,1316.51,172.7,1322.57,165.8Z"
          fill="#557520"
        />
        <path
          d="M1320.65,170.75c6.14,1.68,5.85-11.12,4.85-17.2C1319.59,156.42,1311.79,168.33,1320.65,170.75Z"
          fill="#557520"
        />
        <g>
          <path
            d="M1239.35,120.13c-1.66,1.9-5,3.42-6.35,2.22s-.32-4.69,1.33-6.59,3.28-1.5,4.67-.29S1241,118.23,1239.35,120.13Z"
            fill="#e8f5fa"
          />
          <path
            d="M1238.89,127.7c-2.5-.34-5.59-2.25-5.35-4.07s3.74-2.86,6.23-2.53,3.06,1.92,2.81,3.74S1241.39,128,1238.89,127.7Z"
            fill="#e8f5fa"
          />
          <path
            d="M1231.87,130.41c-.9-2.35-.69-6,1-6.64s4.3,1.91,5.2,4.26-.22,3.6-1.93,4.25S1232.78,132.76,1231.87,130.41Z"
            fill="#e8f5fa"
          />
          <path
            d="M1227,123.05c2.23-1.16,5.87-1.37,6.71.26s-1.42,4.49-3.65,5.64-3.6.19-4.45-1.44S1224.75,124.21,1227,123.05Z"
            fill="#e8f5fa"
          />
          <path
            d="M1231.44,116.64c2.06,1.45,3.92,4.58,2.86,6.08s-4.63.81-6.69-.64-1.83-3.11-.77-4.61S1229.38,115.19,1231.44,116.64Z"
            fill="#e8f5fa"
          />
          <circle cx="1233.39" cy="122.91" r="2.67" fill="#e9ac38" />
        </g>
        <g>
          <path
            d="M1258.43,139.86c-1,1.1-2.88,2-3.68,1.29s-.19-2.72.77-3.83a1.93,1.93,0,0,1,2.91,2.54Z"
            fill="#e8f5fa"
          />
          <path
            d="M1258.16,144.25c-1.44-.19-3.24-1.3-3.1-2.36s2.17-1.66,3.62-1.46a1.93,1.93,0,0,1-.52,3.82Z"
            fill="#e8f5fa"
          />
          <path
            d="M1254.09,145.83c-.52-1.37-.4-3.48.59-3.86s2.5,1.11,3,2.48a1.93,1.93,0,0,1-3.61,1.38Z"
            fill="#e8f5fa"
          />
          <path
            d="M1251.26,141.55c1.29-.67,3.4-.79,3.89.16s-.82,2.6-2.12,3.27a1.93,1.93,0,0,1-1.77-3.43Z"
            fill="#e8f5fa"
          />
          <path
            d="M1253.84,137.83c1.2.85,2.27,2.66,1.66,3.53s-2.69.47-3.88-.37a1.93,1.93,0,0,1,2.22-3.16Z"
            fill="#e8f5fa"
          />
          <circle cx="1254.97" cy="141.47" r="1.55" fill="#e9ac38" />
        </g>
        <g>
          <path
            d="M1273.5,159.88c-1.62,1.85-4.85,3.34-6.2,2.16s-.32-4.58,1.3-6.44,3.2-1.46,4.56-.28S1275.12,158,1273.5,159.88Z"
            fill="#e8f5fa"
          />
          <path
            d="M1273.05,167.28c-2.44-.33-5.46-2.2-5.23-4s3.65-2.8,6.1-2.47,3,1.87,2.75,3.65S1275.5,167.61,1273.05,167.28Z"
            fill="#e8f5fa"
          />
          <path
            d="M1266.19,169.93c-.88-2.3-.68-5.85,1-6.5s4.2,1.87,5.08,4.17-.21,3.52-1.89,4.16S1267.07,172.23,1266.19,169.93Z"
            fill="#e8f5fa"
          />
          <path
            d="M1261.41,162.73c2.19-1.13,5.74-1.33,6.57.26s-1.39,4.38-3.58,5.52-3.52.18-4.34-1.42S1259.22,163.86,1261.41,162.73Z"
            fill="#e8f5fa"
          />
          <path
            d="M1265.76,156.46c2,1.42,3.84,4.48,2.8,5.95s-4.53.79-6.54-.63-1.79-3-.75-4.51S1263.75,155,1265.76,156.46Z"
            fill="#e8f5fa"
          />
          <circle cx="1267.67" cy="162.59" r="2.61" fill="#e9ac38" />
        </g>
        <g>
          <path
            d="M1352.84,141c-1.62,1.86-4.85,3.35-6.21,2.17s-.32-4.59,1.3-6.44,3.21-1.46,4.57-.28S1354.46,139.1,1352.84,141Z"
            fill="#e8f5fa"
          />
          <path
            d="M1352.39,148.36c-2.44-.33-5.47-2.2-5.23-4s3.65-2.79,6.09-2.46,3,1.87,2.75,3.65S1354.83,148.68,1352.39,148.36Z"
            fill="#e8f5fa"
          />
          <path
            d="M1345.53,151c-.88-2.3-.69-5.86,1-6.5s4.2,1.87,5.08,4.17-.21,3.52-1.89,4.16S1346.41,153.31,1345.53,151Z"
            fill="#e8f5fa"
          />
          <path
            d="M1340.75,143.81c2.18-1.14,5.74-1.34,6.57.26s-1.39,4.38-3.58,5.52-3.52.18-4.35-1.42S1338.56,144.94,1340.75,143.81Z"
            fill="#e8f5fa"
          />
          <path
            d="M1345.1,137.54c2,1.42,3.83,4.48,2.8,6s-4.53.79-6.55-.63-1.78-3-.75-4.51S1343.09,136.12,1345.1,137.54Z"
            fill="#e8f5fa"
          />
          <circle cx="1347.01" cy="143.67" r="2.61" fill="#e9ac38" />
        </g>
        <g>
          <path
            d="M1375.65,200.66c-1.62,1.86-4.86,3.35-6.21,2.17s-.32-4.59,1.3-6.44,3.21-1.47,4.56-.29S1377.26,198.81,1375.65,200.66Z"
            fill="#e8f5fa"
          />
          <path
            d="M1375.2,208.07c-2.44-.33-5.47-2.21-5.23-4s3.65-2.79,6.09-2.46,3,1.87,2.75,3.65S1377.64,208.39,1375.2,208.07Z"
            fill="#e8f5fa"
          />
          <path
            d="M1368.34,210.72c-.89-2.3-.69-5.86,1-6.5s4.2,1.87,5.08,4.17-.21,3.52-1.89,4.16S1369.22,213,1368.34,210.72Z"
            fill="#e8f5fa"
          />
          <path
            d="M1363.55,203.52c2.19-1.14,5.75-1.34,6.57.26s-1.39,4.38-3.57,5.51-3.52.19-4.35-1.41S1361.37,204.65,1363.55,203.52Z"
            fill="#e8f5fa"
          />
          <path
            d="M1367.91,197.25c2,1.42,3.83,4.48,2.8,5.95s-4.53.79-6.55-.63-1.78-3-.75-4.51S1365.89,195.83,1367.91,197.25Z"
            fill="#e8f5fa"
          />
          <circle cx="1369.81" cy="203.38" r="2.61" fill="#e9ac38" />
        </g>
        <path
          d="M1382,270.65c-7.24.07-13.8-.3-19.74-.48-3-.08-5.73-.13-8.59-.1s-5.68.1-8.52.23a209.86,209.86,0,0,0-33.79,4.37l-5.45-.87,2.21-1.54c-.24-.43-.44-.55-.51-.22a38.88,38.88,0,0,1-1.22-4.76,33.87,33.87,0,0,0-.56-3.48,3.39,3.39,0,0,1,.72,1.68,15.18,15.18,0,0,1-.32-3,9,9,0,0,0-.44-3c.2-.21,1.42,2.87,2.22,7.53a4,4,0,0,1,0-1.57l0,.17a37.36,37.36,0,0,0-.7-5.85,11.43,11.43,0,0,1,1.68,4.67,27,27,0,0,1-.31-6.65,18,18,0,0,0-.61-7c.43-.08,2,4.33,3.3,10.95a2.5,2.5,0,0,1,.28-.94,6.08,6.08,0,0,0,.13-3.9,23.55,23.55,0,0,1,1.44,5.95c.12-.79.3-1.39.4-2.26a24.1,24.1,0,0,0-.33-8.3c-.13-.83.12-1.1.33-.57a24.85,24.85,0,0,1,.84,2.6,6.92,6.92,0,0,1,1.3,3.48,29.52,29.52,0,0,1-.33-6.07,17.82,17.82,0,0,0-.56-6.24c.45-.4,2.64,6,3.75,15.56a7.66,7.66,0,0,1,.3-3.18l.06.34c-.2-5.89-.16-9.94-.72-12,1,1.15,2.53,5.54,2.92,9.7-.48-6.25-.31-10.95.3-13.57s1.24-9.21-.15-14.36c1-.12,3.62,9,5.24,22.67a4.92,4.92,0,0,1,.75-1.86c.65-.8,1.59-3.77,1-7.89.56.65,1.49,5.64,2,12.29.41-1.58.89-2.74,1.26-4.5,1.55-7.15,1.41-9.76,1-16.92-.11-1.71.49-2.21.83-1.11,1.68,5.48,2.42,12.43,2.31,20.51,0,3.84-.23,7.09-.5,9.76l.63-.1,0-.09c.28-1.12.62-1.87.88-3.06,1-4.48.92-6.12.69-10.62-.05-1.08.31-1.38.5-.69a45.77,45.77,0,0,1,1.27,12.91c0,.38,0,.72,0,1.08l2.19-.23c0-.31,0-.61,0-.89a41.83,41.83,0,0,0,0-4.65,4.41,4.41,0,0,1,.58,2.35,19.83,19.83,0,0,1,.23-3.92,11.91,11.91,0,0,0,.1-4.05c.3-.22,1.23,4,1.26,10.27a5.28,5.28,0,0,1,.42-2v.23c.29-3.8.59-6.4.38-7.76.57.81,1.22,3.74,1.18,6.44a34.6,34.6,0,0,1,1.08-8.7,23.25,23.25,0,0,0,.81-9.26c.6,0,1.68,6.06,1.87,14.94a3.32,3.32,0,0,1,.58-1.15c.47-.48,1.23-2.33,1.08-5,.31.46.6,3.73.53,8,.35-1,.72-1.73,1.06-2.83,1.37-4.51,1.42-6.2,1.52-10.84,0-1.11.42-1.4.57-.68a45.91,45.91,0,0,1,.36,13.35c-.22,2.38-.51,4.4-.81,6.08l.42,0c.23-.67.48-1.13.7-1.86a20.06,20.06,0,0,0,1-6.81c0-.69.26-.87.34-.41a30.06,30.06,0,0,1,.16,8.39c0,.31-.07.6-.11.9a92.46,92.46,0,0,1,15.73,3.43c5.11,1.49,10.25,3.22,16.13,4.72C1386.31,269.24,1384.13,270,1382,270.65Zm-65.76-4.06c-.09-.43-.19-.87-.28-1.31,0,.83,0,1.57,0,2.23l.26-.14A6.46,6.46,0,0,1,1316.22,266.59Z"
          fill="#8ac72f"
        />
        <path
          d="M1354.43,271.68l-21.85-.24c-7.37-.06-13.22.17-17.13,1.13l-2.25-1.5c.18-.4.37-.81.57-1.21-.18-.45-.28-.58-.24-.27-.11-.36-1-3-1.39-4.71s-.7-3-.86-3.42a6.87,6.87,0,0,1,.63,1.69,28.85,28.85,0,0,1-.63-2.89,17.05,17.05,0,0,0-.67-3c.08-.19,1.16,2.91,2.24,7.51a8.68,8.68,0,0,1-.21-1.51l0,.16c-.55-2.82-.86-4.76-1.17-5.76a20.3,20.3,0,0,1,1.48,4.71,44.28,44.28,0,0,1-.94-6.52,33.54,33.54,0,0,0-1-6.94c.27-.06,1.59,4.4,2.88,11a3.87,3.87,0,0,1,.06-.9,10.63,10.63,0,0,0-.25-3.81,41.36,41.36,0,0,1,1.25,6c0-.77,0-1.33,0-2.18a46.78,46.78,0,0,0-.69-8.22c-.12-.83,0-1.08.17-.54.22.81.43,1.7.62,2.64a11.42,11.42,0,0,1,.9,3.57,47,47,0,0,1-.43-6,29.86,29.86,0,0,0-.53-6.23c.31-.37,1.77,6.18,2.65,15.75a13,13,0,0,1,.07-3.12l0,.35c-.25-5.85-.25-9.87-.61-12,.66,1.24,1.57,5.73,1.81,9.9a73.47,73.47,0,0,1,.21-13.45,54.92,54.92,0,0,0,.17-14.3c.66,0,2.15,9.32,2.8,23a6.18,6.18,0,0,1,.48-1.79c.4-.73,1.06-3.6.8-7.77.33.71.72,5.76.82,12.42.28-1.53.6-2.66.88-4.38,1.16-7,1.18-9.59,1.17-16.77,0-1.72.38-2.18.54-1a115.29,115.29,0,0,1,.63,20.63c-.17,3.83-.4,7-.65,9.69l.37-.06,0-.08c.2-1.09.43-1.82.63-3a51.92,51.92,0,0,0,.79-10.53c0-1.08.23-1.36.32-.65a76.88,76.88,0,0,1,.29,13c0,.37,0,.72-.06,1.07.43,0,.86-.07,1.32-.09l0-.88c.1-2.37.23-4,.17-4.64a7.14,7.14,0,0,1,.27,2.37,32.58,32.58,0,0,1,.27-3.9,19.31,19.31,0,0,0,.18-4c.19-.21.62,4.11.44,10.32a8,8,0,0,1,.32-2v.23c.29-3.77.54-6.35.45-7.72a24.13,24.13,0,0,1,.54,6.49,57.71,57.71,0,0,1,.86-8.65,37.87,37.87,0,0,0,.66-9.21c.34,0,.86,6.11.82,15a4.55,4.55,0,0,1,.37-1.13,11.74,11.74,0,0,0,.72-5,50.42,50.42,0,0,1,.2,8c.23-1,.46-1.7.68-2.8a50.63,50.63,0,0,0,1-10.82c0-1.11.25-1.4.33-.67a77.19,77.19,0,0,1,.13,13.35c-.15,2.38-.34,4.4-.54,6.06l.26,0c.15-.66.3-1.12.45-1.85a32.66,32.66,0,0,0,.63-6.8c0-.69.16-.88.21-.42a49.81,49.81,0,0,1,.07,8.39q0,.46-.06.9c6.91,1.3,12.2,4.27,17.74,8C1356.63,270.38,1355.53,271.05,1354.43,271.68Zm-37.71-6.46c-.08-.43-.15-.87-.23-1.32q.09,1.23.15,2.19l.11-.11C1316.74,265.71,1316.72,265.46,1316.72,265.22Z"
          fill="#8ac72f"
        />
        <path
          d="M1434.5,256.31a104.48,104.48,0,0,1-28,10.11,160.52,160.52,0,0,1-27.09,3.21c-8.67.32-16.93.16-24.76,0s-15.23-.29-22.2,0l-6.29-1.68,2.93-1.21c-.2-.47-.42-.61-.56-.29a30,30,0,0,1-.47-4.89,28.8,28.8,0,0,0,.07-3.54,2.88,2.88,0,0,1,.51,1.77,12.22,12.22,0,0,1,.25-3,7.36,7.36,0,0,0,.13-3.08c.28-.17,1.09,3.07,1,7.8a3.35,3.35,0,0,1,.41-1.54v.17c.3-2.89.6-4.86.42-5.89a9.39,9.39,0,0,1,1,4.88,22.17,22.17,0,0,1,1.09-6.61,14.77,14.77,0,0,0,.82-7c.54,0,1.49,4.59,1.6,11.34a2.57,2.57,0,0,1,.55-.88,5,5,0,0,0,1-3.81c.28.35.54,2.83.45,6.1.33-.75.68-1.31,1-2.15,1.3-3.42,1.33-4.7,1.43-8.23,0-.84.39-1.06.52-.51a21.19,21.19,0,0,1,.47,2.71c.43.34.89,1.92.84,3.65a24.42,24.42,0,0,1,.92-6,14.52,14.52,0,0,0,.65-6.23c.63-.32,2,6.35,1.29,16a6.61,6.61,0,0,1,1.06-3.08v.35c1-5.83,1.87-9.81,1.61-11.93,1,1.3,2,5.87,1.62,10,.68-6.24,1.81-10.84,3-13.33s3.11-8.9,2.39-14.21c1.1,0,2.61,9.48,2.31,23.22a4.83,4.83,0,0,1,1.23-1.74c.94-.7,2.55-3.52,2.41-7.69.56.72,1,5.79.55,12.45.76-1.51,1.53-2.62,2.24-4.33,2.86-6.92,2.9-9.53,3.19-16.71.07-1.71.77-2.16,1-1a60,60,0,0,1,.59,20.64,71.89,71.89,0,0,1-1.82,9.67l.87,0,0-.09c.51-1.08,1-1.8,1.52-3,1.79-4.38,1.8-6,1.94-10.53,0-1.08.49-1.36.66-.66a36.23,36.23,0,0,1,.53,13c0,.37-.09.71-.14,1.07l3-.13c0-.3,0-.6,0-.88a32.31,32.31,0,0,0,.33-4.65,3.62,3.62,0,0,1,.63,2.37,15.69,15.69,0,0,1,.51-3.92,9,9,0,0,0,.3-4c.38-.22,1.43,4.06,1.24,10.28a4.26,4.26,0,0,1,.64-2v.23c.52-3.79.93-6.4.7-7.76.69.81,1.51,3.72,1.44,6.42a31.39,31.39,0,0,1,1.4-8.73,18.8,18.8,0,0,0,.76-9.28c.65,0,2.14,6,2.8,14.82A3.09,3.09,0,0,1,1386,251c.58-.52,1.44-2.44,1-5.12.41.43,1,3.66,1.24,8,.4-1,.84-1.78,1.18-2.94,1.36-4.69,1.15-6.36.77-11-.1-1.1.31-1.44.57-.74a38.45,38.45,0,0,1,2.08,13.2,42.9,42.9,0,0,1-.4,6.15l.6,0c.25-.7.54-1.2.76-2,.84-3,.7-4,.4-6.93-.07-.69.2-.91.38-.48a22.77,22.77,0,0,1,1.49,8.27c0,.31,0,.61,0,.91,8.11-.57,15.55-1.29,22.93-2.55a107.38,107.38,0,0,0,22.35-6.07c-1.09,1.15-2.19,2.3-3.33,3.42S1435.71,255.28,1434.5,256.31Zm-94.22,6.18c0-.44,0-.89,0-1.34-.17.82-.34,1.55-.53,2.19l.37-.09A6.92,6.92,0,0,1,1340.28,262.49Z"
          fill="#8ac72f"
        />
        <path
          d="M1443.54,231.37c-5.42,5.95-11.68,12.68-19.82,18.86a80.9,80.9,0,0,1-13.73,8.38,65.49,65.49,0,0,1-16.78,5.4c-1-.17-1.94-.37-2.88-.58s-1.91-.5-2.85-.77l2.51-1.26c-.2-.45-.39-.59-.5-.27a37.54,37.54,0,0,1-.67-4.87c-.08-1.8-.08-3-.19-3.52a4.09,4.09,0,0,1,.49,1.76,19,19,0,0,1-.08-3,11.65,11.65,0,0,0-.21-3.06c.13-.18,1,3,1.48,7.7a4.56,4.56,0,0,1,.13-1.55l0,.17a39.35,39.35,0,0,0-.43-5.86,15.18,15.18,0,0,1,1.32,4.77,45.68,45.68,0,0,1-.34-6.62,24.13,24.13,0,0,0-.82-7c.23,0,1.61,4.4,3.08,11a3.08,3.08,0,0,1,.16-.93,7,7,0,0,0-.24-3.84,32.5,32.5,0,0,1,1.68,5.88c0-.78.13-1.36.11-2.23a29.12,29.12,0,0,0-1.36-8.16c-.22-.81-.11-1.07.11-.56.33.78.66,1.63,1,2.54a10.24,10.24,0,0,1,1.5,3.36,53.62,53.62,0,0,1-1.34-5.91,28.18,28.18,0,0,0-1.64-6c.07-.2.77,1.25,1.84,3.87s2.53,6.42,3.93,11a10.89,10.89,0,0,1-.44-3.12l.12.33a87.82,87.82,0,0,0-3.41-11.48,42.41,42.41,0,0,1,4.44,9c-2-5.94-3.33-10.38-3.9-12.87a48.06,48.06,0,0,0-1.85-5.84,74.42,74.42,0,0,0-3.31-7.46c.13-.05,1.3,2,3.24,5.59s4.66,8.69,7.7,14.85a6.54,6.54,0,0,1-.26-1.84c.09-.84-.6-3.7-2.67-7.33a87.64,87.64,0,0,1,6.23,10.78c-.38-1.52-.59-2.69-1.15-4.35-2.31-6.69-3.77-8.88-7.39-15.07-.87-1.48-.9-2-.23-1.08a148.4,148.4,0,0,1,11.17,17.36,95.06,95.06,0,0,1,4.26,8.75l.4-.31,0-.08c-.32-1.08-.45-1.86-.85-3-1.53-4.23-2.45-5.58-4.86-9.4-.57-.91-.55-1.26-.09-.72a71.84,71.84,0,0,1,7.39,10.66l.52.94,1.36-1-.49-.74c-1.25-2-2.06-3.44-2.49-3.92a6.17,6.17,0,0,1,1.64,1.75,29.48,29.48,0,0,1-2-3.36,17.47,17.47,0,0,0-2.2-3.39c0-.27,3,2.92,6.49,8a7.05,7.05,0,0,1-.88-1.83l.14.18a62.06,62.06,0,0,0-4.23-6.49,23.29,23.29,0,0,1,4.41,4.79,65.4,65.4,0,0,1-4.58-7.4,36.23,36.23,0,0,0-5.25-7.61c.12-.09,1.23,1,3,2.91s4.27,4.75,7.09,8.18a4.19,4.19,0,0,1-.42-1.14,10.64,10.64,0,0,0-2.64-4.31,47.7,47.7,0,0,1,5.39,6c-.44-.92-.71-1.63-1.26-2.62a44.86,44.86,0,0,0-6.4-8.8c-.72-.84-.75-1.2-.21-.71a78.8,78.8,0,0,1,9,9.82c1.47,1.88,2.66,3.52,3.59,4.92l.26-.17c-.31-.61-.48-1.08-.85-1.73a27.24,27.24,0,0,0-4.08-5.5c-.46-.52-.47-.76-.12-.46a44.41,44.41,0,0,1,5.77,6.09l.56.71a68,68,0,0,1,9.86-5.61,75.41,75.41,0,0,1,9.83-3.63C1444.15,228.72,1443.86,230.05,1443.54,231.37Zm-45.75,24.43c-.13-.42-.26-.85-.4-1.28.11.82.19,1.56.23,2.21l.23-.16C1397.82,256.3,1397.8,256,1397.79,255.8Z"
          fill="#8ac72f"
        />
        <path
          d="M1281.65,141.82a3.83,3.83,0,0,0,2.39,0c1.17-.49,1.6-1.93,1.78-3.19A22.37,22.37,0,0,0,1285,129a17.32,17.32,0,0,0,8.43,4.33,2.7,2.7,0,0,0,2.47-.39,2.89,2.89,0,0,0,.59-1.81l.88-9.85c1.09,1.17,3.23,2.24,4,.82a2.43,2.43,0,0,0,0-1.62,23,23,0,0,0-1.73-4.79c-.09.51.68.81,1.12.53a2.11,2.11,0,0,0,.72-1.35l1.65-6.92c.84,1.54,3.2.78,4.88,1.28a6.09,6.09,0,0,1,2.18,1.42l6.88,6a11.89,11.89,0,0,0-5-10.66c1.09.37,1.35-1.48,1-2.55,2.77-.44,3.86-4.2,2.7-6.75s-3.69-4.16-6-5.7a111.26,111.26,0,0,1-11.91-9,32.44,32.44,0,0,0-6.26-4.72,9.23,9.23,0,0,0-7.58-.7l3,10.62a26.81,26.81,0,0,0-10.14-3.35c-2.31-.28-5.45.47-5.46,2.79a9.9,9.9,0,0,0-5.35-1.3c-1.85.22-3.68,1.66-3.73,3.52l-12.76,5.26-.32,3.78a19.51,19.51,0,0,0-6.14-.93,6.59,6.59,0,0,0-5.28,2.82,53.32,53.32,0,0,1,14.62,5.94A58.91,58.91,0,0,0,1240.68,117l2.89.69a78.34,78.34,0,0,0,2.11,13.54l8,2.88a18.07,18.07,0,0,0,4.82,1.27c1.64.12,3.29-.21,4.94-.23C1269.73,135.09,1275.53,140.33,1281.65,141.82Z"
          fill="#7b9933"
        />
        <path
          d="M1331.87,117.67a4.18,4.18,0,0,0-2.19-1.18,1.77,1.77,0,0,0-2,1.21,3.66,3.66,0,0,0,.53,2c.26.65.3,1.54-.3,1.89a1.69,1.69,0,0,1-.89.16h-3.49a5.06,5.06,0,0,0-2.81.55,1.74,1.74,0,0,0-.54,2.49,20.85,20.85,0,0,0-6.08,3.9,3.44,3.44,0,0,0-1.25,1.88,6.4,6.4,0,0,0,0,1.31c.1,2.15-1.34,4-2.57,5.8s-2.33,4-1.51,6a39.84,39.84,0,0,0,6.14-4.93c.22,1.18-.29,2.34-.48,3.52s.17,2.66,1.32,3a2.7,2.7,0,0,0,2.56-1.2,9.47,9.47,0,0,0,2-4.18,5.25,5.25,0,0,0,3,3.53l1.3-9.09c1.11,1.33,3.43.9,4.51-.46s1.13-3.19,1.14-4.83C1339.79,132.75,1335.6,121,1331.87,117.67Z"
          fill="#7b9933"
        />
        <g>
          <path
            d="M1267.77,100.27c-1.52,1.75-4.56,3.15-5.84,2s-.3-4.32,1.23-6.07,3-1.37,4.29-.26S1269.3,98.52,1267.77,100.27Z"
            fill="#e8f5fa"
          />
          <path
            d="M1267.35,107.24c-2.3-.31-5.15-2.07-4.92-3.75s3.43-2.63,5.73-2.32,2.82,1.76,2.59,3.44S1269.65,107.55,1267.35,107.24Z"
            fill="#e8f5fa"
          />
          <path
            d="M1260.89,109.74c-.83-2.17-.64-5.51.94-6.12s4,1.76,4.78,3.93-.2,3.31-1.78,3.91S1261.72,111.9,1260.89,109.74Z"
            fill="#e8f5fa"
          />
          <path
            d="M1256.39,103c2.06-1.07,5.4-1.26,6.18.24s-1.3,4.13-3.36,5.2-3.32.17-4.1-1.33S1254.33,104,1256.39,103Z"
            fill="#e8f5fa"
          />
          <path
            d="M1260.49,97.06c1.9,1.33,3.61,4.21,2.63,5.6s-4.26.74-6.16-.6-1.68-2.86-.71-4.24S1258.59,95.72,1260.49,97.06Z"
            fill="#e8f5fa"
          />
          <circle cx="1262.28" cy="102.83" r="2.46" fill="#e9ac38" />
        </g>
        <g>
          <path
            d="M1281.38,116c-1.12,1.29-3.36,2.32-4.3,1.51s-.22-3.18.91-4.47a2.25,2.25,0,0,1,3.39,3Z"
            fill="#e8f5fa"
          />
          <path
            d="M1281.07,121.17c-1.69-.22-3.79-1.52-3.62-2.76s2.53-1.93,4.22-1.71a2.26,2.26,0,0,1-.6,4.47Z"
            fill="#e8f5fa"
          />
          <path
            d="M1276.32,123c-.61-1.59-.48-4.06.69-4.5s2.91,1.29,3.52,2.89a2.25,2.25,0,0,1-4.21,1.61Z"
            fill="#e8f5fa"
          />
          <path
            d="M1273,118c1.52-.78,4-.92,4.56.18s-1,3-2.48,3.83a2.26,2.26,0,0,1-2.08-4Z"
            fill="#e8f5fa"
          />
          <path
            d="M1276,113.68c1.4,1,2.66,3.1,1.94,4.12s-3.14.55-4.53-.44a2.25,2.25,0,0,1,2.59-3.68Z"
            fill="#e8f5fa"
          />
          <circle cx="1277.34" cy="117.93" r="1.81" fill="#e9ac38" />
        </g>
        <g>
          <path
            d="M1297.66,86.39c-1.52,1.75-4.56,3.16-5.84,2s-.3-4.32,1.23-6.06,3-1.38,4.29-.27S1299.19,84.64,1297.66,86.39Z"
            fill="#e8f5fa"
          />
          <path
            d="M1297.24,93.36c-2.3-.3-5.15-2.07-4.92-3.75s3.44-2.63,5.74-2.32,2.81,1.76,2.58,3.44S1299.54,93.67,1297.24,93.36Z"
            fill="#e8f5fa"
          />
          <path
            d="M1290.78,95.86c-.83-2.17-.64-5.51.94-6.12s4,1.76,4.78,3.93-.2,3.31-1.78,3.92S1291.61,98,1290.78,95.86Z"
            fill="#e8f5fa"
          />
          <path
            d="M1286.28,89.08c2.06-1.07,5.41-1.26,6.18.25s-1.3,4.12-3.36,5.19-3.32.17-4.1-1.33S1284.22,90.15,1286.28,89.08Z"
            fill="#e8f5fa"
          />
          <path
            d="M1290.38,83.18c1.9,1.33,3.61,4.22,2.63,5.6s-4.26.74-6.16-.59-1.68-2.87-.71-4.25S1288.48,81.84,1290.38,83.18Z"
            fill="#e8f5fa"
          />
          <circle cx="1292.17" cy="88.95" r="2.46" fill="#e9ac38" />
        </g>
        <g>
          <path
            d="M1297.53,108.08c-.84,1-2.52,1.74-3.22,1.13s-.17-2.39.67-3.35a1.69,1.69,0,0,1,2.55,2.22Z"
            fill="#e8f5fa"
          />
          <path
            d="M1297.3,111.93c-1.27-.17-2.84-1.15-2.72-2.07s1.9-1.45,3.17-1.28a1.69,1.69,0,0,1-.45,3.35Z"
            fill="#e8f5fa"
          />
          <path
            d="M1293.73,113.31c-.45-1.2-.35-3,.52-3.38s2.18,1,2.64,2.17a1.69,1.69,0,0,1-3.16,1.21Z"
            fill="#e8f5fa"
          />
          <path
            d="M1291.25,109.56c1.14-.59,3-.69,3.41.14s-.72,2.28-1.85,2.87a1.7,1.7,0,0,1-1.56-3Z"
            fill="#e8f5fa"
          />
          <path
            d="M1293.51,106.3c1,.74,2,2.33,1.46,3.1s-2.36.41-3.4-.33a1.69,1.69,0,0,1,1.94-2.77Z"
            fill="#e8f5fa"
          />
          <circle cx="1294.5" cy="109.49" r="1.36" fill="#e9ac38" />
        </g>
      </g>
      <g transform="translate(-70, 0)">
        <ellipse cx="1386.63" cy="480.61" rx="86.05" ry="30.4" fill="#72a139" />
        <path
          d="M1383.85,500.22c.76-1,1.05-2.35,1.84-3.35,1.18-1.48,3.2-1.93,5.06-2.29a16.66,16.66,0,0,1,5.16-.43c1.78.23,3.48,1,5.28,1.05,4.93,0,17.27-14.41,11.88-18.62-5.2-4.08-5.63,12.55-9.1,14.12a7.62,7.62,0,0,1-3.33.4,55.69,55.69,0,0,0-15.2,1.86,8.9,8.9,0,0,0-4.17,2c-1,1.06-1.55,2.54-2.5,3.67s-2.81,1.84-3.89.82a1.79,1.79,0,0,1,1.22,2.26,5.14,5.14,0,0,1-1.69,2.32c2.27-2.12,6.53-1.16,7.95-4,1.78-3.56-3.07-8.39-5.94-9.5a6.27,6.27,0,0,1-2.49-1.27c-1.61-1.73,0-4.5-.12-6.86-.18-2.73-2.78-4.61-4-7.06-1.6-3.26-.61-7.11-.34-10.73a26,26,0,0,0-6.15-18.59c-2.32,3.25-5.43,7.91-4.17,11.69,1,3,4.17,5,5.2,8,1.23,3.67-.92,8.17,1.25,11.39.87,1.29,2.28,2.09,3.43,3.14a9.92,9.92,0,0,1,3.15,7.4c0,2.09-.7,4.4.51,6.1,1,1.33,2.71,1.74,4.27,2.26S1383.71,498.59,1383.85,500.22Z"
          fill="#7b611c"
        />
        <path
          d="M1289,446.9c.15,4.43.27,9.91,4.24,11.89a15.88,15.88,0,0,0,5,1c7.13,1,12.92,6.08,18.26,10.91l12.15,11a10.37,10.37,0,0,0,3.81,2.54,3.59,3.59,0,0,0,4.1-1.26c-6.25-7.62-16.47-11.1-22.76-18.68-1.54-1.86-2.84-4-4.75-5.43-3.22-2.47-7.66-2.81-11-5.17-4.09-2.93-5.56-8.44-5.28-13.47a13.27,13.27,0,0,0-.13-4.45c-.84-2.93-4.11-5.73-5.77-2.66C1285.76,435.07,1288.88,444.24,1289,446.9Z"
          fill="#7b611c"
        />
        <path
          d="M1448.66,487.65c3.28.14,6.4-1.61,8.8-3.86a22.23,22.23,0,0,0,6.74-18.65,4.64,4.64,0,0,0,1.78.07,9.91,9.91,0,0,0,3.16-18.74c-.05-6.23-1.26-13.47-6.72-16.47-1.92-1.06-4.18-1.44-6-2.7s-3-3.26-4.87-4.31-5.09-.18-5,2c0-2.14-3.13-3.44-4.63-1.92a53.48,53.48,0,0,0-30.53-16.43l-.22,4a31.21,31.21,0,0,0-10.3,29.47c-2.91,3.28-.26,13.2,4.72,17.37a44.88,44.88,0,0,0-27.13-6.57,122.17,122.17,0,0,0-7.5,24.95,16.72,16.72,0,0,0,8.85,1c-2,1.56-1.69,4.89,0,6.76s4.31,2.62,6.8,3.05c2.33.41,5.51,2.1,4.32,4.14,4.45-1,18.39-5.56,20.26-.18,5.51-3.64,8.79-2.6,14.79-2.15,6.76.52,10.84-1.76,15.8-6.5A7.42,7.42,0,0,0,1448.66,487.65Z"
          fill="#557520"
        />
        <path
          d="M1354.5,465.64c6.42,2.68,13.09,5.42,20,5s14.11-4.92,15.44-12c1,3.2,5.91,2.25,7.84-.45s2.57-6.35,5-8.56c3.38-3.06,8.48-2,13-2s10.08-3.09,9.08-7.62l4.81,5.76a14.75,14.75,0,0,1,8.08-1.14c8.16-22.06,1.72-49.08-15.42-64.65-3.71-3.37-11.2-5-12.14,0-1.43-5.68-3.09-11.74-7.44-15.49s-12.29-3.44-14.47,2c-1.61-4.14-7.85-5.15-10.6-1.72-4.2-6.06-8.6-12.31-14.88-16s-15-3.89-20,1.47c-6.11-6.54-18.71-3.3-21.18,5.44-4.1-3-9.07,2.25-11.53,6.78l-12.25,22.59L1292.7,379c-15.3,11.47-23,32.85-18.71,51.92a19.13,19.13,0,0,0,3.17,7.6c2.81,3.6,7.44,5.09,11.88,5.55a36.59,36.59,0,0,0,25.4-7c-3.42-.82-5.35,4-5.28,7.68a24.09,24.09,0,0,0,1.1,7.18,16.75,16.75,0,0,0,6.09,8.26c7.35,5.23,17.41,3.37,25.75,6.64,3.72,1.46,9.91,2.36,9.82-1.77a36,36,0,0,0,24.8,6.2"
          fill="#557520"
        />
        <path
          d="M1304.81,385.12A25.82,25.82,0,0,0,1294.4,372a5,5,0,0,0-.18,3.74,16.22,16.22,0,0,0-11.92-3.59,25,25,0,0,1,3.55,5.94,17.35,17.35,0,0,0-8.94,1.65c0,1.5,2.38,2.14,2.42,3.65a3,3,0,0,1-.81,1.72,24.47,24.47,0,0,0-4.68,11.07,4.15,4.15,0,0,0,.58,3.46c.81.9,2.72.64,2.78-.57q.08,8.1.51,16.19a12.32,12.32,0,0,0,7.42-5.21,10.06,10.06,0,0,0,2.41,7.35l4.35-3c.2.92.33,1.77.54,2.7,1.38.91,3.48,1.71,4.47.38a3.39,3.39,0,0,0,.47-1.24l1-4A7.28,7.28,0,0,0,1300,415a1,1,0,0,0,.58.36,1.12,1.12,0,0,0,.69-.23l6.74-4.05c3.21-1.93,7.08-2.9,9.68-5.59a28.81,28.81,0,0,0,.39,6.69l6.87-7.27a7.54,7.54,0,0,0,7.86-3.34,3.15,3.15,0,0,0,.55-1.69,3.81,3.81,0,0,0-.51-1.59l-3.09-6.36-.9.88a7.08,7.08,0,0,1-2.09-4.11c-.08-.53-.17-1.19-.67-1.39a1.38,1.38,0,0,0-1.17.28,67.35,67.35,0,0,0-6.92,4.7,5,5,0,0,0-2.37-3.78,2.89,2.89,0,0,0-3.93,1.17c-1.55-.58-.46-3.8-2.08-4.14a6.42,6.42,0,0,0-1.15.08c-1,0-1.7-.91-2.4-1.6S1305.48,384.39,1304.81,385.12Z"
          fill="#7b9933"
        />
        <path
          d="M1319.3,426.11c-.07-1.42-2-2.24-3.21-1.57a3.28,3.28,0,0,0-1.35,3.71,6.36,6.36,0,0,0,2.57,3.29,25,25,0,0,0,7.59,3.24,4.36,4.36,0,0,0,2.68.21c.65-.24,1.21-.79,1.9-.79a2.62,2.62,0,0,1,1.34.54,31,31,0,0,0,19.86,4.58,43.35,43.35,0,0,0,.3-10.43c-2.23-.49-5.07.45-6.53-1.31s.1-4.7-.75-6.92c-1.76,1.23-4.06-.27-6-1.26a22.91,22.91,0,0,0-10.59-2.3C1321.62,417.43,1321.16,421.55,1319.3,426.11Z"
          fill="#7b9933"
        />
        <path
          d="M1425.15,466.77l6.25-6.19a3.06,3.06,0,0,0,.08-5.15l-5.41-6.29a4.26,4.26,0,0,0-2,2.09,14.61,14.61,0,0,0-3.36-8.13l-2.57,1.52c-1.19-2-2.5-4.06-4.6-5s-5.18,0-5.49,2.32c-1.39-2.57-4.15-4.67-7-4.27s-5,4.21-3.19,6.49c-5.38,1.69-8.21,8.83-5.44,13.75a71.09,71.09,0,0,0-20.73-1.39,1.69,1.69,0,0,0-2,2.07l0,5.77c3.76,1.53,8,.88,12,.66a52.44,52.44,0,0,1,10.77.54c-.65,3.41,3.06,6.37,6.53,6.34s6.56-2.07,9.43-4c-.73,1.61.77,3.52,2.5,3.89s3.5-.3,5.15-1c5.16-2.08,10.58-4.34,14-8.77"
          fill="#7b9933"
        />
        <path
          d="M1412,408.11c1.77,2.06,5.27,1.9,7.34.14s2.88-4.64,2.84-7.35c-.57.28-.06,1.27.57,1.22s1.06-.66,1.34-1.23a11.74,11.74,0,0,0,1.1-6.47,2.2,2.2,0,0,0-.62-1.5,2.51,2.51,0,0,0-1.07-.42l-9.13-1.94a7.81,7.81,0,0,0-.79,4,3.23,3.23,0,0,0-4.83,2l-9.6-3.83a4.69,4.69,0,0,0-3.53-.41,4,4,0,0,0-1.77,1.91,13.62,13.62,0,0,0-1.51,7.72,2.47,2.47,0,1,0-3.53,3.42,9.75,9.75,0,0,0-5.7,9.85,10.9,10.9,0,0,0-2.6,5.07,16.5,16.5,0,0,0,1.74,1c-.57,5.29,6,.41,8.41.39,3,0,5.07,2.55,7.86,2.94,4.86.68,5.14-2.87,8.29-5.58,1.64-1.41,2.56-.38,4-2.83C1411.23,415.42,1412.43,408.59,1412,408.11Z"
          fill="#7b9933"
        />
        <path
          d="M1353.72,426.35c4.21-4.78-7.44-10.13-13.33-11.89C1340.37,421,1347.66,433.26,1353.72,426.35Z"
          fill="#557520"
        />
        <path
          d="M1351.8,431.3c6.14,1.68,5.85-11.12,4.85-17.19C1350.74,417,1342.94,428.88,1351.8,431.3Z"
          fill="#557520"
        />
        <path
          d="M1377.62,424.12c4.2-4.78-7.44-10.13-13.33-11.89C1364.27,418.79,1371.56,431,1377.62,424.12Z"
          fill="#557520"
        />
        <path
          d="M1375.7,429.07c6.14,1.68,5.84-11.12,4.85-17.19C1374.64,414.74,1366.84,426.65,1375.7,429.07Z"
          fill="#557520"
        />
        <g>
          <path
            d="M1294.39,378.45c-1.65,1.9-5,3.42-6.34,2.22s-.33-4.69,1.33-6.59,3.28-1.5,4.66-.29S1296.05,376.55,1294.39,378.45Z"
            fill="#e8f5fa"
          />
          <path
            d="M1293.94,386c-2.5-.33-5.59-2.25-5.35-4.07s3.73-2.86,6.23-2.52,3,1.91,2.81,3.73S1296.43,386.35,1293.94,386Z"
            fill="#e8f5fa"
          />
          <path
            d="M1286.92,388.73c-.9-2.35-.7-6,1-6.64s4.29,1.91,5.19,4.26-.21,3.6-1.93,4.25S1287.82,391.08,1286.92,388.73Z"
            fill="#e8f5fa"
          />
          <path
            d="M1282,381.37c2.24-1.16,5.87-1.37,6.72.27s-1.42,4.48-3.66,5.64-3.6.18-4.44-1.45S1279.8,382.53,1282,381.37Z"
            fill="#e8f5fa"
          />
          <path
            d="M1286.48,375c2.06,1.45,3.92,4.58,2.86,6.08s-4.63.81-6.69-.64-1.82-3.11-.76-4.61S1284.42,373.51,1286.48,375Z"
            fill="#e8f5fa"
          />
          <circle cx="1288.43" cy="381.23" r="2.67" fill="#e9ac38" />
        </g>
        <g>
          <path
            d="M1313.48,398.18c-1,1.1-2.88,2-3.69,1.29s-.19-2.72.78-3.82a1.93,1.93,0,0,1,2.91,2.53Z"
            fill="#e8f5fa"
          />
          <path
            d="M1313.21,402.58c-1.45-.2-3.24-1.31-3.1-2.37s2.16-1.66,3.61-1.46a1.93,1.93,0,0,1-.51,3.83Z"
            fill="#e8f5fa"
          />
          <path
            d="M1309.14,404.15c-.52-1.37-.41-3.48.59-3.86s2.49,1.11,3,2.48a1.93,1.93,0,0,1-3.6,1.38Z"
            fill="#e8f5fa"
          />
          <path
            d="M1306.3,399.88c1.3-.68,3.41-.8,3.9.15s-.82,2.6-2.12,3.27a1.93,1.93,0,0,1-1.78-3.42Z"
            fill="#e8f5fa"
          />
          <path
            d="M1308.89,396.16c1.19.84,2.27,2.65,1.65,3.53s-2.68.46-3.88-.38a1.93,1.93,0,0,1,2.23-3.15Z"
            fill="#e8f5fa"
          />
          <circle cx="1310.02" cy="399.8" r="1.55" fill="#e9ac38" />
        </g>
        <g>
          <path
            d="M1328.55,418.2c-1.62,1.85-4.85,3.35-6.21,2.16s-.32-4.58,1.3-6.44,3.21-1.46,4.56-.28S1330.17,416.34,1328.55,418.2Z"
            fill="#e8f5fa"
          />
          <path
            d="M1328.1,425.6c-2.44-.33-5.47-2.2-5.23-4s3.65-2.8,6.09-2.47,3,1.87,2.75,3.65S1330.54,425.93,1328.1,425.6Z"
            fill="#e8f5fa"
          />
          <path
            d="M1321.24,428.25c-.88-2.3-.69-5.85,1-6.5s4.2,1.87,5.08,4.17-.21,3.52-1.89,4.17S1322.12,430.55,1321.24,428.25Z"
            fill="#e8f5fa"
          />
          <path
            d="M1316.46,421.05c2.18-1.13,5.74-1.33,6.56.26s-1.38,4.39-3.57,5.52-3.52.18-4.35-1.41S1314.27,422.18,1316.46,421.05Z"
            fill="#e8f5fa"
          />
          <path
            d="M1320.81,414.78c2,1.42,3.83,4.48,2.8,6s-4.53.79-6.55-.63-1.78-3-.75-4.51S1318.8,413.36,1320.81,414.78Z"
            fill="#e8f5fa"
          />
          <circle cx="1322.72" cy="420.92" r="2.61" fill="#e9ac38" />
        </g>
        <g>
          <path
            d="M1407.88,399.28c-1.62,1.85-4.85,3.34-6.2,2.16s-.32-4.58,1.3-6.44,3.21-1.46,4.56-.28S1409.5,397.42,1407.88,399.28Z"
            fill="#e8f5fa"
          />
          <path
            d="M1407.44,406.68c-2.45-.33-5.47-2.2-5.23-4s3.65-2.8,6.09-2.47,3,1.87,2.75,3.65S1409.88,407,1407.44,406.68Z"
            fill="#e8f5fa"
          />
          <path
            d="M1400.57,409.33c-.88-2.3-.68-5.86,1-6.5s4.2,1.87,5.08,4.17-.21,3.52-1.89,4.16S1401.45,411.63,1400.57,409.33Z"
            fill="#e8f5fa"
          />
          <path
            d="M1395.79,402.13c2.19-1.13,5.74-1.34,6.57.26s-1.39,4.38-3.57,5.52-3.53.18-4.35-1.42S1393.6,403.26,1395.79,402.13Z"
            fill="#e8f5fa"
          />
          <path
            d="M1400.15,395.86c2,1.42,3.83,4.48,2.79,5.95s-4.53.79-6.54-.63-1.79-3-.75-4.51S1398.13,394.44,1400.15,395.86Z"
            fill="#e8f5fa"
          />
          <circle cx="1402.05" cy="401.99" r="2.61" fill="#e9ac38" />
        </g>
        <g>
          <path
            d="M1430.69,459c-1.62,1.86-4.85,3.35-6.21,2.17s-.31-4.59,1.31-6.44,3.2-1.46,4.56-.28S1432.31,457.13,1430.69,459Z"
            fill="#e8f5fa"
          />
          <path
            d="M1430.24,466.39c-2.44-.33-5.47-2.2-5.23-4s3.65-2.79,6.1-2.46,3,1.87,2.75,3.65S1432.68,466.71,1430.24,466.39Z"
            fill="#e8f5fa"
          />
          <path
            d="M1423.38,469c-.88-2.3-.68-5.86,1-6.5s4.21,1.87,5.09,4.17-.21,3.52-1.89,4.16S1424.26,471.34,1423.38,469Z"
            fill="#e8f5fa"
          />
          <path
            d="M1418.6,461.84c2.19-1.14,5.74-1.34,6.57.26s-1.39,4.38-3.58,5.52-3.52.18-4.34-1.42S1416.41,463,1418.6,461.84Z"
            fill="#e8f5fa"
          />
          <path
            d="M1423,455.57c2,1.42,3.84,4.48,2.8,5.95s-4.53.79-6.54-.63-1.79-3-.75-4.51S1420.94,454.15,1423,455.57Z"
            fill="#e8f5fa"
          />
          <circle cx="1424.86" cy="461.7" r="2.61" fill="#e9ac38" />
        </g>
        <path
          d="M1336.7,400.14a3.73,3.73,0,0,0,2.38,0c1.18-.49,1.61-1.92,1.78-3.19a22.37,22.37,0,0,0-.77-9.69,17.28,17.28,0,0,0,8.43,4.33,2.68,2.68,0,0,0,2.46-.39,2.82,2.82,0,0,0,.59-1.8l.89-9.86c1.08,1.17,3.23,2.24,4,.82a2.37,2.37,0,0,0,0-1.62,21.93,21.93,0,0,0-1.73-4.79c-.08.51.68.81,1.12.53a2.07,2.07,0,0,0,.72-1.35l1.65-6.92c.85,1.54,3.2.78,4.89,1.28a6.18,6.18,0,0,1,2.18,1.42l6.88,6a11.92,11.92,0,0,0-5-10.66c1.08.38,1.35-1.47.94-2.55,2.77-.44,3.86-4.19,2.7-6.75s-3.68-4.15-6-5.7a113.3,113.3,0,0,1-11.91-9,32.14,32.14,0,0,0-6.26-4.72,9.19,9.19,0,0,0-7.58-.69l3,10.62a26.82,26.82,0,0,0-10.14-3.36c-2.3-.28-5.45.47-5.46,2.79a9.88,9.88,0,0,0-5.35-1.3c-1.85.22-3.67,1.66-3.72,3.52l-12.77,5.26-.32,3.78a19.49,19.49,0,0,0-6.13-.93,6.63,6.63,0,0,0-5.29,2.83,53,53,0,0,1,14.63,5.94,58.32,58.32,0,0,0-11.74,11.32l2.89.7a77.42,77.42,0,0,0,2.11,13.53l7.94,2.89a18.14,18.14,0,0,0,4.82,1.26c1.65.12,3.29-.2,4.94-.22C1324.78,393.41,1330.58,398.65,1336.7,400.14Z"
          fill="#7b9933"
        />
        <path
          d="M1386.91,376a4.12,4.12,0,0,0-2.18-1.18,1.78,1.78,0,0,0-2,1.21,3.66,3.66,0,0,0,.53,2c.26.65.31,1.54-.3,1.9a1.75,1.75,0,0,1-.88.15h-3.5a5,5,0,0,0-2.8.55,1.74,1.74,0,0,0-.54,2.49,20.9,20.9,0,0,0-6.09,3.9,3.42,3.42,0,0,0-1.24,1.88,5.76,5.76,0,0,0,0,1.31c.1,2.16-1.35,4-2.57,5.81s-2.34,4-1.51,6a39.78,39.78,0,0,0,6.14-4.92c.21,1.17-.3,2.33-.48,3.51s.17,2.66,1.31,3a2.68,2.68,0,0,0,2.56-1.19,9.57,9.57,0,0,0,2-4.18,5.28,5.28,0,0,0,3,3.52l1.31-9.08c1.1,1.32,3.42.89,4.5-.46s1.13-3.2,1.15-4.83C1394.83,391.08,1390.64,379.35,1386.91,376Z"
          fill="#7b9933"
        />
        <g>
          <path
            d="M1322.82,358.59c-1.53,1.75-4.57,3.16-5.84,2s-.3-4.32,1.22-6.06,3-1.38,4.3-.27S1324.34,356.84,1322.82,358.59Z"
            fill="#e8f5fa"
          />
          <path
            d="M1322.4,365.56c-2.3-.3-5.15-2.07-4.93-3.75s3.44-2.63,5.74-2.32,2.81,1.76,2.59,3.44S1324.7,365.87,1322.4,365.56Z"
            fill="#e8f5fa"
          />
          <path
            d="M1315.94,368.06c-.83-2.17-.65-5.51.93-6.12s4,1.76,4.79,3.93-.2,3.31-1.78,3.92S1316.77,370.23,1315.94,368.06Z"
            fill="#e8f5fa"
          />
          <path
            d="M1311.43,361.28c2.06-1.07,5.41-1.26,6.19.25s-1.31,4.12-3.37,5.19-3.31.17-4.09-1.33S1309.37,362.35,1311.43,361.28Z"
            fill="#e8f5fa"
          />
          <path
            d="M1315.53,355.38c1.9,1.33,3.61,4.22,2.64,5.6s-4.27.74-6.16-.59-1.69-2.87-.71-4.25S1313.64,354,1315.53,355.38Z"
            fill="#e8f5fa"
          />
          <circle cx="1317.33" cy="361.15" r="2.46" fill="#e9ac38" />
        </g>
        <g>
          <path
            d="M1336.43,374.37c-1.12,1.28-3.36,2.32-4.3,1.5s-.22-3.18.9-4.47a2.26,2.26,0,0,1,3.4,3Z"
            fill="#e8f5fa"
          />
          <path
            d="M1336.12,379.5c-1.69-.23-3.79-1.53-3.63-2.76s2.53-1.94,4.23-1.71a2.26,2.26,0,0,1-.6,4.47Z"
            fill="#e8f5fa"
          />
          <path
            d="M1331.36,381.33c-.61-1.59-.47-4.05.69-4.5s2.91,1.29,3.52,2.89a2.25,2.25,0,0,1-4.21,1.61Z"
            fill="#e8f5fa"
          />
          <path
            d="M1328.05,376.34c1.52-.78,4-.92,4.55.18s-1,3-2.48,3.83a2.26,2.26,0,0,1-2.07-4Z"
            fill="#e8f5fa"
          />
          <path
            d="M1331.07,372c1.39,1,2.65,3.1,1.94,4.12s-3.14.55-4.54-.43a2.26,2.26,0,0,1,2.6-3.69Z"
            fill="#e8f5fa"
          />
          <circle cx="1332.39" cy="376.25" r="1.81" fill="#e9ac38" />
        </g>
        <g>
          <path
            d="M1352.71,344.71c-1.52,1.75-4.57,3.16-5.84,2.05s-.3-4.32,1.22-6.07,3-1.38,4.3-.27S1354.23,343,1352.71,344.71Z"
            fill="#e8f5fa"
          />
          <path
            d="M1352.29,351.69c-2.3-.31-5.15-2.08-4.93-3.75s3.44-2.64,5.74-2.33,2.81,1.76,2.59,3.44S1354.59,352,1352.29,351.69Z"
            fill="#e8f5fa"
          />
          <path
            d="M1345.83,354.18c-.83-2.16-.65-5.51.93-6.12s4,1.76,4.79,3.93-.2,3.31-1.78,3.92S1346.66,356.35,1345.83,354.18Z"
            fill="#e8f5fa"
          />
          <path
            d="M1341.32,347.4c2.06-1.07,5.41-1.25,6.19.25s-1.31,4.12-3.37,5.19-3.31.17-4.09-1.33S1339.26,348.47,1341.32,347.4Z"
            fill="#e8f5fa"
          />
          <path
            d="M1345.43,341.5c1.89,1.33,3.6,4.22,2.63,5.6s-4.27.74-6.16-.59-1.68-2.86-.71-4.25S1343.53,340.16,1345.43,341.5Z"
            fill="#e8f5fa"
          />
          <circle cx="1347.22" cy="347.27" r="2.46" fill="#e9ac38" />
        </g>
        <g>
          <path
            d="M1352.58,366.4c-.84,1-2.52,1.74-3.23,1.13s-.16-2.39.68-3.35a1.69,1.69,0,0,1,2.55,2.22Z"
            fill="#e8f5fa"
          />
          <path
            d="M1352.35,370.25c-1.27-.17-2.85-1.15-2.72-2.07s1.9-1.45,3.17-1.28a1.69,1.69,0,0,1-.45,3.35Z"
            fill="#e8f5fa"
          />
          <path
            d="M1348.78,371.63c-.46-1.2-.36-3.05.52-3.38s2.18,1,2.64,2.17a1.69,1.69,0,0,1-3.16,1.21Z"
            fill="#e8f5fa"
          />
          <path
            d="M1346.29,367.88c1.14-.58,3-.69,3.42.14s-.72,2.28-1.86,2.87a1.7,1.7,0,0,1-1.56-3Z"
            fill="#e8f5fa"
          />
          <path
            d="M1348.56,364.63c1,.73,2,2.32,1.45,3.09s-2.35.41-3.4-.33a1.69,1.69,0,0,1,2-2.76Z"
            fill="#e8f5fa"
          />
          <circle cx="1349.55" cy="367.81" r="1.36" fill="#e9ac38" />
        </g>
      </g>
      <g transform="translate(-20, -20)">
        <ellipse cx="1180.81" cy="224.13" rx="86.05" ry="30.4" fill="#72a139" />
        <path
          d="M1178,243.74c.76-1,1-2.35,1.84-3.35,1.18-1.48,3.2-1.93,5.06-2.29a16.68,16.68,0,0,1,5.16-.43c1.79.23,3.48,1,5.28,1.05,4.93,0,17.27-14.41,11.89-18.62-5.21-4.08-5.64,12.55-9.11,14.12a7.59,7.59,0,0,1-3.32.4,55.71,55.71,0,0,0-15.21,1.86,8.9,8.9,0,0,0-4.17,2c-1,1.06-1.54,2.54-2.5,3.67s-2.81,1.84-3.89.82a1.79,1.79,0,0,1,1.22,2.26,5.14,5.14,0,0,1-1.69,2.32c2.27-2.12,6.54-1.16,8-4,1.78-3.56-3.08-8.39-6-9.5a6.27,6.27,0,0,1-2.49-1.27c-1.61-1.73,0-4.5-.12-6.86-.18-2.73-2.78-4.61-4-7.06-1.6-3.26-.61-7.11-.35-10.73a26,26,0,0,0-6.15-18.59c-2.32,3.25-5.43,7.91-4.17,11.69,1,3,4.18,5,5.2,8,1.23,3.67-.92,8.17,1.25,11.39.87,1.29,2.29,2.09,3.43,3.14a9.84,9.84,0,0,1,3.15,7.4c0,2.09-.7,4.4.51,6.1,1,1.33,2.72,1.74,4.27,2.26S1177.89,242.11,1178,243.74Z"
          fill="#7b611c"
        />
        <path
          d="M1083.15,190.42c.14,4.43.27,9.91,4.24,11.89a15.76,15.76,0,0,0,4.94,1c7.13,1,12.92,6.08,18.26,10.91l12.15,11a10.41,10.41,0,0,0,3.82,2.54,3.58,3.58,0,0,0,4.09-1.26c-6.25-7.62-16.47-11.1-22.76-18.68-1.54-1.86-2.84-4-4.75-5.43-3.21-2.47-7.66-2.81-11-5.17-4.09-2.93-5.57-8.44-5.29-13.47a13.53,13.53,0,0,0-.12-4.45c-.84-2.93-4.11-5.73-5.78-2.66C1079.94,178.59,1083.06,187.76,1083.15,190.42Z"
          fill="#7b611c"
        />
        <path
          d="M1242.84,231.17c3.29.14,6.4-1.61,8.8-3.86a22.2,22.2,0,0,0,6.74-18.65,4.64,4.64,0,0,0,1.78.07,9.91,9.91,0,0,0,3.17-18.74c-.06-6.23-1.26-13.48-6.73-16.47-1.92-1.06-4.18-1.44-6-2.7s-3-3.26-4.87-4.31-5.09-.18-5,2c0-2.14-3.12-3.44-4.63-1.92a53.45,53.45,0,0,0-30.52-16.43l-.22,4a31.17,31.17,0,0,0-10.3,29.47c-2.92,3.28-.26,13.2,4.71,17.37a44.88,44.88,0,0,0-27.13-6.57,123.44,123.44,0,0,0-7.5,25,16.73,16.73,0,0,0,8.85,1c-2,1.56-1.69,4.89,0,6.76s4.3,2.62,6.79,3.05c2.33.41,5.52,2.1,4.32,4.14,4.45-1,18.39-5.56,20.26-.18,5.51-3.64,8.79-2.6,14.79-2.15,6.76.52,10.85-1.76,15.8-6.5A7.43,7.43,0,0,0,1242.84,231.17Z"
          fill="#557520"
        />
        <path
          d="M1148.69,209.16c6.41,2.68,13.08,5.41,20,5s14.1-4.92,15.43-12c1,3.2,5.91,2.25,7.84-.45s2.57-6.35,5-8.56c3.38-3.06,8.48-2,13-2s10.08-3.09,9.08-7.62l4.81,5.76a14.78,14.78,0,0,1,8.08-1.14c8.17-22.06,1.72-49.08-15.42-64.65-3.71-3.37-11.19-5-12.14,0-1.43-5.68-3.08-11.74-7.43-15.49s-12.3-3.44-14.47,2c-1.62-4.14-7.85-5.15-10.6-1.72-4.21-6.06-8.61-12.31-14.89-16s-15-3.89-20,1.47c-6.11-6.54-18.71-3.3-21.18,5.44-4.1-3-9.07,2.25-11.53,6.78L1092,128.58l-5.09-6.07c-15.3,11.47-23,32.85-18.7,51.92a19,19,0,0,0,3.16,7.6c2.81,3.6,7.45,5.09,11.89,5.55a36.57,36.57,0,0,0,25.39-7c-3.42-.82-5.34,4-5.27,7.68a23.46,23.46,0,0,0,1.1,7.18,16.73,16.73,0,0,0,6.08,8.26c7.36,5.23,17.41,3.37,25.75,6.64,3.72,1.46,9.91,2.36,9.82-1.77a36,36,0,0,0,24.81,6.2"
          fill="#557520"
        />
        <path
          d="M1099,128.64a25.83,25.83,0,0,0-10.42-13.1,5,5,0,0,0-.18,3.74,16.22,16.22,0,0,0-11.92-3.59,25.38,25.38,0,0,1,3.56,5.94,17.37,17.37,0,0,0-9,1.65c0,1.5,2.38,2.14,2.42,3.65a2.88,2.88,0,0,1-.81,1.71,24.66,24.66,0,0,0-4.68,11.08,4.19,4.19,0,0,0,.58,3.46c.81.9,2.72.64,2.79-.57q.06,8.1.5,16.19a12.31,12.31,0,0,0,7.43-5.21,10.09,10.09,0,0,0,2.4,7.35l4.35-3c.21.92.33,1.77.54,2.7,1.39.9,3.48,1.71,4.47.38a3.41,3.41,0,0,0,.48-1.24l.94-4a7.55,7.55,0,0,0,1.69,2.74,1,1,0,0,0,.58.36,1.15,1.15,0,0,0,.7-.23l6.74-4c3.21-1.93,7.07-2.9,9.68-5.59a29.36,29.36,0,0,0,.38,6.69l6.88-7.27a7.53,7.53,0,0,0,7.85-3.34,3.16,3.16,0,0,0,.56-1.69,4,4,0,0,0-.52-1.59l-3.09-6.36-.9.88a7.2,7.2,0,0,1-2.09-4.11c-.07-.54-.16-1.19-.67-1.39a1.38,1.38,0,0,0-1.17.28,67.35,67.35,0,0,0-6.92,4.7,5,5,0,0,0-2.36-3.78,2.9,2.9,0,0,0-3.94,1.17c-1.55-.58-.46-3.8-2.08-4.14a6.42,6.42,0,0,0-1.15.08c-1,0-1.69-.91-2.4-1.6S1099.66,127.91,1099,128.64Z"
          fill="#7b9933"
        />
        <path
          d="M1113.48,169.63c-.07-1.42-2-2.24-3.21-1.57a3.27,3.27,0,0,0-1.34,3.71,6.29,6.29,0,0,0,2.56,3.29,25.08,25.08,0,0,0,7.59,3.24,4.39,4.39,0,0,0,2.69.21c.65-.24,1.2-.79,1.9-.79a2.62,2.62,0,0,1,1.33.54,31,31,0,0,0,19.86,4.58,43.87,43.87,0,0,0,.31-10.43c-2.24-.49-5.07.45-6.53-1.31s.09-4.7-.75-6.92c-1.77,1.23-4.06-.27-6-1.26a22.89,22.89,0,0,0-10.59-2.3C1115.81,161,1115.35,165.07,1113.48,169.63Z"
          fill="#7b9933"
        />
        <path
          d="M1219.33,210.29l6.25-6.19a3.06,3.06,0,0,0,.08-5.15l-5.4-6.29a4.24,4.24,0,0,0-2,2.09,14.61,14.61,0,0,0-3.36-8.13l-2.57,1.52c-1.18-2-2.5-4.06-4.6-5s-5.17,0-5.49,2.32c-1.38-2.57-4.14-4.67-7-4.27s-5,4.21-3.19,6.49c-5.38,1.69-8.2,8.83-5.44,13.75a71.09,71.09,0,0,0-20.73-1.39,2.21,2.21,0,0,0-1.61.59,2.27,2.27,0,0,0-.34,1.48l0,5.77c3.76,1.53,8,.88,12.06.66a52.38,52.38,0,0,1,10.76.54c-.65,3.41,3.06,6.37,6.53,6.34s6.56-2.07,9.43-4c-.73,1.61.78,3.52,2.51,3.89s3.5-.3,5.14-1c5.16-2.08,10.58-4.34,14-8.77"
          fill="#7b9933"
        />
        <path
          d="M1206.2,151.63c1.76,2.06,5.26,1.9,7.33.14s2.89-4.64,2.85-7.35c-.57.28-.07,1.27.56,1.22s1.06-.66,1.34-1.23a11.66,11.66,0,0,0,1.11-6.47,2.29,2.29,0,0,0-.62-1.5,2.55,2.55,0,0,0-1.08-.42l-9.13-1.94a7.91,7.91,0,0,0-.79,4,3.23,3.23,0,0,0-4.83,2l-9.6-3.83c-1.13-.45-2.41-.9-3.52-.41a3.92,3.92,0,0,0-1.77,1.91,13.54,13.54,0,0,0-1.52,7.72,2.46,2.46,0,1,0-3.52,3.42,9.73,9.73,0,0,0-5.7,9.85,10.92,10.92,0,0,0-2.61,5.07,16.5,16.5,0,0,0,1.74,1c-.56,5.29,6.06.41,8.41.39,3,0,5.07,2.55,7.87,2.94,4.85.68,5.13-2.87,8.28-5.58,1.64-1.41,2.57-.38,4-2.83C1205.41,158.94,1206.61,152.11,1206.2,151.63Z"
          fill="#7b9933"
        />
        <path
          d="M1147.91,169.87c4.2-4.78-7.44-10.13-13.34-11.89C1134.56,164.54,1141.85,176.78,1147.91,169.87Z"
          fill="#557520"
        />
        <path
          d="M1146,174.82c6.15,1.68,5.85-11.12,4.85-17.19C1144.93,160.49,1137.12,172.4,1146,174.82Z"
          fill="#557520"
        />
        <path
          d="M1171.8,167.64c4.2-4.78-7.44-10.13-13.33-11.89C1158.45,162.31,1165.74,174.55,1171.8,167.64Z"
          fill="#557520"
        />
        <path
          d="M1169.88,172.59c6.14,1.68,5.85-11.12,4.85-17.19C1168.82,158.26,1161,170.17,1169.88,172.59Z"
          fill="#557520"
        />
        <g>
          <path
            d="M1088.58,122c-1.66,1.9-5,3.42-6.35,2.22s-.32-4.69,1.33-6.59,3.28-1.5,4.67-.29S1090.23,120.07,1088.58,122Z"
            fill="#e8f5fa"
          />
          <path
            d="M1088.12,129.54c-2.5-.33-5.59-2.25-5.35-4.07s3.73-2.86,6.23-2.52,3.06,1.91,2.81,3.73S1090.62,129.87,1088.12,129.54Z"
            fill="#e8f5fa"
          />
          <path
            d="M1081.1,132.25c-.9-2.35-.7-6,1-6.64s4.29,1.91,5.2,4.26-.22,3.6-1.94,4.25S1082,134.6,1081.1,132.25Z"
            fill="#e8f5fa"
          />
          <path
            d="M1076.21,124.89c2.24-1.16,5.88-1.37,6.72.27s-1.42,4.48-3.65,5.64-3.6.18-4.45-1.45S1074,126.05,1076.21,124.89Z"
            fill="#e8f5fa"
          />
          <path
            d="M1080.67,118.48c2.06,1.45,3.91,4.58,2.86,6.08s-4.63.81-6.69-.64-1.83-3.11-.77-4.61S1078.61,117,1080.67,118.48Z"
            fill="#e8f5fa"
          />
          <circle cx="1082.62" cy="124.75" r="2.67" fill="#e9ac38" />
        </g>
        <g>
          <path
            d="M1107.66,141.7c-1,1.1-2.88,2-3.68,1.29s-.19-2.72.77-3.82a1.93,1.93,0,0,1,2.91,2.53Z"
            fill="#e8f5fa"
          />
          <path
            d="M1107.39,146.1c-1.45-.2-3.24-1.31-3.1-2.37s2.17-1.66,3.61-1.46a1.93,1.93,0,0,1-.51,3.83Z"
            fill="#e8f5fa"
          />
          <path
            d="M1103.32,147.67c-.52-1.37-.4-3.48.59-3.86s2.49,1.11,3,2.48a1.93,1.93,0,0,1-3.61,1.38Z"
            fill="#e8f5fa"
          />
          <path
            d="M1100.48,143.4c1.3-.68,3.41-.8,3.9.15s-.82,2.6-2.12,3.27a1.93,1.93,0,0,1-1.78-3.42Z"
            fill="#e8f5fa"
          />
          <path
            d="M1103.07,139.68c1.19.84,2.27,2.65,1.66,3.53s-2.69.46-3.89-.38a1.93,1.93,0,0,1,2.23-3.15Z"
            fill="#e8f5fa"
          />
          <circle cx="1104.2" cy="143.32" r="1.55" fill="#e9ac38" />
        </g>
        <g>
          <path
            d="M1122.73,161.72c-1.62,1.85-4.85,3.35-6.21,2.16s-.31-4.58,1.31-6.44,3.2-1.46,4.56-.28S1124.35,159.86,1122.73,161.72Z"
            fill="#e8f5fa"
          />
          <path
            d="M1122.28,169.12c-2.44-.33-5.47-2.2-5.23-4s3.65-2.8,6.1-2.47,3,1.87,2.75,3.65S1124.72,169.45,1122.28,169.12Z"
            fill="#e8f5fa"
          />
          <path
            d="M1115.42,171.77c-.88-2.3-.68-5.85,1-6.5s4.2,1.87,5.09,4.17-.22,3.52-1.89,4.17S1116.3,174.07,1115.42,171.77Z"
            fill="#e8f5fa"
          />
          <path
            d="M1110.64,164.57c2.19-1.13,5.74-1.33,6.57.26s-1.39,4.39-3.58,5.52-3.52.18-4.35-1.41S1108.45,165.7,1110.64,164.57Z"
            fill="#e8f5fa"
          />
          <path
            d="M1115,158.3c2,1.42,3.83,4.48,2.8,5.95s-4.53.79-6.54-.63-1.79-3-.75-4.51S1113,156.88,1115,158.3Z"
            fill="#e8f5fa"
          />
          <circle cx="1116.9" cy="164.44" r="2.61" fill="#e9ac38" />
        </g>
        <g>
          <path
            d="M1202.07,142.8c-1.62,1.85-4.85,3.34-6.21,2.16s-.32-4.58,1.3-6.44,3.21-1.46,4.56-.28S1203.69,140.94,1202.07,142.8Z"
            fill="#e8f5fa"
          />
          <path
            d="M1201.62,150.2c-2.44-.33-5.47-2.2-5.23-4s3.65-2.8,6.09-2.47,3,1.87,2.75,3.65S1204.06,150.53,1201.62,150.2Z"
            fill="#e8f5fa"
          />
          <path
            d="M1194.76,152.85c-.89-2.3-.69-5.86,1-6.5s4.2,1.87,5.08,4.17-.21,3.52-1.89,4.16S1195.64,155.15,1194.76,152.85Z"
            fill="#e8f5fa"
          />
          <path
            d="M1190,145.65c2.19-1.13,5.75-1.34,6.57.26s-1.38,4.38-3.57,5.52-3.52.18-4.35-1.42S1187.79,146.78,1190,145.65Z"
            fill="#e8f5fa"
          />
          <path
            d="M1194.33,139.38c2,1.42,3.83,4.48,2.8,6s-4.53.79-6.55-.63-1.78-3-.75-4.51S1192.32,138,1194.33,139.38Z"
            fill="#e8f5fa"
          />
          <circle cx="1196.24" cy="145.51" r="2.61" fill="#e9ac38" />
        </g>
        <g>
          <path
            d="M1224.87,202.5c-1.61,1.86-4.85,3.35-6.2,2.17s-.32-4.59,1.3-6.44,3.21-1.46,4.56-.28S1226.49,200.65,1224.87,202.5Z"
            fill="#e8f5fa"
          />
          <path
            d="M1224.43,209.91c-2.45-.33-5.47-2.2-5.23-4s3.65-2.79,6.09-2.46,3,1.87,2.75,3.65S1226.87,210.23,1224.43,209.91Z"
            fill="#e8f5fa"
          />
          <path
            d="M1217.56,212.56c-.88-2.3-.68-5.86,1-6.5s4.2,1.87,5.08,4.17-.21,3.52-1.89,4.16S1218.45,214.86,1217.56,212.56Z"
            fill="#e8f5fa"
          />
          <path
            d="M1212.78,205.36c2.19-1.14,5.74-1.34,6.57.26s-1.39,4.38-3.57,5.52-3.52.18-4.35-1.42S1210.59,206.49,1212.78,205.36Z"
            fill="#e8f5fa"
          />
          <path
            d="M1217.14,199.09c2,1.42,3.83,4.48,2.79,5.95s-4.53.79-6.54-.63-1.79-3-.75-4.51S1215.12,197.67,1217.14,199.09Z"
            fill="#e8f5fa"
          />
          <circle cx="1219.04" cy="205.22" r="2.61" fill="#e9ac38" />
        </g>
        <path
          d="M1231.21,272.5c-7.24.06-13.81-.31-19.74-.49-3-.08-5.74-.13-8.59-.1s-5.68.1-8.52.23a211,211,0,0,0-33.79,4.37l-5.45-.87,2.21-1.54c-.24-.43-.44-.55-.51-.22a39.09,39.09,0,0,1-1.22-4.75,34.26,34.26,0,0,0-.56-3.49,3.39,3.39,0,0,1,.72,1.68,15.18,15.18,0,0,1-.32-3,9,9,0,0,0-.44-3c.2-.21,1.42,2.87,2.22,7.53a3.9,3.9,0,0,1,0-1.56l0,.16a38.85,38.85,0,0,0-.7-5.85,11.42,11.42,0,0,1,1.68,4.68,27,27,0,0,1-.31-6.65,18.2,18.2,0,0,0-.61-7c.43-.08,2,4.33,3.3,11a2.38,2.38,0,0,1,.28-.94,6,6,0,0,0,.12-3.9,22.62,22.62,0,0,1,1.44,6c.13-.79.31-1.39.41-2.26a24.28,24.28,0,0,0-.33-8.29c-.13-.84.12-1.1.32-.58a24.8,24.8,0,0,1,.85,2.6,7,7,0,0,1,1.3,3.48,29.49,29.49,0,0,1-.33-6.07,17.74,17.74,0,0,0-.56-6.23c.45-.41,2.64,6,3.75,15.55a8,8,0,0,1,.29-3.18l.07.34c-.2-5.89-.17-9.94-.72-12,1,1.15,2.53,5.54,2.92,9.7-.48-6.25-.31-11,.29-13.57a34.74,34.74,0,0,0-.14-14.36c1-.12,3.62,9,5.24,22.67a4.94,4.94,0,0,1,.74-1.86c.66-.79,1.6-3.76,1-7.89.56.65,1.49,5.64,2,12.29.41-1.58.89-2.74,1.26-4.5,1.55-7.15,1.41-9.76,1-16.92-.11-1.71.49-2.21.83-1.11,1.67,5.48,2.42,12.43,2.31,20.51-.05,3.84-.24,7.09-.51,9.76l.64-.1,0-.09c.28-1.11.62-1.87.88-3.06,1-4.47.92-6.11.69-10.62-.05-1.07.31-1.38.5-.69a45.81,45.81,0,0,1,1.27,12.91c0,.38,0,.72,0,1.08l2.18-.23c0-.31,0-.61,0-.89a44.64,44.64,0,0,0,0-4.65,4.45,4.45,0,0,1,.58,2.35,19.83,19.83,0,0,1,.23-3.92,11.68,11.68,0,0,0,.09-4.05c.31-.22,1.24,4.05,1.27,10.27a5.28,5.28,0,0,1,.42-2v.23c.29-3.8.58-6.4.38-7.76.57.81,1.21,3.74,1.18,6.44a34.6,34.6,0,0,1,1.08-8.7,23.22,23.22,0,0,0,.81-9.25c.59,0,1.68,6,1.87,14.93a3.32,3.32,0,0,1,.58-1.15c.46-.47,1.23-2.33,1.08-5,.31.46.6,3.73.52,8,.36-1,.73-1.72,1.06-2.83,1.38-4.51,1.43-6.2,1.53-10.84,0-1.11.42-1.4.57-.67a45.84,45.84,0,0,1,.36,13.34c-.23,2.38-.51,4.4-.81,6.08l.42,0c.23-.66.48-1.13.7-1.86a20.25,20.25,0,0,0,1-6.8c0-.7.26-.88.34-.42a29.73,29.73,0,0,1,.15,8.39l-.1.9a93.64,93.64,0,0,1,15.73,3.43c5.11,1.49,10.25,3.22,16.13,4.72Q1234.44,271.5,1231.21,272.5Zm-65.76-4.07-.28-1.31c0,.83,0,1.58,0,2.23l.27-.14A6.46,6.46,0,0,1,1165.45,268.43Z"
          fill="#8ac72f"
        />
        <path
          d="M1203.66,273.53l-21.85-.25c-7.37-.06-13.22.17-17.13,1.13l-2.25-1.49c.18-.41.37-.82.57-1.22-.18-.45-.28-.58-.24-.27-.12-.36-1-3-1.4-4.71s-.69-3-.86-3.42a6.35,6.35,0,0,1,.64,1.69,28.85,28.85,0,0,1-.63-2.89,17.17,17.17,0,0,0-.68-3c.09-.19,1.17,2.91,2.25,7.51a7.57,7.57,0,0,1-.21-1.51l0,.17c-.55-2.83-.85-4.77-1.16-5.77a20.81,20.81,0,0,1,1.48,4.71,43.31,43.31,0,0,1-1-6.52,32.73,32.73,0,0,0-1-6.94c.27-.06,1.59,4.4,2.88,11a3.25,3.25,0,0,1,.06-.89,10.69,10.69,0,0,0-.25-3.82,41.36,41.36,0,0,1,1.25,6c0-.77,0-1.33,0-2.18a46.78,46.78,0,0,0-.69-8.22c-.12-.83,0-1.08.17-.54.22.81.43,1.7.62,2.65a11.53,11.53,0,0,1,.9,3.56,47,47,0,0,1-.43-6,29.86,29.86,0,0,0-.53-6.23c.31-.37,1.77,6.18,2.65,15.75a13.06,13.06,0,0,1,.07-3.12l0,.35c-.25-5.85-.25-9.87-.61-12,.66,1.24,1.57,5.73,1.81,9.9a73.47,73.47,0,0,1,.21-13.45,54.92,54.92,0,0,0,.17-14.3c.66,0,2.15,9.32,2.8,23a6,6,0,0,1,.48-1.78c.4-.74,1-3.61.8-7.78.33.71.72,5.76.81,12.42.29-1.53.61-2.66.89-4.38,1.16-7,1.18-9.59,1.17-16.77,0-1.72.38-2.17.54-1a115.4,115.4,0,0,1,.62,20.63c-.16,3.83-.39,7.05-.64,9.69l.37-.05,0-.09c.2-1.09.43-1.82.62-3a51.21,51.21,0,0,0,.8-10.53c0-1.07.23-1.36.32-.65a76.91,76.91,0,0,1,.29,13c0,.37,0,.72-.06,1.07l1.32-.09,0-.88c.11-2.37.23-4,.18-4.64a7.17,7.17,0,0,1,.27,2.38,32.61,32.61,0,0,1,.27-3.91,19.31,19.31,0,0,0,.18-4c.19-.21.62,4.11.44,10.32a8,8,0,0,1,.32-2v.23c.29-3.77.54-6.35.45-7.72a24.13,24.13,0,0,1,.54,6.49,57.71,57.71,0,0,1,.86-8.65,37.87,37.87,0,0,0,.66-9.21c.34,0,.86,6.11.82,15a4.13,4.13,0,0,1,.37-1.14,11.72,11.72,0,0,0,.72-5,51.65,51.65,0,0,1,.2,8.05c.23-1,.46-1.71.68-2.81a50.57,50.57,0,0,0,1-10.82c0-1.11.25-1.4.33-.67a78.2,78.2,0,0,1,.13,13.35c-.15,2.38-.34,4.4-.54,6.07l.26,0c.15-.67.3-1.13.44-1.86a32,32,0,0,0,.64-6.8c0-.69.16-.88.21-.42a49.83,49.83,0,0,1,.07,8.39c0,.32,0,.61-.07.9,6.92,1.3,12.21,4.27,17.75,8C1205.86,272.22,1204.76,272.89,1203.66,273.53Zm-37.72-6.47-.22-1.32q.08,1.23.15,2.19l.11-.11C1166,267.56,1166,267.3,1165.94,267.06Z"
          fill="#8ac72f"
        />
        <path
          d="M1283.73,258.15a104.61,104.61,0,0,1-28,10.11,160.52,160.52,0,0,1-27.09,3.21c-8.67.32-16.93.16-24.76,0s-15.23-.28-22.2,0l-6.3-1.68,2.93-1.21c-.19-.46-.41-.61-.55-.29a30,30,0,0,1-.47-4.89,28.8,28.8,0,0,0,.07-3.54,2.84,2.84,0,0,1,.5,1.78,12.21,12.21,0,0,1,.26-3,7.49,7.49,0,0,0,.13-3.07c.28-.18,1.09,3.06,1,7.79a3.46,3.46,0,0,1,.4-1.54V262c.31-2.89.61-4.86.43-5.89a9.49,9.49,0,0,1,1,4.88,22.17,22.17,0,0,1,1.09-6.61,14.87,14.87,0,0,0,.82-7c.54,0,1.49,4.59,1.6,11.33a2.41,2.41,0,0,1,.55-.87,5.11,5.11,0,0,0,1-3.82c.28.35.54,2.83.45,6.1.33-.75.68-1.31,1-2.15,1.3-3.42,1.33-4.7,1.43-8.23,0-.84.39-1.06.52-.51a21.19,21.19,0,0,1,.47,2.71c.43.34.89,1.92.84,3.65a24,24,0,0,1,.92-6,14.5,14.5,0,0,0,.65-6.23c.63-.32,2,6.35,1.29,16a6.79,6.79,0,0,1,1.05-3.08v.35c1-5.83,1.87-9.81,1.61-11.93,1,1.31,2,5.88,1.62,10,.68-6.24,1.81-10.84,3-13.33s3.1-8.9,2.39-14.2c1.1,0,2.6,9.48,2.31,23.21a4.83,4.83,0,0,1,1.23-1.74c.94-.7,2.55-3.52,2.4-7.69.56.72,1,5.79.56,12.45.76-1.51,1.53-2.62,2.24-4.32,2.86-6.93,2.9-9.54,3.19-16.72.07-1.71.77-2.16,1-1a60,60,0,0,1,.59,20.64,73.51,73.51,0,0,1-1.82,9.67l.87,0,0-.09c.52-1.08,1-1.8,1.53-3,1.79-4.38,1.8-6,1.94-10.53,0-1.08.48-1.36.66-.65a36.16,36.16,0,0,1,.53,13l-.14,1.07,3-.12c0-.31,0-.61,0-.89a30.3,30.3,0,0,0,.32-4.65,3.57,3.57,0,0,1,.64,2.37,15.76,15.76,0,0,1,.51-3.92,9,9,0,0,0,.3-4c.38-.22,1.43,4.06,1.24,10.28a4.31,4.31,0,0,1,.64-2v.23c.52-3.79.93-6.4.69-7.76.7.81,1.52,3.72,1.45,6.43a31,31,0,0,1,1.4-8.74,18.8,18.8,0,0,0,.76-9.28c.65,0,2.14,6,2.8,14.83a3.14,3.14,0,0,1,.71-1.2c.58-.52,1.44-2.44,1-5.12.41.43,1,3.66,1.24,8,.4-1,.84-1.78,1.18-2.94,1.35-4.69,1.15-6.36.77-11-.1-1.1.31-1.44.57-.74a38.7,38.7,0,0,1,2.08,13.2,42.9,42.9,0,0,1-.4,6.15l.6,0c.25-.69.54-1.2.76-2,.84-3,.7-4,.4-6.93-.07-.69.2-.91.38-.48a22.77,22.77,0,0,1,1.49,8.27v.91c8.1-.57,15.55-1.29,22.93-2.55a107.38,107.38,0,0,0,22.35-6.07c-1.09,1.15-2.2,2.3-3.33,3.42S1284.94,257.12,1283.73,258.15Zm-94.22,6.18-.06-1.34c-.16.82-.34,1.55-.52,2.19l.37-.09A6.92,6.92,0,0,1,1189.51,264.33Z"
          fill="#8ac72f"
        />
        <path
          d="M1292.77,233.21c-5.43,6-11.68,12.68-19.82,18.86a80.66,80.66,0,0,1-13.73,8.38,65.06,65.06,0,0,1-16.79,5.4c-1-.17-1.93-.37-2.87-.58s-1.92-.49-2.85-.77l2.51-1.25c-.2-.46-.39-.6-.5-.28a35.81,35.81,0,0,1-.67-4.87,33.29,33.29,0,0,0-.2-3.52,3.86,3.86,0,0,1,.49,1.76,18.56,18.56,0,0,1-.07-3,11.72,11.72,0,0,0-.21-3.07c.13-.18,1,3,1.48,7.7a4.28,4.28,0,0,1,.13-1.55l0,.17a39.35,39.35,0,0,0-.43-5.86,15.18,15.18,0,0,1,1.32,4.77,45.68,45.68,0,0,1-.34-6.62,24.16,24.16,0,0,0-.82-7c.23,0,1.61,4.4,3.08,11a3.08,3.08,0,0,1,.16-.93,7.08,7.08,0,0,0-.24-3.84,32.58,32.58,0,0,1,1.67,5.88c.05-.78.13-1.36.11-2.23a28.41,28.41,0,0,0-1.36-8.16c-.21-.81-.1-1.07.12-.56.33.78.66,1.63,1,2.54a10,10,0,0,1,1.51,3.36,51.36,51.36,0,0,1-1.34-5.91,28.18,28.18,0,0,0-1.64-6c.07-.19.77,1.25,1.84,3.87s2.53,6.43,3.93,11a10.94,10.94,0,0,1-.44-3.13l.12.33a90,90,0,0,0-3.41-11.48,42.9,42.9,0,0,1,4.44,9c-2-5.94-3.33-10.38-3.9-12.86a47.55,47.55,0,0,0-1.85-5.85,74.42,74.42,0,0,0-3.31-7.46c.13-.05,1.3,2,3.24,5.59s4.66,8.7,7.69,14.86a6.47,6.47,0,0,1-.25-1.84c.09-.85-.6-3.71-2.67-7.34a87.64,87.64,0,0,1,6.23,10.78c-.38-1.52-.6-2.69-1.15-4.34-2.32-6.69-3.77-8.89-7.39-15.08-.87-1.48-.9-2-.23-1.08a148.4,148.4,0,0,1,11.17,17.36c1.82,3.36,3.23,6.28,4.26,8.75l.4-.31,0-.08c-.32-1.08-.44-1.86-.84-3-1.53-4.23-2.46-5.58-4.86-9.4-.58-.91-.55-1.26-.09-.72a72.6,72.6,0,0,1,7.39,10.66l.52.94,1.35-1c-.16-.26-.33-.51-.48-.74-1.25-2-2.07-3.44-2.49-3.92a6.17,6.17,0,0,1,1.64,1.75,30.47,30.47,0,0,1-2-3.35,16.89,16.89,0,0,0-2.2-3.39c0-.28,3,2.91,6.49,8a6.68,6.68,0,0,1-.88-1.83l.14.18a62.06,62.06,0,0,0-4.23-6.49,23.29,23.29,0,0,1,4.41,4.79,64.5,64.5,0,0,1-4.58-7.4,36.49,36.49,0,0,0-5.25-7.61c.12-.09,1.23,1,3,2.91s4.28,4.75,7.09,8.18a4.41,4.41,0,0,1-.41-1.13,10.65,10.65,0,0,0-2.64-4.32,49.46,49.46,0,0,1,5.39,6c-.44-.91-.71-1.63-1.27-2.62a44.05,44.05,0,0,0-6.39-8.79c-.72-.85-.75-1.2-.21-.72a78.8,78.8,0,0,1,9,9.82c1.47,1.88,2.66,3.52,3.59,4.92l.26-.17c-.31-.61-.49-1.08-.86-1.73a26.49,26.49,0,0,0-4.07-5.49c-.46-.53-.47-.77-.12-.47a44.41,44.41,0,0,1,5.77,6.09l.56.71a67,67,0,0,1,9.86-5.6,74.94,74.94,0,0,1,9.83-3.64C1293.37,230.57,1293.09,231.89,1292.77,233.21ZM1247,257.64c-.13-.42-.27-.85-.4-1.28.11.82.19,1.56.23,2.21l.23-.16C1247.05,258.14,1247,257.88,1247,257.64Z"
          fill="#8ac72f"
        />
        <path
          d="M1130.88,143.66a3.73,3.73,0,0,0,2.38,0c1.18-.49,1.61-1.92,1.79-3.19a22.37,22.37,0,0,0-.78-9.69,17.32,17.32,0,0,0,8.43,4.33,2.67,2.67,0,0,0,2.46-.39,2.83,2.83,0,0,0,.6-1.8l.88-9.86c1.08,1.17,3.23,2.24,4,.82a2.43,2.43,0,0,0,0-1.62,23,23,0,0,0-1.73-4.79c-.09.51.68.81,1.12.53a2.06,2.06,0,0,0,.71-1.35l1.65-6.92c.85,1.54,3.21.78,4.89,1.28a6.09,6.09,0,0,1,2.18,1.42l6.88,6a11.92,11.92,0,0,0-5-10.66c1.09.38,1.35-1.47,1-2.55,2.77-.44,3.86-4.19,2.7-6.75s-3.69-4.15-6-5.7a112.39,112.39,0,0,1-11.92-9,32.07,32.07,0,0,0-6.25-4.72,9.2,9.2,0,0,0-7.58-.69l3,10.62a26.93,26.93,0,0,0-10.15-3.36c-2.3-.28-5.44.47-5.45,2.79a9.93,9.93,0,0,0-5.36-1.3c-1.85.22-3.67,1.66-3.72,3.52l-12.77,5.26-.32,3.78a19.49,19.49,0,0,0-6.13-.93,6.6,6.6,0,0,0-5.28,2.83,53,53,0,0,1,14.62,5.94,58.59,58.59,0,0,0-11.74,11.32l2.89.7a78.37,78.37,0,0,0,2.11,13.53l7.94,2.89a18.12,18.12,0,0,0,4.83,1.26c1.64.12,3.29-.2,4.94-.22C1119,136.93,1124.76,142.17,1130.88,143.66Z"
          fill="#7b9933"
        />
        <path
          d="M1181.1,119.51a4.18,4.18,0,0,0-2.19-1.18,1.77,1.77,0,0,0-2,1.21,3.65,3.65,0,0,0,.52,2c.27.65.31,1.54-.3,1.9a1.75,1.75,0,0,1-.88.15h-3.5a5,5,0,0,0-2.8.55,1.74,1.74,0,0,0-.54,2.49,20.85,20.85,0,0,0-6.08,3.9,3.44,3.44,0,0,0-1.25,1.88,6.4,6.4,0,0,0,0,1.31c.1,2.16-1.34,4-2.57,5.81s-2.33,4-1.51,6a39.78,39.78,0,0,0,6.14-4.92c.22,1.17-.29,2.33-.48,3.51s.17,2.66,1.32,3a2.67,2.67,0,0,0,2.55-1.19,9.48,9.48,0,0,0,2.05-4.18,5.23,5.23,0,0,0,3,3.52l1.3-9.08c1.11,1.32,3.43.89,4.5-.46s1.14-3.2,1.15-4.83C1189,134.6,1184.83,122.87,1181.1,119.51Z"
          fill="#7b9933"
        />
        <g>
          <path
            d="M1117,102.11c-1.52,1.75-4.57,3.16-5.84,2s-.3-4.32,1.22-6.06,3-1.38,4.3-.27S1118.53,100.36,1117,102.11Z"
            fill="#e8f5fa"
          />
          <path
            d="M1116.58,109.08c-2.3-.3-5.15-2.07-4.92-3.75s3.43-2.63,5.73-2.32,2.82,1.76,2.59,3.44S1118.88,109.39,1116.58,109.08Z"
            fill="#e8f5fa"
          />
          <path
            d="M1110.12,111.58c-.83-2.17-.65-5.51.93-6.12s4,1.76,4.79,3.93-.2,3.31-1.78,3.92S1111,113.75,1110.12,111.58Z"
            fill="#e8f5fa"
          />
          <path
            d="M1105.62,104.8c2.06-1.07,5.4-1.26,6.18.25s-1.31,4.12-3.37,5.19-3.31.17-4.09-1.33S1103.56,105.87,1105.62,104.8Z"
            fill="#e8f5fa"
          />
          <path
            d="M1109.72,98.9c1.89,1.33,3.6,4.22,2.63,5.6s-4.26.74-6.16-.59-1.68-2.87-.71-4.25S1107.82,97.56,1109.72,98.9Z"
            fill="#e8f5fa"
          />
          <circle cx="1111.51" cy="104.67" r="2.46" fill="#e9ac38" />
        </g>
        <g>
          <path
            d="M1130.61,117.89c-1.12,1.28-3.36,2.32-4.3,1.5s-.22-3.18.9-4.47a2.26,2.26,0,0,1,3.4,3Z"
            fill="#e8f5fa"
          />
          <path
            d="M1130.3,123c-1.69-.23-3.79-1.53-3.62-2.76s2.53-1.94,4.22-1.71a2.26,2.26,0,0,1-.6,4.47Z"
            fill="#e8f5fa"
          />
          <path
            d="M1125.55,124.85c-.61-1.59-.48-4,.69-4.5s2.91,1.29,3.52,2.89a2.25,2.25,0,0,1-4.21,1.61Z"
            fill="#e8f5fa"
          />
          <path
            d="M1122.23,119.86c1.52-.78,4-.92,4.55.18s-1,3-2.47,3.83a2.26,2.26,0,0,1-2.08-4Z"
            fill="#e8f5fa"
          />
          <path
            d="M1125.25,115.52c1.4,1,2.66,3.1,1.94,4.12s-3.14.55-4.54-.43a2.26,2.26,0,0,1,2.6-3.69Z"
            fill="#e8f5fa"
          />
          <circle cx="1126.57" cy="119.77" r="1.81" fill="#e9ac38" />
        </g>
        <g>
          <path
            d="M1146.89,88.23c-1.52,1.75-4.57,3.16-5.84,2s-.3-4.32,1.22-6.07,3-1.38,4.3-.27S1148.42,86.49,1146.89,88.23Z"
            fill="#e8f5fa"
          />
          <path
            d="M1146.47,95.21c-2.3-.31-5.15-2.08-4.92-3.75s3.43-2.64,5.73-2.33,2.82,1.76,2.59,3.44S1148.77,95.51,1146.47,95.21Z"
            fill="#e8f5fa"
          />
          <path
            d="M1140,97.7c-.83-2.16-.64-5.51.94-6.12s4,1.76,4.78,3.93-.2,3.31-1.78,3.92S1140.84,99.87,1140,97.7Z"
            fill="#e8f5fa"
          />
          <path
            d="M1135.51,90.92c2.06-1.07,5.4-1.26,6.18.25s-1.3,4.12-3.36,5.19-3.32.17-4.1-1.33S1133.45,92,1135.51,90.92Z"
            fill="#e8f5fa"
          />
          <path
            d="M1139.61,85c1.89,1.33,3.61,4.22,2.63,5.6s-4.26.74-6.16-.59-1.68-2.86-.71-4.25S1137.71,83.68,1139.61,85Z"
            fill="#e8f5fa"
          />
          <circle cx="1141.4" cy="90.79" r="2.46" fill="#e9ac38" />
        </g>
        <g>
          <path
            d="M1146.76,109.92c-.84,1-2.52,1.74-3.22,1.13s-.17-2.39.67-3.35a1.69,1.69,0,0,1,2.55,2.22Z"
            fill="#e8f5fa"
          />
          <path
            d="M1146.53,113.77c-1.27-.17-2.84-1.15-2.72-2.07s1.9-1.45,3.17-1.28a1.69,1.69,0,0,1-.45,3.35Z"
            fill="#e8f5fa"
          />
          <path
            d="M1143,115.15c-.46-1.2-.35-3.05.52-3.38s2.18,1,2.64,2.17a1.69,1.69,0,0,1-3.16,1.21Z"
            fill="#e8f5fa"
          />
          <path
            d="M1140.48,111.4c1.13-.58,3-.69,3.41.14s-.72,2.28-1.86,2.87a1.69,1.69,0,0,1-1.55-3Z"
            fill="#e8f5fa"
          />
          <path
            d="M1142.74,108.15c1,.73,2,2.32,1.45,3.09s-2.35.41-3.4-.33a1.69,1.69,0,0,1,2-2.76Z"
            fill="#e8f5fa"
          />
          <circle cx="1143.73" cy="111.33" r="1.36" fill="#e9ac38" />
        </g>
      </g>
      <g transform="translate(30, -20)">
        <path
          d="M1119.45,244.31a9.74,9.74,0,0,1-.13-3.53l1.31,1.89a3.77,3.77,0,0,1,1.48-1.61,8.54,8.54,0,0,0,2.21,2.43l1.81-1.46a1.72,1.72,0,0,0,2.19,1.25,5,5,0,0,0,2.26-1.72l.85,1.87a5.87,5.87,0,0,0,2.12-1.3,1.84,1.84,0,0,0,.64,1.6,34.41,34.41,0,0,1,11-16.6,48.71,48.71,0,0,0-10.67,22.25,21.66,21.66,0,0,1,6.64-6.8,1.29,1.29,0,0,0,.07,1.92,96.17,96.17,0,0,1-6.67,11.4,32.78,32.78,0,0,0-3.36-9.51l-1.53,2.26a3.58,3.58,0,0,1-1.74-1.53,3.27,3.27,0,0,0-1.78-1.47c-.77-.16-1.72.56-1.44,1.3-1.28-1.15-2.54-2.4-3.91-3.42-.18,2,.4,4.53-.3,6.41-3.12-2.58-3.69-9.38-5.54-12.9C1116.45,239.45,1117.94,241.89,1119.45,244.31Z"
          fill="#72a139"
        />
        <path
          d="M1099.16,170.45c-38.32,13.11-82.68,21.9-88.39,42.42s32.79,23.27,42.77,26-44.19,18.86-47,44.86,18.53,42.72,51.32,56.4c14.16,5.91,34.51,19.19,72.7,23,21.93,2.16,56.72-10.34,78.88-10.46,28.54-.15,56.84,4.23,75.07-1.9a245.29,245.29,0,0,0,41.41-18c12.54-7,23.27-23.61,32.72-32.33,16.37-15.1,35.12-16.86,41.09-36.61,12.83-42.42-132.32-109.72-222.13-102.87C1177.56,160.88,1120.54,163.14,1099.16,170.45Z"
          fill="#f5db86"
        />
        <path
          d="M1178.35,172.7c-10.09-2.43-34.22-6.19-65.61-.12s-85.81,29.26-82.64,41c2.56,9.48,51.07,18.16,58.92,20.59s-52.9,26.29-53.85,53.22c-.57,16.07.47,24,14.57,30.41,6.21,2.8,21.26,3.89,29.14,7.6,8.12,3.82,22.51,15.16,41.82,18.37,17.81,3,40-2.05,60.84-1.55,28.32.68,56.9,3.81,77.27-4.15,15.74-6.15,33.67-22.29,48.15-30.41,10.56-5.91,21.41-4.18,29.78-11.4,12.76-11,18.86-28.37,22.81-43.09,10.09-37.62-98.53-90.33-169.16-84.26"
          fill="#a68023"
        />
        <path
          d="M1351.31,246.19c0,22.5-7.6,46.25-46.88,57.66-19.37,5.62-35.91,24.16-61.46,30.41-18.1,4.43-46.42,3-66.43,4.9-35.57,3.34-39.36-7.58-59-11.87-25.51-5.57-52.6-9.16-69.76-20.21-23.1-14.88-8.2-41.85,43.49-66.29,36.06-17.06-72.09-19.24-57.56-32.11,28.82-25.53,81.91-44.85,142.75-44.85C1268,163.83,1351.31,198.38,1351.31,246.19Z"
          fill="#78c2ef"
        />
        <path
          d="M1320.42,240.26c-11.56-4.72-3.85,1.88,9.64-17.92a22,22,0,0,0,2.48-4.81c-26.69-29.54-88.7-48.63-158.26-48.63a282.26,282.26,0,0,0-76.87,10.44c-9,6-15,12.84-15,19.42,0,18.86,27.94,21.69,36.62,32.07s10.59,19.8,1.92,22.63-12.52,0-27,7.54-38.54,5.66-38.54,21.69,8.67,27.35,24.09,23.58,26-9.43,35.65-4.72,19.27,17,36.62,20.75,37.58-5.66,54-10.37,16.38,2.83,45.28-3.77,47.22,0,62.63-20.75S1332,245,1320.42,240.26Z"
          fill="#5c96ee"
        />
        <path
          d="M1300.31,215.62c-16.59-6.47-21.38.48-29.93,1.91s-35.17-2.86-35.17,11.4,31.36,3.8,44.19,9,22.34,20.43,30.42,7.6S1319.79,223.23,1300.31,215.62Z"
          fill="#78c2ef"
        />
        <g>
          <ellipse
            cx="1144.88"
            cy="353.8"
            rx="6.77"
            ry="3.09"
            transform="translate(-35.47 147.14) rotate(-7.24)"
            fill="#cebd66"
          />
          <path
            d="M1148.54,352c.4,3.14-2,3.65-5.36,4.08s-6.34.59-6.74-2.54,1.89-7.89,5.23-8.31S1148.14,348.89,1148.54,352Z"
            fill="#d5ba78"
          />
          <path
            d="M1144.85,346.14a8.14,8.14,0,0,1,1,2.8c.4,3.14-2,3.65-5.36,4.08a15.72,15.72,0,0,1-4,.14c0,.14,0,.28,0,.41.4,3.13,3.4,3,6.74,2.54s5.76-.94,5.36-4.08A9.06,9.06,0,0,0,1144.85,346.14Z"
            fill="#bd9f76"
          />
        </g>
        <g>
          <ellipse
            cx="1159.61"
            cy="355.99"
            rx="4.62"
            ry="2.11"
            transform="translate(-35.62 149.01) rotate(-7.24)"
            fill="#cebd66"
          />
          <path
            d="M1162.11,354.78c.27,2.14-1.38,2.49-3.66,2.78s-4.33.41-4.61-1.73,1.29-5.38,3.57-5.67S1161.83,352.64,1162.11,354.78Z"
            fill="#d5ba78"
          />
          <path
            d="M1159.59,350.76a5.73,5.73,0,0,1,.66,1.91c.27,2.14-1.38,2.5-3.66,2.79a11,11,0,0,1-2.77.1c0,.09,0,.18,0,.27.28,2.14,2.33,2,4.61,1.73s3.93-.64,3.66-2.78A6.22,6.22,0,0,0,1159.59,350.76Z"
            fill="#bd9f76"
          />
        </g>
        <g>
          <ellipse
            cx="1283.79"
            cy="338.57"
            rx="4.62"
            ry="2.11"
            transform="translate(-32.44 164.53) rotate(-7.24)"
            fill="#cebd66"
          />
          <path
            d="M1286.28,337.36c.28,2.14-1.37,2.49-3.65,2.78s-4.34.41-4.61-1.73,1.29-5.38,3.57-5.67S1286,335.21,1286.28,337.36Z"
            fill="#d5ba78"
          />
          <path
            d="M1283.77,333.34a5.42,5.42,0,0,1,.65,1.91c.28,2.14-1.37,2.49-3.65,2.78a10.6,10.6,0,0,1-2.77.1c0,.1,0,.19,0,.28.27,2.14,2.32,2,4.61,1.73s3.93-.64,3.65-2.78A6.21,6.21,0,0,0,1283.77,333.34Z"
            fill="#bd9f76"
          />
        </g>
        <g>
          <ellipse
            cx="1330.83"
            cy="314.34"
            rx="4.62"
            ry="2.11"
            transform="translate(-29.01 170.26) rotate(-7.24)"
            fill="#cebd66"
          />
          <path
            d="M1333.33,313.12c.27,2.15-1.38,2.5-3.66,2.79s-4.33.41-4.61-1.74,1.29-5.38,3.57-5.67S1333.05,311,1333.33,313.12Z"
            fill="#d5ba78"
          />
          <path
            d="M1330.81,309.1a5.73,5.73,0,0,1,.66,1.91c.27,2.15-1.38,2.5-3.66,2.79a10.59,10.59,0,0,1-2.77.1c0,.09,0,.19,0,.27.28,2.15,2.33,2,4.61,1.74s3.93-.64,3.66-2.79A6.27,6.27,0,0,0,1330.81,309.1Z"
            fill="#bd9f76"
          />
        </g>
        <g>
          <ellipse
            cx="1082.76"
            cy="342.32"
            rx="2.11"
            ry="4.62"
            transform="translate(577.41 1359.26) rotate(-81.12)"
            fill="#cebd66"
          />
          <path
            d="M1085.49,341.85c-.33,2.13-2,2-4.28,1.66s-4.28-.82-4-2.95,2.74-4.81,5-4.46S1085.83,339.71,1085.49,341.85Z"
            fill="#d5ba78"
          />
          <path
            d="M1084.19,337.28a5.61,5.61,0,0,1,.1,2c-.33,2.14-2,2-4.29,1.66a10.49,10.49,0,0,1-2.68-.67l-.06.27c-.33,2.13,1.67,2.59,4,2.95s4,.47,4.28-1.66A6.23,6.23,0,0,0,1084.19,337.28Z"
            fill="#bd9f76"
          />
        </g>
        <g>
          <ellipse
            cx="1056.47"
            cy="330.28"
            rx="2.11"
            ry="4.62"
            transform="translate(567.07 1323.1) rotate(-81.12)"
            fill="#cebd66"
          />
          <path
            d="M1059.2,329.81c-.33,2.13-2,2-4.29,1.66s-4.27-.81-3.94-3,2.73-4.81,5-4.46S1059.53,327.67,1059.2,329.81Z"
            fill="#d5ba78"
          />
          <path
            d="M1057.9,325.25a5.82,5.82,0,0,1,.1,2c-.34,2.13-2,2-4.29,1.65a10,10,0,0,1-2.68-.67,2.61,2.61,0,0,0-.06.27c-.33,2.14,1.67,2.59,3.94,3s4,.47,4.29-1.66A6.24,6.24,0,0,0,1057.9,325.25Z"
            fill="#bd9f76"
          />
        </g>
        <g>
          <ellipse
            cx="1074.67"
            cy="236.78"
            rx="2.11"
            ry="4.62"
            transform="translate(674.85 1262.02) rotate(-81.12)"
            fill="#cebd66"
          />
          <path
            d="M1077.4,236.31c-.33,2.13-2,2-4.29,1.66s-4.27-.81-3.94-2.95,2.73-4.81,5-4.46S1077.73,234.17,1077.4,236.31Z"
            fill="#d5ba78"
          />
          <path
            d="M1076.1,231.75a5.54,5.54,0,0,1,.1,2c-.33,2.14-2,2-4.29,1.66a10,10,0,0,1-2.68-.67l-.06.27c-.33,2.14,1.67,2.59,3.94,2.95s4,.47,4.29-1.66A6.24,6.24,0,0,0,1076.1,231.75Z"
            fill="#bd9f76"
          />
        </g>
        <g>
          <ellipse
            cx="1349.63"
            cy="213.34"
            rx="2.11"
            ry="4.62"
            transform="translate(930.53 1513.86) rotate(-81.12)"
            fill="#cebd66"
          />
          <path
            d="M1352.37,212.87c-.34,2.13-2,2-4.29,1.65s-4.28-.81-3.94-2.94,2.73-4.81,5-4.46S1352.7,210.73,1352.37,212.87Z"
            fill="#d5ba78"
          />
          <path
            d="M1351.06,208.3a5.62,5.62,0,0,1,.11,2c-.34,2.14-2,2-4.29,1.66a10.58,10.58,0,0,1-2.69-.67,2.56,2.56,0,0,0,0,.27c-.34,2.13,1.67,2.59,3.94,2.94s4,.48,4.29-1.65A6.23,6.23,0,0,0,1351.06,208.3Z"
            fill="#bd9f76"
          />
        </g>
        <path
          d="M1151.45,249.7c-7.27,4.5-1.09,12.47,14.53,8.81s25.07-18.36,10.17-22.58-36.33,2-35.24,7.31S1150,248.3,1151.45,249.7Z"
          fill="#42661d"
        />
        <path
          d="M1266.51,207.52c-5.7,3.54-.85,9.79,11.42,6.92s19.7-14.43,8-17.74-28.54,1.55-27.68,5.74S1265.37,206.42,1266.51,207.52Z"
          fill="#42661d"
        />
        <path
          d="M1268.26,258.53c-13.58,6.14-4.7,21.31,23.14,18.51s47.49-26.11,22.69-36.76-63.27-4.79-62.59,4.69S1266.06,255.77,1268.26,258.53Z"
          fill="#42661d"
        />
        <path
          d="M1256.91,317.63c2-3.82-6,.79-11.72,4s-17.42,2.37-15.2,4.91S1254.22,322.7,1256.91,317.63Z"
          fill="#f4da34"
          opacity="0.45"
        />
        <path
          d="M1252.09,323.63c.66-1.49-8.2,3.19-10.7,3.72s-5.53-.13-4.56,2S1250.49,327.26,1252.09,323.63Z"
          fill="#f4da34"
          opacity="0.45"
        />
        <path
          d="M1167.9,300.21c2-3.83-6,.79-11.72,4s-17.43,2.37-15.21,4.91S1165.2,305.27,1167.9,300.21Z"
          fill="#c3397f"
          opacity="0.43"
        />
        <path
          d="M1163.07,306.21c.66-1.49-8.19,3.19-10.69,3.72s-5.54-.14-4.56,2S1161.47,309.84,1163.07,306.21Z"
          fill="#c3397f"
          opacity="0.43"
        />
        <path
          d="M1196.69,271.23c3-3.09-6-1-12.37.46s-17.38-2.68-16,.38S1192.66,275.32,1196.69,271.23Z"
          fill="#b4ecfd"
          opacity="0.34"
        />
        <path
          d="M1190.35,275.61c1.06-1.24-8.76.73-11.31.52s-5.27-1.7-4.94.63S1187.78,278.64,1190.35,275.61Z"
          fill="#b4ecfd"
          opacity="0.34"
        />
        <path
          d="M1314.65,276.41c2.35-3.63-6.07.27-12,2.93s-17.56.87-15.57,3.58S1311.53,281.22,1314.65,276.41Z"
          fill="#bef754"
          opacity="0.58"
        />
        <path
          d="M1309.33,282c.78-1.43-8.45,2.47-11,2.78s-5.5-.6-4.72,1.62S1307.42,285.45,1309.33,282Z"
          fill="#bef754"
          opacity="0.58"
        />
        <path
          d="M1151.52,249c-7.27,4.5-1.09,12.47,14.53,8.81s25.06-18.36,10.17-22.58-36.33,2-35.24,7.31S1150.06,247.62,1151.52,249Z"
          fill="#557520"
        />
        <path
          d="M1206.11,196.86c-12.67,7.84-1.9,21.73,25.34,15.36s43.72-32,17.74-39.38-63.35,3.43-61.45,12.74S1203.57,194.41,1206.11,196.86Z"
          fill="#42661d"
        />
        <path
          d="M1206.23,195.67c-12.67,7.84-1.9,21.73,25.34,15.36s43.72-32,17.74-39.38-63.36,3.43-61.46,12.74S1203.69,193.22,1206.23,195.67Z"
          fill="#557520"
        />
        <path
          d="M1106.92,289.75c-12.67,7.84-1.9,21.74,25.34,15.37s43.72-32,17.74-39.39-63.36,3.44-61.46,12.75S1104.38,287.3,1106.92,289.75Z"
          fill="#42661d"
        />
        <path
          d="M1107.39,288.48c-12.67,7.85-1.9,21.74,25.34,15.37s43.72-32,17.74-39.38-63.35,3.43-61.45,12.74S1104.86,286,1107.39,288.48Z"
          fill="#557520"
        />
        <path
          d="M1106.09,189c-8.18,5.06-1.23,14,16.34,9.91s28.2-20.66,11.44-25.4-40.86,2.21-39.64,8.22S1104.45,187.43,1106.09,189Z"
          fill="#42661d"
        />
        <path
          d="M1106.39,188.19c-8.17,5.06-1.22,14,16.35,9.91s28.2-20.66,11.44-25.4-40.87,2.22-39.64,8.22S1104.76,186.61,1106.39,188.19Z"
          fill="#557520"
        />
        <path
          d="M1268.5,257.5c-13.58,6.14-4.7,21.31,23.14,18.51s47.49-26.11,22.68-36.76-63.27-4.79-62.58,4.7S1266.3,254.74,1268.5,257.5Z"
          fill="#557520"
        />
        <path
          d="M1246.38,297.19c-6.76,4.18-1,11.59,13.52,8.19s23.31-17.08,9.46-21-33.79,1.83-32.78,6.8S1245,295.88,1246.38,297.19Z"
          fill="#42661d"
        />
        <path
          d="M1246.38,296.43c-6.76,4.18-1,11.59,13.52,8.19s23.31-17.08,9.46-21-33.79,1.83-32.78,6.8S1245,295.12,1246.38,296.43Z"
          fill="#557520"
        />
        <path
          d="M1237.86,235.93c-3.53,2.19-.53,6.07,7.08,4.29s12.2-8.94,5-11-17.69,1-17.16,3.56S1237.16,235.25,1237.86,235.93Z"
          fill="#42661d"
        />
        <path
          d="M1237.86,235.54c-3.53,2.19-.53,6.06,7.08,4.28s12.2-8.94,5-11-17.69,1-17.16,3.56S1237.16,234.85,1237.86,235.54Z"
          fill="#557520"
        />
        <path
          d="M1266.59,206.81c-5.71,3.53-.86,9.79,11.41,6.92s19.7-14.43,8-17.74-28.55,1.54-27.69,5.74S1265.44,205.7,1266.59,206.81Z"
          fill="#557520"
        />
        <path
          d="M1186.79,317.75c.55-2.57-.9-4-9.55.78s-27.87-4.08-29.15-.31,5.19,6.71,12.62,6.91,14.17-.66,14.68,1.21-14.86-.39-14.72,2.14,9.14,5,18.76,2.81,13.69-8.62,13-10.46-7.93,4.22-9.48,2.93S1186.26,320.2,1186.79,317.75Z"
          fill="#fff"
        />
        <path
          d="M1081.9,195.64c-3.82-1.44-5.4,9.33-3.19,15s9.82,7.61,12.28,4.67-2.46-.49-5.65-6.88,2,2.83,4.18,2.21-1.48-2.58-2.83-6.13,2.46-10.32.74-11.42-3.32,9-4.3,8.22S1083.87,196.37,1081.9,195.64Z"
          fill="#fff"
        />
        <path
          d="M1252.82,358.11c-14.84-2.86-29.74-4.36-43.79-1.29-7.09,1.52-14.3,4.08-22,6.16-3.88,1-7.74,2-11.67,2.69-3.91.86-7.87,1.34-11.82,1.93A177.32,177.32,0,0,1,1070,353.69c-2.12-1.09-4.28-2.08-6.35-3.26l-6.23-3.55,6.25,3a2.54,2.54,0,0,0-1.06-.64c0-.13-.29-1,.23-1.27s1.05-.31,1-.5c.36.23.7.63.56.8a1.49,1.49,0,0,1,1.13-.25c.44.06,1.13,0,.88-.4.55.22,1.43,1.52.39,2.34a2.46,2.46,0,0,1,1.1.09.08.08,0,0,1,0,0c1.18-.25,2.09-.37,1.94-.72.85.56,1.54,1.49,1.06,1.84a5.07,5.07,0,0,1,3.16-.36c1.18.14,3.06,0,2.58-.85a3,3,0,0,1,1.42,3.63,7.35,7.35,0,0,1,1.17.24c.88.26,2.43.5,2.41-.06a1.07,1.07,0,0,1,.17,1.68c.75.06,1.5.17,2.2.19,2.86.09,3-.2,3.52-1,.12-.18.81,0,1,.22a3.13,3.13,0,0,1,.65.94c.78.36,1.57,1,1.34,1.37a3.11,3.11,0,0,1,2.18-.94c.91-.06,2.26-.45,1.61-1.15,1.15.25,3.33,2.62,1.58,4.62a5.68,5.68,0,0,1,2.22-.21.25.25,0,0,0,0,.09c2.24-1,4-1.57,3.57-2.21,1.88.78,3.6,2.37,2.81,3.25a11.1,11.1,0,0,1,6.07-2.21,11.9,11.9,0,0,0,3.69-.84c1-.51,1.59-1.17.93-1.93a6,6,0,0,1,4.45,6.48,17.78,17.78,0,0,1,2.4-.12c1.85,0,5-.42,4.65-1.5a2.24,2.24,0,0,1,1.22,3.24,39.58,39.58,0,0,0,4.36-.8c5.56-1.49,5.64-2.11,6.17-3.92.12-.43,1.53-.54,2.06-.26,2.63,1.39,3.23,3.14,1.27,5.15a12.59,12.59,0,0,1-3.51,2.43l1.7,0,.07,0c1-.27,2-.45,3-.74,3.49-1.09,3.53-1.52,3.8-2.67.07-.27,1-.39,1.32-.23,1.73.8,2.15,1.88,1,3.2a2.47,2.47,0,0,1-.28.28l5.77-.3a.82.82,0,0,1,.1-.24c.43-.63,1-1.09.71-1.23.56,0,1.21.19,1.17.48a2,2,0,0,1,1.09-1.08c.53-.26,1.26-.82.69-1.08.77-.13,2.65.77,2.06,2.39a3.34,3.34,0,0,1,1.3-.63.13.13,0,0,0,0,.06c1.14-1,2-1.88,1.66-2.15,1.32,0,2.73.55,2.45,1.28A6.79,6.79,0,0,1,1169,361c1.42-.58,3.4-2.1,2.25-2.72a3.87,3.87,0,0,1,4.13,3,9.33,9.33,0,0,1,1.45-.58,9.08,9.08,0,0,0,1.89-.8c.55-.36.9-.74.7-1a1.41,1.41,0,0,1,1.4,1.72c.86-.46,1.76-.87,2.54-1.36,3.18-1.95,3.12-2.38,3.11-3.58,0-.29.87-.61,1.26-.53,1.92.38,2.6,1.36,1.74,3a8,8,0,0,1-1.65,2.05l1.07-.3c.54-.33,1.13-.62,1.64-1,2-1.31,1.91-1.58,1.89-2.34,0-.18.55-.39.79-.35,1.22.23,1.64.84,1.12,1.86l-.17.28c7-2,13.43-3.85,19.65-4.57a87.25,87.25,0,0,1,18.18-.2c11.8,1.08,22.86,3.84,34.36,6.8C1261.76,359.58,1257.28,358.79,1252.82,358.11Zm-165.9.26a2.16,2.16,0,0,1,0-.36,8.09,8.09,0,0,1-1.24.15l.74.23A2.68,2.68,0,0,1,1086.92,358.37Z"
          fill="#8ac72f"
        />
        <path
          d="M1107.06,363q-25.83-7.2-51-16.7l-3.56-1.91,1.9.46c-.06-.15-.16-.23-.29-.2a3.18,3.18,0,0,1,.34-1.18c.26-.39.48-.63.48-.76a.45.45,0,0,1,.07.5,1.56,1.56,0,0,1,.5-.6c.17-.1.46-.38.43-.65.17,0,.24.93-.33,2a.64.64,0,0,1,.41-.25l0,0c.51-.57.89-.95.91-1.22a1.3,1.3,0,0,1,0,1.32,3.24,3.24,0,0,1,1.31-1.26,1.91,1.91,0,0,0,1.17-1.43c.28.1.32,1.35-.28,2.93a1,1,0,0,1,.38-.09.94.94,0,0,0,.93-.66c.12.14,0,.76-.33,1.5a7.71,7.71,0,0,0,.75-.29,2.62,2.62,0,0,0,1.52-1.63c.09-.19.3-.17.32,0a2.55,2.55,0,0,1,0,.73.93.93,0,0,1,.14,1,3.11,3.11,0,0,1,1-1.23c.33-.22.91-.8.86-1.35.35.05.51,1.88-.62,4a1.4,1.4,0,0,1,.82-.52l0,.08c1-1.18,1.78-2,1.81-2.52a2.66,2.66,0,0,1,.09,2.69,6.68,6.68,0,0,1,2.61-2.61c.83-.37,2.3-1.56,2.31-3,.57.2.7,2.74-.46,6a2,2,0,0,1,.78-.19,1.92,1.92,0,0,0,1.85-1.4c.25.28.09,1.56-.61,3.08.52-.23,1-.35,1.52-.63a5.29,5.29,0,0,0,3-3.39c.17-.4.6-.37.65-.06a6.76,6.76,0,0,1-1.3,5,10.45,10.45,0,0,1-1.72,2l.46.14h0c.36-.17.7-.24,1-.43a3.32,3.32,0,0,0,1.88-2.14c.11-.25.38-.24.41,0a4.19,4.19,0,0,1-.8,3.15l-.17.23,1.56.5a.93.93,0,0,1,.1-.2c.32-.52.6-.86.58-1a.59.59,0,0,1,.12.66,2.1,2.1,0,0,1,.63-.82,1.15,1.15,0,0,0,.53-.88c.23,0,.37,1.2-.32,2.61a.89.89,0,0,1,.52-.36l0,.06c.64-.79,1.11-1.31,1.12-1.67a1.74,1.74,0,0,1,.11,1.74,4.33,4.33,0,0,1,1.64-1.74,2.52,2.52,0,0,0,1.45-2c.37.13.5,1.77-.19,3.88a1.31,1.31,0,0,1,.5-.14,1.25,1.25,0,0,0,1.18-.94,2.9,2.9,0,0,1-.35,2c.33-.16.65-.25,1-.43a3.46,3.46,0,0,0,1.9-2.25c.1-.25.38-.24.42,0a4.31,4.31,0,0,1-.77,3.26,6.58,6.58,0,0,1-1,1.26l.3.11c.22-.11.43-.16.64-.29a2.18,2.18,0,0,0,1.19-1.41c.06-.17.24-.16.26,0a2.69,2.69,0,0,1-.47,2.05l-.14.19c7.91,2.78,13.92,5.25,20.33,7.95Zm-45.74-16.62.08-.33a4.37,4.37,0,0,1-.48.41l.21.05A.8.8,0,0,1,1061.32,346.34Z"
          fill="#8ac72f"
        />
        <path
          d="M1100.09,355.31q-25.52-4.74-50.7-11.11l-3.63-1.46,1.88.23c-.07-.15-.18-.22-.3-.17a3.18,3.18,0,0,1,.21-1.21c.2-.41.4-.68.38-.81a.48.48,0,0,1,.12.49,1.52,1.52,0,0,1,.42-.65.91.91,0,0,0,.35-.7c.17,0,.33.88-.12,2a.68.68,0,0,1,.37-.3v0c.43-.63.76-1,.75-1.32a1.34,1.34,0,0,1,.16,1.31,3.29,3.29,0,0,1,1.13-1.41,1.93,1.93,0,0,0,1-1.56c.29.08.45,1.31,0,2.94a1,1,0,0,1,.37-.13.94.94,0,0,0,.82-.77,2.16,2.16,0,0,1-.17,1.53,6.8,6.8,0,0,0,.7-.38,2.65,2.65,0,0,0,1.31-1.79c.06-.2.27-.21.31-.06a2.84,2.84,0,0,1,.08.72,1,1,0,0,1,.24,1,3.19,3.19,0,0,1,.84-1.34,1.82,1.82,0,0,0,.7-1.44c.35,0,.69,1.8-.19,4.06a1.4,1.4,0,0,1,.74-.62l0,.09c.86-1.29,1.52-2.16,1.49-2.71a2.69,2.69,0,0,1,.36,2.66,6.71,6.71,0,0,1,2.26-2.89c.77-.47,2.08-1.82,2-3.2.58.13.94,2.64.14,6a1.75,1.75,0,0,1,.74-.28,1.94,1.94,0,0,0,1.65-1.6c.27.25.24,1.54-.29,3.12.47-.28.94-.46,1.4-.79a5.36,5.36,0,0,0,2.58-3.7c.13-.41.55-.43.63-.12a6.89,6.89,0,0,1-.79,5.11,10.36,10.36,0,0,1-1.47,2.14l.46.1,0,0c.33-.21.64-.32,1-.55a3.37,3.37,0,0,0,1.62-2.33c.08-.26.34-.27.39-.08a4.33,4.33,0,0,1-.48,3.22l-.14.24,1.55.33c0-.08.05-.15.08-.21.26-.55.5-.92.47-1.09a.62.62,0,0,1,.17.65,2.14,2.14,0,0,1,.53-.88,1.15,1.15,0,0,0,.43-.94c.23,0,.47,1.15-.06,2.63a.9.9,0,0,1,.47-.41v.06c.54-.85,1-1.42.93-1.78a1.75,1.75,0,0,1,.26,1.72,4.31,4.31,0,0,1,1.43-1.91,2.56,2.56,0,0,0,1.22-2.09c.38.08.65,1.7.16,3.87a1.17,1.17,0,0,1,.48-.19,1.25,1.25,0,0,0,1-1.06c.18.16.17,1-.15,2a10.11,10.11,0,0,0,.9-.53,3.47,3.47,0,0,0,1.63-2.42c.08-.27.35-.29.41-.09a4.48,4.48,0,0,1-.46,3.32,6.81,6.81,0,0,1-.89,1.36l.3.07c.2-.13.39-.2.59-.35a2.2,2.2,0,0,0,1-1.52c.05-.17.22-.18.26-.06a2.82,2.82,0,0,1-.28,2.08l-.12.21c7.89,1.95,13.9,3.83,20.3,5.93Zm-45.67-11.66,0-.33a3.19,3.19,0,0,1-.43.46l.21,0Z"
          fill="#8ac72f"
        />
        <path
          d="M1249,360.37a84.11,84.11,0,0,0-17.39-3.16,115.28,115.28,0,0,0-18,.13c-12.09,1-24.19,3.61-36.39,6.48l-5.6.81,2.6-.88a.45.45,0,0,0-.49,0,2.27,2.27,0,0,1-.43-1.16c0-.47.14-.81,0-.91a.45.45,0,0,1,.44.36,1.32,1.32,0,0,1,.18-.81c.13-.19.28-.6.06-.8.22-.09.94.58,1,1.78a.8.8,0,0,1,.31-.46l0,0c.2-.79.4-1.34.23-1.56a1.18,1.18,0,0,1,1,1,3,3,0,0,1,.69-1.85c.38-.41.88-1.34.42-1.9.42-.1,1.34.88,1.7,2.53a1.48,1.48,0,0,1,.41-.32c.34-.17.86-.65.67-1.13.24,0,.56.6.63,1.42a7.93,7.93,0,0,0,.71-.71,2.3,2.3,0,0,0,.74-2.27.25.25,0,0,1,.38-.22,2.31,2.31,0,0,1,.51.58,1,1,0,0,1,.87.75,2.57,2.57,0,0,1,.39-1.63c.27-.39.59-1.23.15-1.63.47-.19,1.91,1.2,2,3.65a1.61,1.61,0,0,1,.66-.93l0,.09c.45-1.59.88-2.7.55-3.17a2.36,2.36,0,0,1,1.89,2.16,6,6,0,0,1,1.55-3.72c.8-.8,1.91-2.65,1-3.83.88-.17,2.69,1.9,3.27,5.29a2.87,2.87,0,0,1,.87-.61c.7-.31,1.83-1.22,1.49-2.22.49.1,1.07,1.28,1.12,3,.51-.47,1.06-.84,1.54-1.35,2-2.07,1.92-2.71,1.86-4.52a.53.53,0,0,1,.84-.38,4.86,4.86,0,0,1,1.24,5,9.41,9.41,0,0,1-1,2.59l.66-.11,0,0c.35-.33.73-.56,1.06-.9,1.23-1.26,1.22-1.67,1.2-2.81a.32.32,0,0,1,.52-.23,3.1,3.1,0,0,1,.72,3.18l-.08.28,2.25-.28a.83.83,0,0,1,0-.22c.12-.61.3-1,.19-1.19a.6.6,0,0,1,.51.54,1.69,1.69,0,0,1,.37-1c.2-.23.47-.74.23-1,.31-.08,1.12.93,1,2.51a1.08,1.08,0,0,1,.49-.55v.06c.41-1,.77-1.67.6-2a1.56,1.56,0,0,1,1,1.55,4,4,0,0,1,1.29-2.26c.58-.44,1.45-1.53,1-2.36.58,0,1.55,1.44,1.62,3.66a1.85,1.85,0,0,1,.61-.31c.47-.13,1.27-.61,1.14-1.28.3.1.57.91.45,2,.37-.26.75-.46,1.1-.74,1.42-1.13,1.46-1.56,1.58-2.72a.33.33,0,0,1,.56-.17,3.14,3.14,0,0,1,.34,3.33,5.86,5.86,0,0,1-.85,1.53h.44c.24-.17.49-.28.72-.46a1.92,1.92,0,0,0,1-1.69.21.21,0,0,1,.35-.1,2,2,0,0,1,.17,2.1l-.1.23a74,74,0,0,1,15.43,2.26,63.62,63.62,0,0,1,12.89,4.84l-2.56-.65Zm-65.47.21a3,3,0,0,1-.12-.32,3.72,3.72,0,0,1-.32.63l.3-.09A.9.9,0,0,1,1183.5,360.58Z"
          fill="#8ac72f"
        />
        <path
          d="M1286.11,357.4l-16.26.69-8.13.34a25.1,25.1,0,0,0-3.27.3,11,11,0,0,0-1.14.29,4,4,0,0,0-.61.29,3.51,3.51,0,0,0-.61-.13,1,1,0,0,1-.06-.31c-.09-.07-.13-.09-.09,0s-.59-.51-.91-.83-.5-.57-.6-.64c.06,0,.23.1.37.26a2.78,2.78,0,0,1-.45-.6,2,2,0,0,0-.46-.61c0-.08.68.44,1.39,1.39a1.52,1.52,0,0,1-.18-.35l0,0a11.48,11.48,0,0,0-.76-1.26,2.15,2.15,0,0,1,.87.89,3.71,3.71,0,0,1-.58-1.57,3.46,3.46,0,0,0-.54-1.7c.19-.09.94.84,1.6,2.39a.43.43,0,0,1,.06-.26,1.28,1.28,0,0,0,0-1,3.7,3.7,0,0,1,.61,1.4c0-.21.08-.37.11-.6a4.75,4.75,0,0,0-.13-2.1c0-.21.06-.29.14-.17a3.26,3.26,0,0,1,.31.62c.16,0,.4.4.48.82a3.93,3.93,0,0,1,0-1.53,2.79,2.79,0,0,0-.08-1.58c.23-.12,1,1.45,1.14,3.85a1.37,1.37,0,0,1,.21-.81V355a12.52,12.52,0,0,0,.12-3,3.42,3.42,0,0,1,.87,2.43,7.63,7.63,0,0,1,.71-3.41,5.34,5.34,0,0,0,.59-3.6c.44,0,1.09,2.31,1.23,5.74a1.2,1.2,0,0,1,.4-.45,2.15,2.15,0,0,0,.7-2,6.75,6.75,0,0,1,.4,3.1c.23-.39.48-.68.7-1.12a7.36,7.36,0,0,0,.9-4.23c0-.43.25-.55.36-.27a10.63,10.63,0,0,1,.44,5.14,15.21,15.21,0,0,1-.5,2.45l.29,0v0c.16-.28.33-.47.48-.77a4.53,4.53,0,0,0,.56-2.65c0-.27.16-.35.23-.17a6.62,6.62,0,0,1,.28,3.23l0,.27,1-.06v-.23a6.27,6.27,0,0,0,.09-1.16.72.72,0,0,1,.22.58,2.83,2.83,0,0,1,.16-1,1.68,1.68,0,0,0,.1-1c.13-.06.49,1,.42,2.56a1.08,1.08,0,0,1,.21-.51v.06a7.15,7.15,0,0,0,.25-1.95,2.34,2.34,0,0,1,.46,1.61,5.76,5.76,0,0,1,.53-2.19,3.53,3.53,0,0,0,.38-2.32c.24,0,.69,1.49.77,3.71a.84.84,0,0,1,.26-.29,1.41,1.41,0,0,0,.46-1.27,4.47,4.47,0,0,1,.25,2,7.38,7.38,0,0,0,.46-.72,4.77,4.77,0,0,0,.58-2.74c0-.28.16-.35.23-.18a6.79,6.79,0,0,1,.29,3.33,10.78,10.78,0,0,1-.31,1.53h.19c.1-.18.21-.3.3-.48a3,3,0,0,0,.36-1.72c0-.17.11-.23.15-.11a4.22,4.22,0,0,1,.18,2.09l0,.23a81.78,81.78,0,0,1,13.3,1.38Zm-28.76-.21-.1-.32c0,.21,0,.4,0,.56l.08,0A1.27,1.27,0,0,1,1257.35,357.19Z"
          fill="#8ac72f"
        />
        <g>
          <path
            d="M1143.39,288.34c-1.44,1.06-4.32,1.91-5.52,1.24s-.29-2.62,1.15-3.68a3.53,3.53,0,0,1,4.07-.16C1144.29,286.42,1144.83,287.28,1143.39,288.34Z"
            fill="#e8f5fa"
          />
          <path
            d="M1143,292.57c-2.17-.19-4.87-1.26-4.65-2.28s3.25-1.59,5.42-1.4,2.66,1.06,2.45,2.08S1145.17,292.75,1143,292.57Z"
            fill="#e8f5fa"
          />
          <path
            d="M1136.88,294.08c-.78-1.31-.61-3.34.89-3.71s3.74,1.07,4.52,2.38-.19,2-1.68,2.37S1137.67,295.39,1136.88,294.08Z"
            fill="#e8f5fa"
          />
          <path
            d="M1132.63,290c1.94-.65,5.11-.76,5.84.15s-1.23,2.5-3.18,3.15-3.13.1-3.87-.81S1130.68,290.62,1132.63,290Z"
            fill="#e8f5fa"
          />
          <path
            d="M1136.5,286.4c1.8.8,3.41,2.55,2.49,3.39s-4,.45-5.82-.36-1.59-1.73-.67-2.57A3.39,3.39,0,0,1,1136.5,286.4Z"
            fill="#e8f5fa"
          />
          <ellipse cx="1138.2" cy="289.89" rx="2.32" ry="1.49" fill="#e9ac38" />
        </g>
        <g>
          <path
            d="M1196.61,255.08c-1.44,1.06-4.32,1.91-5.52,1.24s-.29-2.62,1.15-3.68a3.53,3.53,0,0,1,4.07-.16C1197.51,253.15,1198.05,254,1196.61,255.08Z"
            fill="#e8f5fa"
          />
          <path
            d="M1196.21,259.3c-2.17-.18-4.87-1.25-4.65-2.27s3.25-1.59,5.42-1.41,2.66,1.07,2.45,2.09S1198.39,259.49,1196.21,259.3Z"
            fill="#e8f5fa"
          />
          <path
            d="M1190.1,260.82c-.78-1.32-.61-3.34.89-3.71s3.74,1.07,4.52,2.38-.19,2-1.68,2.37S1190.89,262.13,1190.1,260.82Z"
            fill="#e8f5fa"
          />
          <path
            d="M1185.85,256.71c1.94-.65,5.11-.76,5.84.15s-1.23,2.5-3.18,3.14-3.13.11-3.87-.8S1183.9,257.35,1185.85,256.71Z"
            fill="#e8f5fa"
          />
          <path
            d="M1189.72,253.13c1.8.81,3.41,2.56,2.49,3.4s-4,.45-5.82-.36-1.59-1.74-.67-2.57A3.39,3.39,0,0,1,1189.72,253.13Z"
            fill="#e8f5fa"
          />
          <ellipse
            cx="1191.42"
            cy="256.63"
            rx="2.32"
            ry="1.49"
            fill="#e9ac38"
          />
        </g>
        <g>
          <path
            d="M1149.92,188.6c-2.19,1.39-6.59,2.51-8.43,1.62s-.43-3.43,1.77-4.82a6.07,6.07,0,0,1,6.2-.21C1151.3,186.07,1152.12,187.21,1149.92,188.6Z"
            fill="#e8f5fa"
          />
          <path
            d="M1149.32,194.14c-3.32-.24-7.43-1.65-7.11-3s5-2.09,8.28-1.85,4.06,1.4,3.73,2.74S1152.63,194.39,1149.32,194.14Z"
            fill="#e8f5fa"
          />
          <path
            d="M1140,196.13c-1.19-1.73-.92-4.39,1.36-4.87s5.7,1.4,6.9,3.12-.29,2.64-2.57,3.12S1141.19,197.85,1140,196.13Z"
            fill="#e8f5fa"
          />
          <path
            d="M1133.5,190.73c3-.84,7.8-1,8.92.2s-1.88,3.28-4.85,4.13-4.79.14-5.91-1.06S1130.53,191.58,1133.5,190.73Z"
            fill="#e8f5fa"
          />
          <path
            d="M1139.42,186c2.73,1.06,5.2,3.36,3.79,4.46s-6.15.59-8.88-.48-2.43-2.27-1-3.37S1136.68,185,1139.42,186Z"
            fill="#e8f5fa"
          />
          <ellipse cx="1142" cy="190.63" rx="3.54" ry="1.95" fill="#e9ac38" />
        </g>
        <g>
          <path
            d="M1251.61,196.2c-2.2,1.39-6.59,2.51-8.43,1.62s-.43-3.43,1.77-4.82a6.07,6.07,0,0,1,6.2-.21C1253,193.67,1253.81,194.81,1251.61,196.2Z"
            fill="#e8f5fa"
          />
          <path
            d="M1251,201.74c-3.31-.24-7.43-1.64-7.1-3s5-2.09,8.27-1.84,4.06,1.4,3.74,2.73S1254.32,202,1251,201.74Z"
            fill="#e8f5fa"
          />
          <path
            d="M1241.68,203.73c-1.2-1.72-.93-4.38,1.35-4.87s5.71,1.4,6.91,3.13-.29,2.63-2.57,3.11S1242.88,205.45,1241.68,203.73Z"
            fill="#e8f5fa"
          />
          <path
            d="M1235.19,198.34c3-.85,7.8-1,8.92.19s-1.89,3.29-4.86,4.13-4.78.14-5.9-1S1232.22,199.19,1235.19,198.34Z"
            fill="#e8f5fa"
          />
          <path
            d="M1241.1,193.64c2.74,1.07,5.21,3.36,3.8,4.46s-6.15.59-8.89-.47-2.42-2.28-1-3.38S1238.37,192.58,1241.1,193.64Z"
            fill="#e8f5fa"
          />
          <ellipse
            cx="1243.69"
            cy="198.24"
            rx="3.54"
            ry="1.95"
            fill="#e9ac38"
          />
        </g>
        <g>
          <path
            d="M1239.37,270c-1.66,1.05-5,1.89-6.37,1.22s-.32-2.59,1.34-3.64a4.59,4.59,0,0,1,4.68-.16C1240.41,268.08,1241,268.94,1239.37,270Z"
            fill="#e8f5fa"
          />
          <path
            d="M1238.91,274.18c-2.5-.19-5.61-1.25-5.36-2.26s3.74-1.58,6.25-1.39,3.07,1.05,2.82,2.06S1241.42,274.36,1238.91,274.18Z"
            fill="#e8f5fa"
          />
          <path
            d="M1231.87,275.68c-.9-1.31-.7-3.32,1-3.68s4.31,1.06,5.22,2.36-.22,2-1.94,2.35S1232.78,277,1231.87,275.68Z"
            fill="#e8f5fa"
          />
          <path
            d="M1227,271.6c2.25-.64,5.9-.75,6.75.15s-1.43,2.48-3.67,3.12-3.62.1-4.46-.8S1224.72,272.24,1227,271.6Z"
            fill="#e8f5fa"
          />
          <path
            d="M1231.43,268.05c2.07.81,3.94,2.54,2.87,3.37s-4.64.45-6.71-.36-1.83-1.72-.77-2.55A4.41,4.41,0,0,1,1231.43,268.05Z"
            fill="#e8f5fa"
          />
          <ellipse
            cx="1233.39"
            cy="271.52"
            rx="2.68"
            ry="1.48"
            fill="#e9ac38"
          />
        </g>
      </g>
    </g>
  );
};

export default Decor1;
